/* l25-snuggle-embed.js — dựng 2026-09-27T09:34:58.207Z từ snuggle-panel-embed.js + l25-doodle/doodle-ve.js (shopify-mcp/_hk-l25-doodle.mjs). */
/* Sinh bởi scripts/build-snuggle-embed.mjs - ĐỪNG SỬA TAY.
   Nối từ app/snuggle-tones.mjs, app/snuggle-palette.mjs, app/snuggle-text.mjs, app/snuggle-spec.mjs, app/snuggle-render.mjs, app/blanket-mockup.mjs, app/snuggle-ai.mjs, app/snuggle-anh.mjs, app/snuggle-embed.mjs của POD Studio. */
(function () {
"use strict";
// ── app/snuggle-tones.mjs ───────────────────────────────────────
// SINH TỰ ĐỘNG bởi scripts/build-snuggle-tones.mjs - đừng sửa tay.
//
// Màu vải đo trực tiếp từ 14 ảnh chăn của nhà cung cấp trong fixture Custom Pet Photo, lấy trung
// vị vùng giữa tấm. Màu chữ suy ra từ độ sáng vải: vải tối thì chữ sáng, và cả hai đều pha từ
// chính màu vải nên nhìn như in trên vải chứ không như dán chữ lên.
const SNUGGLE_TONES = [
  { key: "beige", label: "Beige", dark: false, colours: { paper: "#EAE6DC", ink: "#3F3128", accent: "#988066" } },
  { key: "camel", label: "Camel", dark: false, colours: { paper: "#E0CEA3", ink: "#3E2E22", accent: "#866D4D" } },
  { key: "grey", label: "Grey", dark: false, colours: { paper: "#929292", ink: "#352720", accent: "#534435" } },
  { key: "orange", label: "Orange", dark: false, colours: { paper: "#C85113", ink: "#060302", accent: "#402715" } },
  { key: "pink", label: "Pink", dark: false, colours: { paper: "#EBA8B5", ink: "#3F2924", accent: "#7A5849" } },
  { key: "white", label: "White", dark: false, colours: { paper: "#EBEBEB", ink: "#3F312A", accent: "#98816A" } },
  { key: "black", label: "Black", dark: true, colours: { paper: "#141414", ink: "#E3E3E3", accent: "#BDA887" } },
  { key: "blue", label: "Blue", dark: true, colours: { paper: "#3E5EAA", ink: "#E8ECF5", accent: "#C9BDB1" } },
  { key: "brown", label: "Brown", dark: true, colours: { paper: "#843F23", ink: "#F0E8E5", accent: "#DDB48B" } },
  { key: "green", label: "Green", dark: true, colours: { paper: "#126434", ink: "#E3ECE7", accent: "#BDBF90" } },
  { key: "navy", label: "Navy", dark: true, colours: { paper: "#14253F", ink: "#E3E5E8", accent: "#BDAD93" } },
  { key: "plum", label: "Plum", dark: true, colours: { paper: "#50314C", ink: "#EAE6EA", accent: "#CEB097" } },
  { key: "red", label: "Red", dark: true, colours: { paper: "#891213", ink: "#F1E3E3", accent: "#DEA887" } },
  { key: "teal", label: "Teal", dark: true, colours: { paper: "#127877", ink: "#E4F0F0", accent: "#C0C7A8" } },
];

// ── app/snuggle-palette.mjs ─────────────────────────────────────
// Bảng tông vải của Snuggle Blanket.
//
// Element trong spec KHÔNG ghi mã màu cứng mà ghi khoá màu (paper/ink/accent). Bảng này
// phân giải khoá đó theo tông đang chọn, nên đổi tông là chữ tự đổi theo - không phải sửa
// từng element, và layout nền ảnh chỉ cần một bảng khoá khác.

// 14 tông vải đúng bằng bộ màu nhà cung cấp bán, đo thẳng từ ảnh chăn thật của họ. Màu chữ do
// script chọn theo độ tương phản đo được, không phải theo cảm tính - xem build-snuggle-tones.mjs.

/** Layout nền ảnh (trời đêm, gỗ + đèn) không cho đổi tông; chữ trắng cố định. */
const DARK_PALETTE = {
  key: "photo",
  label: "Nền ảnh",
  colours: { paper: "#000000", ink: "#FFFFFF", accent: "#F3E2C7" },
};

/** Ba cỡ chăn nhà cung cấp bán, giống nhau ở cả hai chất liệu (đối chiếu trang sản phẩm thật).
 *
 *  `widthMm` là bề ngang tờ in - nó quyết định ngưỡng cảnh báo nét mảnh: cùng một thiết kế in
 *  ra khổ 30x40 thì mọi nét chỉ còn một nửa bề dày so với khổ 60x80. */
const SNUGGLE_SIZES = [
  { key: "30x40in", label: "30x40in", widthMm: 762 },
  { key: "50x60in", label: "50x60in", widthMm: 1270 },
  { key: "60x80in", label: "60x80in", widthMm: 1524 },
];

function sizeByKey(key) {
  return SNUGGLE_SIZES.find((size) => size.key === key) ?? SNUGGLE_SIZES[SNUGGLE_SIZES.length - 1];
}

function toneByKey(key) {
  return SNUGGLE_TONES.find((tone) => tone.key === key) ?? SNUGGLE_TONES[0];
}

function resolveColour(value, tone) {
  if (typeof value === "string" && value.startsWith("#")) return value;
  const colour = tone?.colours?.[value];
  if (!colour) throw new Error(`khoá màu không hợp lệ: ${value}`);
  return colour;
}

// ── app/snuggle-text.mjs ────────────────────────────────────────
// Dàn chữ cho Snuggle Blanket: ngắt dòng, co cho vừa khung, và cảnh báo nét quá mảnh để in.
//
// Module không tự gọi canvas mà nhận hàm đo bề rộng từ bên ngoài. Nhờ vậy test chạy được
// trong Node với hàm đo giả, còn lúc chạy thật thì truyền vào ctx.measureText.

/** Tỉ lệ giữa bề dày nét MẢNH NHẤT và cỡ chữ, đo một lần cho từng font.
 *  Hai font script có nét cực mảnh - đó là lý do phải có nút chỉnh độ dày. */
const FONT_THIN_RATIO = {
  "Patrick Hand SC": 0.055,
  "Patrick Hand": 0.050,
  "Oswald": 0.060,
  "Allura": 0.012,
  "Italianno": 0.009,
  // Đo bằng cách rasterise "one Snuggle" ở cỡ 400px rồi lấy phân vị 5% của các đoạn mực nằm
  // ngang, quy về cùng thang với các dòng trên (đoạn nằm ngang luôn dài hơn bề dày thật ở nét
  // xiên, nên chữ viết tay phải nhân thêm ~0.5, chữ đứng ~0.6).
  "Yellowtail": 0.028,
  // Girassol là serif in hoa, nét ngang mảnh nhưng vẫn dày hơn chữ viết tay.
  "Girassol": 0.030,
  // MindScribe gần như monoline, nét đều - dày hơn hẳn Allura/Italianno.
  "MindScribe": 0.035,
  // Bitter là slab serif, nét ngang dày - an toàn nhất trong bộ.
  "Bitter": 0.055,
  "Bitter Italic": 0.055,
  // Hai font dưới đo bằng scripts/font-raster.mjs theo đúng cách trên: ra 0.093 và 0.044. Ghi
  // thấp hơn số đo vì phép đo này chỉ thấy đoạn mực NẰM NGANG, mà cả hai font đều gần như không
  // có nét mảnh nên phân vị 5% rơi vào thân nét chứ không vào chỗ mảnh nhất - tức là đo cao lên.
  // Thà cảnh báo thừa còn hơn để lọt một dòng chữ in ra bị sợi fleece nuốt mất.
  "Staatliches": 0.065,
  "Pattaya": 0.038,
  // Playlist Script: brush khô, nét mảnh nhất là chỗ đuôi bút tách sợi.
  "Playlist Script": 0.020,
  // Sailors: sans hình học nét đều, đo trên chính bộ glyph ảnh - nét mảnh nhất chia cỡ chữ.
  // Dày nhất trong bộ, gần như không bao giờ chạm ngưỡng in.
  "Sailors": 0.090,
};

/** Dưới mức này thì sợi vải fleece nuốt mất nét hoặc làm đứt quãng. */
const MIN_STROKE_MM = 0.8;

function wrapLines(text, { size, maxWidth, measure }) {
  const words = String(text).split(/\s+/).filter(Boolean);
  if (!words.length) return [];
  const lines = [];
  let current = words[0];
  for (const word of words.slice(1)) {
    const candidate = `${current} ${word}`;
    if (measure(candidate, size) <= maxWidth) current = candidate;
    else { lines.push(current); current = word; }
  }
  lines.push(current);
  return lines;
}

/** Co cỡ chữ dần cho vừa chiều cao. Co quá minRatio thì thà báo tràn còn hơn vẽ đè lên lớp khác. */
function fitLines(lines, { size, leading, maxHeight, minRatio = 0.75 }) {
  const heightAt = (value) => lines.length * value * leading;
  if (heightAt(size) <= maxHeight) return { size, lines, overflow: false };
  const needed = maxHeight / (lines.length * leading);
  if (needed >= size * minRatio) return { size: needed, lines, overflow: false };
  return { size: size * minRatio, lines, overflow: true };
}

/** `size` là tỉ lệ khung, `stroke` là PIXEL của khung thiết kế - quy cả hai về khổ in rồi ra mm. */
function strokeWidthMm(element, { printWidthPx, printWidthMm, designWidthPx }) {
  const ratio = FONT_THIN_RATIO[element.font] ?? 0.05;
  const strokePx = (element.stroke ?? 0) * (printWidthPx / designWidthPx);
  const thinPx = element.size * printWidthPx * ratio + strokePx;
  return thinPx * (printWidthMm / printWidthPx);
}

/** Trả về câu cảnh báo, hoặc null nếu nét đủ dày. */
function printWarning(element, print) {
  const mm = strokeWidthMm(element, print);
  if (mm >= MIN_STROKE_MM) return null;
  return `${element.id}: nét mảnh nhất chỉ ${mm.toFixed(2)}mm, dưới ngưỡng in ${MIN_STROKE_MM}mm — tăng độ dày nét hoặc cỡ chữ`;
}

/** Co chữ cho vừa bề ngang chỗ dành cho nó. Trả về HỆ SỐ co, không trả về cỡ chữ mới.
 *
 *  Vì sao co bằng hệ số: co bằng cách hạ cỡ chữ thì chữ vẫn neo mép trên, dòng ngắn lại là nó
 *  trôi lên, nhìn như bị lệch. Nhân hệ số quanh tâm hộp thì chữ nhỏ lại đúng tại chỗ cũ, và nét
 *  viền, tracking, giãn dòng cũng nhỏ theo cùng một nhịp - không phải chỉnh từng thứ.
 *
 *  Co quá minScale thì thà báo tràn: nhỏ hơn nữa là in ra không đọc được, người vận hành cần
 *  biết để bảo khách rút ngắn chữ. */
function fitWidth(lines, { size, maxWidth, measure, minScale = 0.3 }) {
  if (!(maxWidth > 0)) return { scale: 1, overflow: false };
  const widest = Math.max(0, ...lines.map((line) => measure(line, size)));
  if (widest <= maxWidth) return { scale: 1, overflow: false };
  const scale = maxWidth / widest;
  if (scale >= minScale) return { scale, overflow: false };
  return { scale: minScale, overflow: true };
}

// ── app/snuggle-spec.mjs ────────────────────────────────────────
// Đọc và kiểm spec layout của Snuggle Blanket.
//
// Toạ độ trong spec là do người dựng ĐOÁN TỪ ẢNH CHỤP rồi kéo chỉnh dần trong Studio, nên
// hàm kiểm ở đây là lưới an toàn: nó chặn spec vô nghĩa trước khi bộ vẽ gặp phải.

const SNUGGLE_ELEMENT_TYPES = ["background", "text", "photo_slot", "art"];

/** Phải khớp đúng số font đã tải về public/snuggle-fonts. Dùng font ngoài danh sách là chữ
 *  sẽ rơi về font hệ thống lúc chạy thật mà không ai biết. */
/** Font chỉ có trong Canva, không mua/tải được file - dựng thành BỘ GLYPH ẢNH.
 *
 *  Tách khỏi danh mục font phía dưới vì hai thứ khác hẳn nhau: font ở đó phải có file .ttf trong
 *  kho và có @font-face; bộ glyph thì là một tấm ảnh kèm bảng toạ độ, trình duyệt không biết nó
 *  là font. Gộp chung một danh mục là phép kiểm "đủ file font" báo thiếu oan. */
const SNUGGLE_GLYPH_SETS = ["Sailors", "L11 Hand", "L12 Serif", "L12 Serif Bold", "L12 Ornate", "L13 Serif", "L13 Script", "L14 Serif", "L15 Caps", "L15 Script", "L16 Bold", "L16 Script", "L17 Serif", "L17 Script", "L18 Script", "L19 Brush", "L19 Block", "L19 Script", "L20 Script", "L20 Serif", "L20 Serif Bold", "L21 Script outline", "L21 Script fill", "L21 Yearbook outline", "L21 Yearbook fill", "L22 Name", "L23 Script", "L23 Script Fill"];

const SNUGGLE_FONT_NAMES = ["Patrick Hand SC", "Patrick Hand", "Allura", "Italianno", "Oswald", "Yellowtail", "Girassol", "MindScribe", "Bitter", "Bitter Italic", "Staatliches", "Pattaya", "Playlist Script"];

/** Bộ lọc màu cho ảnh của khách. Mỗi cái là một chuỗi filter của canvas, áp đúng lúc vẽ ảnh nên
 *  không đụng gì tới khung tim hay chữ chung quanh.
 *
 *  Là LỰA CHỌN CỦA KHÁCH chứ không phải thuộc tính của layout, nên nó đi trong `edits` của ô ảnh
 *  giống pan/zoom, và trên Shopify thì theo đơn hàng dưới dạng line item property. Nhờ vậy người
 *  dựng file in về sau vẫn tô đúng bộ lọc khách chọn, kể cả khi trình duyệt của khách không vẽ
 *  được `ctx.filter`. */
const SNUGGLE_PHOTO_FILTERS = [
  { key: "none", label: "Ảnh gốc", en: "Original", css: "none" },
  { key: "bw", label: "Trắng đen", en: "Black & white", css: "grayscale(1)" },
  { key: "sepia", label: "Nâu cổ", en: "Sepia", css: "sepia(0.55) contrast(1.03)" },
  { key: "warm", label: "Ấm", en: "Warm", css: "saturate(1.18) sepia(0.16)" },
  { key: "cool", label: "Lạnh", en: "Cool", css: "saturate(1.08) hue-rotate(-12deg) brightness(1.02)" },
  { key: "soft", label: "Dịu", en: "Soft", css: "contrast(0.9) brightness(1.07) saturate(0.88)" },
];

function photoFilterCss(key) {
  return SNUGGLE_PHOTO_FILTERS.find((item) => item.key === key)?.css ?? "none";
}

/** Chuỗi filter CSS → một phép affine màu {m: 3×3, b: 3} (đơn vị 0..1), theo ma trận của đặc tả
 *  Filter Effects. Dùng khi trình duyệt không có `ctx.filter` (Safari): gán thuộc tính ấy xong không
 *  có gì xảy ra, ảnh khách chọn "Trắng đen" vẫn ra màu - lỗi lặng lẽ khách báo "photo tone không
 *  hoạt động". Chỉ hiểu các hàm SNUGGLE_PHOTO_FILTERS dùng; gặp hàm lạ thì ném lỗi. */
function filterMatrix(css) {
  let m = [1, 0, 0, 0, 1, 0, 0, 0, 1], b = [0, 0, 0];
  if (!css || css === "none") return { m, b };
  const nhan = (a, c) => [0, 1, 2].flatMap((i) => [0, 1, 2].map((j) => a[i * 3] * c[j] + a[i * 3 + 1] * c[3 + j] + a[i * 3 + 2] * c[6 + j]));
  for (const [, ten, doi] of css.matchAll(/([a-z-]+)\(([^)]*)\)/g)) {
    const v = parseFloat(doi);
    let n, nb = [0, 0, 0];
    if (ten === "grayscale" || ten === "sepia" || ten === "saturate") {
      const s = ten === "saturate" ? v : 1 - Math.min(1, v);
      n = ten === "sepia"
        ? [0.393 + 0.607 * s, 0.769 - 0.769 * s, 0.189 - 0.189 * s, 0.349 - 0.349 * s, 0.686 + 0.314 * s, 0.168 - 0.168 * s, 0.272 - 0.272 * s, 0.534 - 0.534 * s, 0.131 + 0.869 * s]
        : ten === "grayscale"
          ? [0.2126 + 0.7874 * s, 0.7152 - 0.7152 * s, 0.0722 - 0.0722 * s, 0.2126 - 0.2126 * s, 0.7152 + 0.2848 * s, 0.0722 - 0.0722 * s, 0.2126 - 0.2126 * s, 0.7152 - 0.7152 * s, 0.0722 + 0.9278 * s]
          : [0.213 + 0.787 * s, 0.715 - 0.715 * s, 0.072 - 0.072 * s, 0.213 - 0.213 * s, 0.715 + 0.285 * s, 0.072 - 0.072 * s, 0.213 - 0.213 * s, 0.715 - 0.715 * s, 0.072 + 0.928 * s];
    } else if (ten === "hue-rotate") {
      const r = (v * Math.PI) / 180, c = Math.cos(r), s = Math.sin(r);
      n = [0.213 + c * 0.787 - s * 0.213, 0.715 - c * 0.715 - s * 0.715, 0.072 - c * 0.072 + s * 0.928,
        0.213 - c * 0.213 + s * 0.143, 0.715 + c * 0.285 + s * 0.140, 0.072 - c * 0.072 - s * 0.283,
        0.213 - c * 0.213 - s * 0.787, 0.715 - c * 0.715 + s * 0.715, 0.072 + c * 0.928 + s * 0.072];
    } else if (ten === "brightness") {
      n = [v, 0, 0, 0, v, 0, 0, 0, v];
    } else if (ten === "contrast") {
      n = [v, 0, 0, 0, v, 0, 0, 0, v];
      nb = [0.5 - 0.5 * v, 0.5 - 0.5 * v, 0.5 - 0.5 * v];
    } else {
      throw new Error(`bộ lọc "${ten}" chưa có ma trận điểm ảnh`);
    }
    // Áp phép mới SAU phép cũ: m' = n·m, b' = n·b + nb.
    b = [0, 1, 2].map((i) => n[i * 3] * b[0] + n[i * 3 + 1] * b[1] + n[i * 3 + 2] * b[2] + nb[i]);
    m = nhan(n, m);
  }
  return { m, b };
}

/** Áp bộ lọc lên mảng RGBA tại chỗ (alpha giữ nguyên). */
function applyFilterPixels(data, css) {
  if (!css || css === "none") return;
  const { m, b } = filterMatrix(css);
  const b0 = b[0] * 255, b1 = b[1] * 255, b2 = b[2] * 255;
  for (let i = 0; i < data.length; i += 4) {
    const r = data[i], g = data[i + 1], bl = data[i + 2];
    data[i] = m[0] * r + m[1] * g + m[2] * bl + b0;
    data[i + 1] = m[3] * r + m[4] * g + m[5] * bl + b1;
    data[i + 2] = m[6] * r + m[7] * g + m[8] * bl + b2;
  }
}

/** Font nào có nhiều nét đậm dùng được. Oswald tải về là bản variable 200-700 nên `weight` mới
 *  có tác dụng; các font kia một nét duy nhất, khai weight cho chúng là khai suông. */
const SNUGGLE_FONT_WEIGHTS = { Oswald: [500, 600], Bitter: [400, 500, 600, 700, 800], "Bitter Italic": [400, 500, 600, 700, 800] };

/** Bán kính cung nhỏ nhất còn cho phép, đo theo chiều rộng khung thiết kế. */
const MIN_ARC = 0.2;

// Trần giãn dòng. Yêu cầu ban đầu là "giãn nhẹ" và 1.6 đủ cho layout 1 (thơ mười dòng ngắn),
// nhưng layout 5 đo trên ảnh mẫu ra 1.95: ba dòng dài, chữ hoa nhỏ, cố tình để thoáng. Trần
// nới lên 2.0 - vẫn là trần thật, chặn được số vô nghĩa, chỉ không còn chặn nhầm bản thiết kế.
const MAX_LEADING = 2.0;
const MIN_LEADING = 0.9;

function boxToPixels(box, [width, height]) {
  return { x: box.x * width, y: box.y * height, w: box.w * width, h: box.h * height };
}

/** size, tracking, radius đo theo CHIỀU RỘNG khung - một quy ước, không ngoại lệ.
 *  Riêng `stroke` là pixel khung thiết kế, không đi qua hàm này. */
function scaleToPixels(value, [width]) {
  return value * width;
}

function validateSpec(spec) {
  const errors = [];
  if (spec?.schema !== 1) errors.push(`schema phải là 1, đang là ${spec?.schema}`);
  if (!Array.isArray(spec?.design_size) || spec.design_size.length !== 2) errors.push("design_size phải là [rộng, cao]");
  if (!Array.isArray(spec?.elements) || spec.elements.length === 0) errors.push("spec không có element nào");
  if (errors.length) return errors;

  const seen = new Set();
  for (const element of spec.elements) {
    const at = element.id ?? "(thiếu id)";
    if (!element.id) errors.push("có element thiếu id");
    else if (seen.has(element.id)) errors.push(`id trùng nhau: ${element.id}`);
    seen.add(element.id);
    // `group` gom các lớp đi cùng nhau (cụm tiêu đề, cụm chữ ký) để editor kéo nguyên khối.
    // Đánh máy sai tên nhóm thì lớp đó lặng lẽ tách khỏi cụm, kéo xong mới thấy lệch.
    if (element.group !== undefined && typeof element.group !== "string") {
      errors.push(`${at}: group phải là chuỗi, đang là ${typeof element.group}`);
    }

    if (!SNUGGLE_ELEMENT_TYPES.includes(element.type)) {
      errors.push(`${at}: loại element không hợp lệ: ${element.type}`);
      continue;
    }
    if (element.type === "background") continue;

    const box = element.box;
    if (!box || ["x", "y", "w", "h"].some((key) => typeof box[key] !== "number")) {
      errors.push(`${at}: thiếu box đầy đủ x/y/w/h`);
      continue;
    }
    if (box.w <= 0 || box.h <= 0) errors.push(`${at}: box có cạnh bằng 0 hoặc âm`);
    if (box.x < 0 || box.y < 0 || box.x + box.w > 1 || box.y + box.h > 1) {
      errors.push(`${at}: box tràn ra ngoài khung thiết kế`);
    }

    // Ô ảnh KHOÁ vào một lớp khác: hộp của nó không phải số độc lập mà suy ra từ hộp lớp chủ.
    // Ô ảnh cắt theo hình luôn đi kèm một khung trang trí vẽ đè lên; để hai hộp rời nhau thì kéo
    // hoặc phóng một cái là cửa sổ rời khỏi viền, lộ ra mảng ảnh nằm ngoài - đúng lỗi đã gặp hai
    // lần ở Layout 8.
    // `locked` không có lớp chủ: khung trang trí nằm trong ẢNH NỀN chứ không phải một lớp, nên
    // không khoá theo cái gì được, nhưng hộp vẫn phải cứng - kéo rời là cửa sổ ảnh trượt khỏi
    // viền y hệt trường hợp có lớp chủ.
    if (element.locked !== undefined && typeof element.locked !== "boolean") {
      errors.push(`${at}: locked phải là true/false`);
    }
    if (element.locked && element.locked_to) {
      errors.push(`${at}: khai cả locked lẫn locked_to - chọn một`);
    }
    if (element.locked_to) {
      const host = spec.elements.find((item) => item.id === element.locked_to.element);
      if (!host) errors.push(`${at}: khoá vào lớp "${element.locked_to.element}" không có`);
      else if (host.box) {
        const rel = element.locked_to.box;
        const want = {
          x: host.box.x + rel.x * host.box.w, y: host.box.y + rel.y * host.box.h,
          w: rel.w * host.box.w, h: rel.h * host.box.h,
        };
        for (const key of ["x", "y", "w", "h"]) {
          if (Math.abs((element.box?.[key] ?? 0) - want[key]) > 0.001) {
            errors.push(`${at}: box.${key} = ${element.box?.[key]} lệch khỏi lớp chủ (phải là ${want[key].toFixed(4)})`);
          }
        }
      }
    }

    // Mặt nạ cắt ô ảnh theo hình bất kỳ. Khai nhầm cho lớp khác thì nó im lặng không có tác dụng.
    if (element.mask !== undefined) {
      if (element.type !== "photo_slot") errors.push(`${at}: chỉ ô ảnh mới dùng được mask`);
      if (typeof element.mask !== "string" || !element.mask.startsWith("/")) {
        errors.push(`${at}: mask phải là đường dẫn tương đối bắt đầu bằng /`);
      }
    }

    if (element.type === "photo_slot") {
      // Dưới 1 là ảnh KHÔNG phủ kín khung nữa - cố tình cho phép, vì nhiều ảnh phải thu nhỏ mới
      // lọt hết chủ thể vào khung. Chỗ hụt để trống, người vận hành nhìn thấy ngay mà quyết.
      const zoom = element.zoom ?? 1;
      if (!(zoom >= 0.4 && zoom <= 4)) errors.push(`${at}: zoom ${zoom} nằm ngoài 0.4–4`);
      for (const key of ["pan_x", "pan_y"]) {
        const value = element[key] ?? 0;
        if (!(value >= -1 && value <= 1)) errors.push(`${at}: ${key} ${value} nằm ngoài -1..1`);
      }
      // Gõ sai tên bộ lọc thì bộ vẽ lặng lẽ vẽ ảnh gốc - đơn hàng ghi "trắng đen" mà in ra ảnh màu.
      if (element.filter !== undefined && !SNUGGLE_PHOTO_FILTERS.some((item) => item.key === element.filter)) {
        errors.push(`${at}: bộ lọc "${element.filter}" không có (${SNUGGLE_PHOTO_FILTERS.map((i) => i.key).join(", ")})`);
      }
    }

    if (element.type === "text") {
      // Chữ vẽ bằng bộ glyph ảnh thì không cần file font, nhưng `glyphs` phải trỏ đúng một bộ đã
      // khai - gõ sai tên là bộ vẽ vẽ ra ô trống mà không ai biết vì sao.
      if (element.glyphs !== undefined) {
        if (!SNUGGLE_GLYPH_SETS.includes(element.glyphs)) {
          errors.push(`${at}: bộ glyph chưa khai: ${element.glyphs}`);
        }
        if (!spec.glyph_sets?.[element.glyphs]) {
          errors.push(`${at}: spec thiếu số đo của bộ glyph "${element.glyphs}"`);
        }
      } else if (!SNUGGLE_FONT_NAMES.includes(element.font)) {
        errors.push(`${at}: font chưa tải về: ${element.font}`);
      }
      // Khai weight cho font một nét thì trình duyệt lặng lẽ bỏ qua: bản thiết kế ghi SemiBold
      // mà in ra Regular, không có gì báo. Chặn ngay ở đây.
      if (element.weight !== undefined) {
        const allowed = SNUGGLE_FONT_WEIGHTS[element.font];
        if (!allowed) errors.push(`${at}: font ${element.font} chỉ có một nét, không khai weight được`);
        else if (!allowed.includes(element.weight)) {
          errors.push(`${at}: weight ${element.weight} không có trong ${element.font} (${allowed.join(", ")})`);
        }
      }
      if (!(element.size > 0)) errors.push(`${at}: size phải dương`);
      // Nghiêng chữ để thay cho font nghiêng không tải về được. Quá 30° là chữ đổ, không còn đọc
      // được ở cỡ in - đó là trần, không phải khoảng thẩm mỹ.
      if (element.slant !== undefined && !(element.slant >= -30 && element.slant <= 30)) {
        errors.push(`${at}: slant ${element.slant} nằm ngoài -30..30 độ`);
      }
      // `arc` là BÁN KÍNH cung, đo theo chiều rộng khung thiết kế như `size` và `tracking`. Dương
      // là tâm nằm dưới chữ (dòng vồng lên hình mái vòm), âm là ngược lại.
      //
      // Chặn bán kính quá nhỏ: dưới 0.2 khung thì một dòng chữ dài quấn hơn nửa vòng tròn, không
      // còn là "chữ bám theo dải ruy-băng" nữa mà là một cái vòng - gần như chắc chắn gõ nhầm số.
      if (element.arc !== undefined) {
        if (typeof element.arc !== "number" || !Number.isFinite(element.arc)) {
          errors.push(`${at}: arc phải là số`);
        } else if (Math.abs(element.arc) < MIN_ARC) {
          errors.push(`${at}: arc ${element.arc} - bán kính dưới ${MIN_ARC} khung thì chữ cuộn thành vòng`);
        }
      }
      const leading = element.leading ?? 1;
      if (leading < MIN_LEADING || leading > MAX_LEADING) {
        errors.push(`${at}: giãn dòng ${leading} nằm ngoài khoảng ${MIN_LEADING}–${MAX_LEADING}`);
      }
      // Bề ngang tối đa dòng chữ được phép chiếm, tính theo tỉ lệ khung. Khai nó là để NỚI ra
      // rộng hơn chữ mặc định; không khai thì bộ vẽ tự lấy đúng bề rộng chữ mặc định làm trần.
      if (element.max_width !== undefined && !(element.max_width > 0 && element.max_width <= 1)) {
        errors.push(`${at}: max_width ${element.max_width} phải nằm trong khoảng 0–1`);
      }
    }
  }

  // Nền ảnh phải trỏ vào một file có thật. Thiếu asset thì bộ vẽ xoá khung rồi không vẽ gì -
  // canvas trong suốt, ra mockup thành mảng trắng trông y như "chưa chọn thiết kế".
  if (spec.background?.kind === "image") {
    const asset = spec.background.asset;
    if (typeof asset !== "string" || !asset.startsWith("/")) {
      errors.push("background nền ảnh phải có asset là đường dẫn tương đối bắt đầu bằng /");
    }
  }

  // Bộ nền cho khách chọn. Mỗi lỗi ở đây đều LẶNG LẼ: sai đường dẫn thì lớp đó không vẽ, trỏ vào
  // element không có thì bản vá rơi vào hư không - cả hai trường hợp bản dựng vẫn ra hình.
  if (spec.background_options !== undefined) {
    if (!Array.isArray(spec.background_options) || !spec.background_options.length) {
      errors.push("background_options phải là mảng có ít nhất một bộ");
    } else {
      const khoa = new Set();
      for (const bo of spec.background_options) {
        const at = `bộ nền "${bo?.key ?? "(thiếu key)"}"`;
        if (!bo?.key) errors.push("có bộ nền thiếu key");
        else if (khoa.has(bo.key)) errors.push(`${at}: key trùng nhau`);
        khoa.add(bo?.key);
        // `label` cho người vận hành đọc, `en` cho khách đọc trên storefront. Thiếu `en` là dòng
        // option ngoài cửa hàng hiện ra chữ tiếng Việt.
        for (const key of ["label", "en"]) {
          if (typeof bo?.[key] !== "string" || !bo[key]) errors.push(`${at}: thiếu ${key}`);
        }
        if (typeof bo?.background !== "string" || !bo.background.startsWith("/")) {
          errors.push(`${at}: background phải là đường dẫn tương đối bắt đầu bằng /`);
        }
        for (const [id, patch] of Object.entries(bo?.patch ?? {})) {
          if (!seen.has(id)) errors.push(`${at}: vá vào lớp "${id}" không có trong spec`);
          if (patch?.asset !== undefined && !String(patch.asset).startsWith("/")) {
            errors.push(`${at}: asset của lớp "${id}" phải bắt đầu bằng /`);
          }
        }
      }
      // Mọi bộ phải vá CÙNG một danh sách lớp. Thiếu một lớp ở một bộ là đổi qua bộ đó xong lớp
      // ấy giữ nguyên giá trị của bộ trước - nền hồng mà hoạ tiết vẫn xanh.
      const chuan = Object.keys(spec.background_options[0]?.patch ?? {}).sort().join(",");
      for (const bo of spec.background_options.slice(1)) {
        const co = Object.keys(bo?.patch ?? {}).sort().join(",");
        if (co !== chuan) errors.push(`bộ nền "${bo?.key}": vá ${co || "(không lớp nào)"} trong khi bộ đầu vá ${chuan}`);
      }
    }
  }

  // Ô nhập của khách. Element trỏ `source: field:x` mà spec không khai field x thì dòng chữ đó
  // thành chữ chết: khách nhìn thấy nó trên chăn nhưng không có ô nào sửa được - đúng lỗi đã
  // dính với cụm tiêu đề. Ngược lại, khai field mà không lớp nào dùng thì Studio mọc ra một ô
  // nhập gõ vào chẳng thấy gì đổi.
  const fields = new Map((spec.fields ?? []).map((field) => [field.id, field]));
  const used = new Set();
  for (const element of spec.elements) {
    if (typeof element.source !== "string" || !element.source.startsWith("field:")) continue;
    const id = element.source.slice(6);
    used.add(id);
    if (!fields.has(id)) errors.push(`${element.id}: trỏ vào field "${id}" mà spec không khai field đó`);
  }
  for (const [id, field] of fields) {
    if (!used.has(id)) errors.push(`field "${id}": không lớp nào dùng`);
    if (typeof field.label !== "string" || !field.label) errors.push(`field "${id}": thiếu label cho ô nhập`);
    if (!(field.max_length > 0)) errors.push(`field "${id}": thiếu max_length`);
    // Studio mồi ô nhập bằng `default`, nên thiếu nó là khách mở lên thấy ô trống và mất luôn
    // dòng chữ mẫu trên chăn. Dài hơn max_length thì gõ một ký tự là bị cắt cụt ngay.
    if (typeof field.default !== "string") errors.push(`field "${id}": thiếu default để mồi ô nhập`);
    else if (field.default.length > (field.max_length ?? 0)) {
      errors.push(`field "${id}": default dài ${field.default.length} ký tự, quá max_length ${field.max_length}`);
    }
  }
  return errors;
}

/** Dời một cụm lớp đi cùng một khoảng, trả về bản vá mới cho từng lớp.
 *
 *  Phải cộng dồn lên hộp ĐÃ VÁ chứ không phải hộp gốc trong spec: kéo lần thứ hai mà lấy hộp
 *  gốc làm mốc là lần kéo trước bị nuốt mất, cụm nhảy về chỗ cũ. */
function moveGroup(elements, edits, ids, dx, dy) {
  const draft = { ...edits };
  for (const id of ids) {
    const element = elements.find((item) => item.id === id);
    if (!element?.box) continue;
    const box = { ...element.box, ...(edits[id]?.box ?? {}) };
    draft[id] = {
      ...edits[id],
      box: { ...box, x: Number((box.x + dx).toFixed(4)), y: Number((box.y + dy).toFixed(4)) },
    };
  }
  return draft;
}

/** Tính lại hộp của mọi lớp đang KHOÁ theo lớp chủ, sau mỗi lần sửa.
 *
 *  Đây là thứ giữ cho cửa sổ ảnh hình tim luôn nằm đúng trong viền: người vận hành kéo hay phóng
 *  cái khung, ô ảnh tự đi theo. Thiếu nó thì hai hộp trôi khỏi nhau và ảnh thò ra ngoài viền. */
function syncLockedBoxes(elements, edits) {
  const draft = { ...edits };
  const boxOf = (element) => ({ ...element.box, ...(draft[element.id]?.box ?? {}) });
  for (const element of elements) {
    if (!element.locked_to?.box) continue;
    const host = elements.find((item) => item.id === element.locked_to.element);
    if (!host?.box) continue;
    const hostBox = boxOf(host);
    const rel = element.locked_to.box;
    const round = (value) => Number(value.toFixed(4));
    draft[element.id] = {
      ...draft[element.id],
      box: {
        ...boxOf(element),
        x: round(hostBox.x + rel.x * hostBox.w),
        y: round(hostBox.y + rel.y * hostBox.h),
        w: round(rel.w * hostBox.w),
        h: round(rel.h * hostBox.h),
      },
    };
  }
  return draft;
}

/** Bộ nền mà khách đang chọn, hoặc `null` nếu layout này không có option nền.
 *
 *  Một lựa chọn nền KHÔNG chỉ là một ảnh nền: nó đổi cả lớp hoạ tiết và màu mấy dòng chữ nhấn.
 *  Đổi mỗi ảnh nền mà giữ nguyên viền với chữ màu cũ thì bộ nào cũng chỏi tông - nên `patch` gom
 *  đủ mọi thứ phải đổi theo, và bộ vẽ đắp nó lên element TRƯỚC khi đắp bản sửa của người vận hành.
 *
 *  Chọn nhầm khoá thì rơi về bộ đầu tiên chứ không vẽ trống: khách đổi nền mà tấm chăn biến mất
 *  là lỗi nặng hơn nhiều so với hiện sai một bộ màu. */
function boNen(spec, state) {
  const ds = spec?.background_options;
  if (!Array.isArray(ds) || !ds.length) return null;
  return ds.find((bo) => bo.key === state?.background) ?? ds[0];
}

/** Mọi asset mà các bộ nền có thể cần - để bên gọi nạp sẵn, đổi nền là hiện ngay.
 *
 *  Không gom thì đổi nền xong bộ vẽ tra `assets[url]` không thấy gì và lặng lẽ bỏ qua lớp đó:
 *  nền biến mất, hoạ tiết biến mất, mà không có lỗi nào nổ ra. */
function backgroundOptionUrls(spec) {
  const urls = [];
  for (const bo of spec?.background_options ?? []) {
    if (bo.background) urls.push(bo.background);
    for (const patch of Object.values(bo.patch ?? {})) if (patch?.asset) urls.push(patch.asset);
  }
  return urls;
}

/** Đường dẫn mọi ảnh atlas mà spec này cần, để bên gọi gom chung vào lượt tải asset.
 *
 *  Có hàm này thì thêm một bộ glyph vào spec là mọi nơi vẽ đều tự tải, không nơi nào phải nhớ.
 *  Thiếu atlas không nổ - nó vẽ trống rồi kèm cảnh báo - nên đây đúng là loại lỗi lặng lẽ nhất:
 *  chữ biến mất khỏi chăn mà bản dựng vẫn ra hình. */
function glyphAtlasUrls(spec) {
  return Object.values(spec.glyph_sets ?? {}).map((bo) => bo.atlas).filter(Boolean);
}

// ── app/snuggle-render.mjs ──────────────────────────────────────
// Đường vẽ DUY NHẤT của Snuggle Blanket.
//
// Xem trước phẳng, mockup thật và nút xuất ảnh đều gọi renderSnuggle. Có đường vẽ thứ hai
// là sớm muộn ảnh xuất ra sẽ khác ảnh khách nhìn thấy.



/** Tờ in 60 inch của smart object. designWidthPx phải khớp design_size[0] của spec.
 *
 *  Đây là khổ LỚN NHẤT trong ba cỡ nhà cung cấp bán. Chọn cỡ nhỏ hơn thì cùng một thiết kế in
 *  ra bé lại, nét chữ mảnh đi đúng theo tỉ lệ - nên ngưỡng cảnh báo in phải tính theo cỡ đang
 *  chọn chứ không phải theo hằng số này. State truyền `printWidthMm` vào để đổi. */
const PRINT = { printWidthPx: 9526, printWidthMm: 1524, designWidthPx: 2400 };

/** Vẽ toàn bộ spec lên ctx. Trả về danh sách cảnh báo in để Studio hiện lên. */
function renderSnuggle(ctx, spec, state, assets) {
  const size = spec.design_size;
  const tone = state.tone;
  const warnings = [];
  // Bộ nền khách chọn. `null` với mọi layout chưa có option nền, và khi đó mọi dòng dưới đây
  // rơi về đúng đường cũ.
  const nen = boNen(spec, state);

  ctx.clearRect(0, 0, size[0], size[1]);
  if (spec.background.kind === "fabric") {
    ctx.fillStyle = resolveColour("paper", tone);
    ctx.fillRect(0, 0, size[0], size[1]);
    const texture = assets[spec.background.texture];
    if (texture) {
      // Vân vải chỉ là lớp phủ nhẹ; màu vải vẫn do khoá paper quyết định. Hoạ tiết damask là
      // bản đồ alpha đen nên cần độ mờ thấp hơn nhiều vân vải - spec tự khai.
      ctx.save();
      ctx.globalAlpha = spec.background.texture_alpha ?? 0.35;
      ctx.drawImage(texture, 0, 0, size[0], size[1]);
      ctx.restore();
    }
  } else {
    // Tô paper trước rồi mới đè ảnh: ảnh nền tải hỏng thì còn lại nền đen của bảng màu nền ảnh,
    // chứ không phải khung trong suốt - trong suốt đi qua mockup ra mảng trắng, nhìn hệt như
    // chưa chọn thiết kế nên không ai biết là ảnh lỗi.
    ctx.fillStyle = resolveColour("paper", tone);
    ctx.fillRect(0, 0, size[0], size[1]);
    const image = assets[nen?.background ?? spec.background.asset];
    if (image) ctx.drawImage(image, 0, 0, size[0], size[1]);
  }

  for (const element of spec.elements) {
    // Ba tầng, và thứ tự này là cố ý: spec gốc, rồi bộ nền khách chọn, rồi bản sửa của người vận
    // hành. Đảo hai tầng sau là mỗi lần khách đổi nền sẽ nuốt mất mọi chỉnh tay đã làm trước đó.
    const theoNen = nen?.patch?.[element.id] ?? {};
    const patch = state.edits?.[element.id] ?? {};
    const merged = { ...element, ...theoNen, ...patch, box: { ...element.box, ...(patch.box ?? {}) } };
    if (merged.hidden) continue;
    if (merged.type === "text") warnings.push(...drawText(ctx, merged, spec, state, tone, assets));
    else if (merged.type === "photo_slot") drawPhoto(ctx, merged, spec, state, assets);
    else if (merged.type === "art") drawArt(ctx, merged, spec, tone, assets);
  }
  // Lọc bằng typeof chứ không bằng Boolean: TypeScript không thu hẹp kiểu qua Boolean,
  // nên bên gọi sẽ nhận (string|null)[] và báo lỗi.
  return warnings.filter((warning) => typeof warning === "string");
}

function linesFor(element, state) {
  if (element.source?.startsWith("field:")) {
    const value = state.fields?.[element.source.slice(6)];
    // Ô nhập đã có trong state thì nó nắm quyền, kể cả khi khách xoá trắng - xoá là chữ biến khỏi
    // chăn. Rơi về `lines` lúc rỗng thì khách xoá xong vẫn thấy chữ cũ, tưởng ô nhập hỏng.
    if (typeof value === "string") return value.split("\n");
  }
  if (Array.isArray(element.lines)) return element.lines;
  return [element.text ?? ""];
}

// ── Chữ DOODLE (layout 25 "Doodle Name Blanket", 2026-09-27) ─────────────────────────────────────
// Chèn vào bản sao snuggle-panel-embed.js thành l25-snuggle-embed.js (shopify-mcp/_hk-l25-doodle.mjs).
// KHÔNG nằm trong snuggle-kit/ve: luật kit cấm sửa bộ vẽ dùng chung cho một layout; 15 chăn đang bán
// vẫn chạy snuggle-panel-embed.js không đổi.
//
// Một lớp text có khoá `doodle` thì vẽ theo 4 lượt, dưới lên trên:
//   1. vòng chấm nhiều màu, cách viền trắng một khoảng (`dot_gap`), mỗi chấm cách nhau `dot_step`;
//   2. viền dày (`outline`, mặc định trắng) - gộp các chữ thành một miếng "sticker";
//   3. nét mảnh sẫm (`color` của lớp) sát mép chữ;
//   4. ruột chữ tô HOẠ TIẾT tự vẽ bằng code (loang màu + paisley + hoa + chấm + nét cong), lặp liền 4 mép.
// Mọi số đo `doodle.*` tính theo cỡ chữ đang vẽ (px), trừ `tile` tính theo bề ngang khung thiết kế - để
// hoạ tiết giữ nguyên cỡ dù tên dài hay ngắn (và không phải dựng lại tấm hoạ tiết mỗi phím gõ).
// Chữ tự co cho vừa hộp: theo chiều dài hộp (dọc khi rotate ±90) và theo bề dày còn lại.
// In ra khổ lớn: canvas được scale K lần thì tấm hoạ tiết dựng ở K lần để in không nhoè; vòng chấm tính
// trên mặt nạ thu nhỏ (≤720px) nhưng toạ độ ở khung thiết kế nên in to vẫn đúng chỗ.
const DOODLE_BANG_MAU = ["#ff3fa4", "#00bcd4", "#ffd23f", "#ff8a1c", "#8b4dff", "#76d83a", "#ff5a6e", "#27c4a0"];
const DOODLE_CHAM_MAU = ["#ffd23f", "#00bcd4", "#ff3fa4", "#76d83a", "#ff8a1c", "#8b4dff"];
const doodleTamHoaTiet = new Map();
const doodleTamCham = new Map();

function doodleHoaTiet(T, hat, P) {
  T = Math.max(64, Math.round(T));
  const khoa = `${T}|${hat}|${P.join(",")}`;
  const co = doodleTamHoaTiet.get(khoa);
  if (co) return co;
  let s = Math.max(1, hat | 0);
  const r = () => (s = (s * 16807) % 2147483647) / 2147483647;
  const c = document.createElement("canvas");
  c.width = c.height = T;
  const g = c.getContext("2d");
  const u = T / 720;
  const vien = "#1d2450";
  // Vẽ lặp ở 9 ô kề nhau: hình nào chờm mép này thì hiện phần còn lại ở mép đối diện - tấm lặp liền mạch.
  const moi = (f) => { for (const dx of [-T, 0, T]) for (const dy of [-T, 0, T]) { g.save(); g.translate(dx, dy); f(); g.restore(); } };
  g.fillStyle = P[hat % P.length];
  g.fillRect(0, 0, T, T);
  for (let i = 0; i < 46; i++) {
    const x = r() * T, y = r() * T, rr = T * (0.08 + r() * 0.16), m = P[i % P.length];
    moi(() => {
      const gr = g.createRadialGradient(x, y, 0, x, y, rr);
      gr.addColorStop(0, m + "ff"); gr.addColorStop(0.55, m + "cc"); gr.addColorStop(1, m + "00");
      g.fillStyle = gr; g.fillRect(x - rr, y - rr, rr * 2, rr * 2);
    });
  }
  const giot = (sc) => {
    g.beginPath(); g.moveTo(0, -60 * sc);
    g.bezierCurveTo(50 * sc, -40 * sc, 55 * sc, 40 * sc, 0, 55 * sc);
    g.bezierCurveTo(-55 * sc, 40 * sc, -40 * sc, -5 * sc, -5 * sc, -10 * sc);
    g.bezierCurveTo(15 * sc, -15 * sc, 10 * sc, -40 * sc, 0, -60 * sc);
    g.closePath();
  };
  const paisley = (x, y, k, rot, m1, m2) => moi(() => {
    g.save(); g.translate(x, y); g.rotate(rot); g.scale(k * u, k * u);
    giot(1); g.fillStyle = m1; g.fill(); g.lineWidth = 5; g.strokeStyle = vien; g.stroke();
    giot(0.62); g.fillStyle = m2; g.fill(); g.lineWidth = 4; g.stroke();
    g.fillStyle = "#fff";
    for (let a = 0; a < 7; a++) { g.beginPath(); g.arc(-4 + Math.cos(a) * 20, 18 + Math.sin(a) * 18, 5, 0, 7); g.fill(); }
    g.restore();
  });
  const hoa = (x, y, k, n, m1, m2) => moi(() => {
    g.save(); g.translate(x, y); g.scale(k * u, k * u);
    for (let i = 0; i < n; i++) {
      g.save(); g.rotate((i / n) * Math.PI * 2);
      g.beginPath(); g.ellipse(0, -30, 16, 30, 0, 0, 7);
      g.fillStyle = m1; g.fill(); g.lineWidth = 4; g.strokeStyle = vien; g.stroke();
      g.restore();
    }
    g.beginPath(); g.arc(0, 0, 15, 0, 7); g.fillStyle = m2; g.fill(); g.lineWidth = 4; g.strokeStyle = vien; g.stroke();
    g.restore();
  });
  for (let i = 0; i < 24; i++) paisley(r() * T, r() * T, 0.7 + r() * 0.8, r() * 6.28, P[(i + 1) % P.length], P[(i + 4) % P.length]);
  for (let i = 0; i < 22; i++) hoa(r() * T, r() * T, 0.6 + r() * 0.8, 5 + (i % 4), P[(i + 2) % P.length], P[(i + 5) % P.length]);
  for (let i = 0; i < 90; i++) {
    const x = r() * T, y = r() * T, rr = (3 + r() * 7) * u, m = P[i % P.length];
    moi(() => { g.beginPath(); g.arc(x, y, rr, 0, 7); g.fillStyle = m; g.fill(); });
  }
  for (let i = 0; i < 18; i++) {
    const x = r() * T, y = r() * T, rr = (12 + r() * 20) * u, a0 = r() * 6;
    moi(() => { g.beginPath(); g.arc(x, y, rr, a0, a0 + 4); g.lineWidth = 5 * u; g.lineCap = "round"; g.strokeStyle = vien; g.stroke(); });
  }
  doodleTamHoaTiet.set(khoa, c);
  if (doodleTamHoaTiet.size > 6) doodleTamHoaTiet.delete(doodleTamHoaTiet.keys().next().value);
  return c;
}

/** Toạ độ các chấm quanh chữ (khung thiết kế). `veVung(g)` tô vùng chữ + viền + khoảng hở lên g. */
function doodleCham(khoa, W, H, veVung, buoc, luuTam = true, doPhan = 480) {
  const co = doodleTamCham.get(khoa);
  if (co) return co;
  // Mặt nạ thu nhỏ: 480px cạnh dài khi xem trên trang (nhanh - mỗi phím gõ tính lại), lớn hơn theo hệ số
  // phóng khi dựng file in (chấm nằm đúng chỗ tới từng pixel in).
  const k = Math.min(1, doPhan / Math.max(W, H));
  const w = Math.max(1, Math.round(W * k)), h = Math.max(1, Math.round(H * k));
  const m = document.createElement("canvas");
  m.width = w; m.height = h;
  const g = m.getContext("2d", { willReadFrequently: true });
  g.scale(k, k);
  veVung(g);
  const a = g.getImageData(0, 0, w, h).data;
  const trong = (x, y) => a[(y * w + x) * 4 + 3] > 127;
  const b = Math.max(2, buoc * k), luoi = new Map(), diem = [];
  for (let y = 1; y < h - 1; y++) {
    for (let x = 1; x < w - 1; x++) {
      if (!trong(x, y) || (trong(x - 1, y) && trong(x + 1, y) && trong(x, y - 1) && trong(x, y + 1))) continue;
      const gx = Math.floor(x / b), gy = Math.floor(y / b);
      let gan = false;
      for (let i = -1; i <= 1 && !gan; i++) for (let j = -1; j <= 1 && !gan; j++) {
        for (const p of luoi.get(`${gx + i},${gy + j}`) ?? []) if ((p[0] - x) ** 2 + (p[1] - y) ** 2 < b * b) { gan = true; break; }
      }
      if (gan) continue;
      const p = [x, y];
      diem.push(p);
      const o = `${gx},${gy}`;
      if (!luoi.has(o)) luoi.set(o, []);
      luoi.get(o).push(p);
    }
  }
  const ra = diem.map(([x, y]) => [(x + 0.5) / k, (y + 0.5) / k]);
  // Font chưa nạp xong thì vòng chấm đang ôm chữ font hệ thống: vẽ tạm được, nhưng KHÔNG nhớ - nhớ là lần
  // vẽ sau (đã có font) lấy lại đúng vòng chấm sai này.
  if (!luuTam) return ra;
  doodleTamCham.set(khoa, ra);
  if (doodleTamCham.size > 24) doodleTamCham.delete(doodleTamCham.keys().next().value);
  return ra;
}

function veChuDoodle(ctx, element, spec, state, box, mauCanh) {
  const d = element.doodle || {};
  const text = linesFor(element, state).join(" ").replace(/\s+/g, " ").trim();
  if (!text) return [];
  const [W, H] = spec.design_size;
  const goc = ((element.rotate ?? 0) * Math.PI) / 180;
  const doc = Math.abs(Math.round(Math.sin(goc))) === 1;
  const dai = doc ? box.h : box.w, day = doc ? box.w : box.h;
  const cx = box.x + box.w / 2, cy = box.y + box.h / 2;
  const vien = d.outline_w ?? 0.17, canh = d.edge_w ?? 0.06, ho = d.dot_gap ?? 0.12, rCham = d.dot_r ?? 0.022, buoc = d.dot_step ?? 0.075;
  const le = vien + 2 * (ho + rCham);
  const fontCua = (px) => `${element.weight ? `${element.weight} ` : ""}${px}px "${element.font}"`;
  let px = scaleToPixels(element.size, spec.design_size);
  ctx.save();
  ctx.font = fontCua(100);
  const rong1 = ctx.measureText(text).width / 100;
  ctx.restore();
  px = Math.max(8, Math.min(px, dai / (rong1 + le), day / ((d.cao ?? 0.95) + le)));
  const dy = (d.dy ?? 0.04) * px;
  const datChu = (g) => { g.font = fontCua(px); g.textAlign = "center"; g.textBaseline = "middle"; g.lineJoin = "round"; g.lineCap = "round"; };
  const xoay = (g) => { g.translate(cx, cy); g.rotate(goc); g.translate(-cx, -cy); };

  const m = ctx.getTransform();
  const K = Math.hypot(m.a, m.b) || 1;
  const doPhan = Math.min(4000, Math.round(480 * Math.max(1, K)));

  // 1. vòng chấm - tính trong khung thiết kế (đã xoay), vẽ không xoay
  const cham = doodleCham(`${text}|${element.font}|${Math.round(px)}|${element.rotate}|${cx}|${cy}|${W}x${H}|${vien}|${ho}|${buoc}|${doPhan}`, W, H, (g) => {
    xoay(g); datChu(g);
    g.lineWidth = px * (vien + 2 * ho); g.strokeStyle = "#000"; g.fillStyle = "#000";
    g.strokeText(text, cx, cy + dy); g.fillText(text, cx, cy + dy);
  }, px * buoc, !document.fonts || document.fonts.check(fontCua(100)), doPhan);
  const mauCham = Array.isArray(d.dots) && d.dots.length ? d.dots : DOODLE_CHAM_MAU;
  ctx.save();
  cham.forEach(([x, y], i) => { ctx.beginPath(); ctx.arc(x, y, px * rCham, 0, Math.PI * 2); ctx.fillStyle = mauCham[i % mauCham.length]; ctx.fill(); });
  ctx.restore();

  // 2-4. viền dày, nét sẫm, ruột hoạ tiết. Bóng đổ TẮT mặc định: nó tốn ~50ms mỗi phím gõ (làm mờ cả nét
  // viền dày trên tấm 2400×3250) mà trên chăn hầu như không thấy; muốn bật thì khai doodle.shadow.
  ctx.save();
  xoay(ctx); datChu(ctx);
  if (d.shadow) {
    ctx.shadowColor = typeof d.shadow === "string" ? d.shadow : "rgba(0,0,0,0.16)";
    ctx.shadowBlur = px * 0.05 * K;
    ctx.shadowOffsetY = px * 0.02 * K;
  }
  ctx.lineWidth = px * vien; ctx.strokeStyle = element.outline ?? "#ffffff";
  ctx.strokeText(text, cx, cy + dy);
  ctx.shadowColor = "transparent";
  ctx.lineWidth = px * canh; ctx.strokeStyle = mauCanh;
  ctx.strokeText(text, cx, cy + dy);
  const bang = Array.isArray(d.palette) && d.palette.length ? d.palette : DOODLE_BANG_MAU;
  const T = (d.tile ?? 0.32) * W;
  const tam = doodleHoaTiet(T * K, d.seed ?? 7, bang);
  const mau = ctx.createPattern(tam, "repeat");
  if (mau && mau.setTransform && typeof DOMMatrix === "function") mau.setTransform(new DOMMatrix().scale(1 / K));
  ctx.fillStyle = mau || bang[0];
  ctx.fillText(text, cx, cy + dy);
  ctx.restore();
  return [];
}

function drawText(ctx, element, spec, state, tone, assets) {
  const box = boxToPixels(element.box, spec.design_size);
  const colour = resolveColour(element.color ?? "ink", tone);
  let size = scaleToPixels(element.size, spec.design_size);
  const leading = element.leading ?? 1;

  // Layout 25: chữ doodle tô hoạ tiết (l25-doodle/doodle-ve.js).
  if (element.doodle) return veChuDoodle(ctx, element, spec, state, box, colour);
  // Font chỉ có trong Canva thì spec khai `glyphs` trỏ tới bộ ký tự đã tô sẵn thành ảnh.
  if (element.glyphs) return drawGlyphText(ctx, element, spec, state, box, colour, size, assets);

  ctx.save();
  // Chữ nằm trên dải ruy-băng nghiêng thì phải nghiêng theo. Xoay quanh tâm hộp, giống lớp art.
  rotateAbout(ctx, element.rotate, box);
  slantAbout(ctx, element.slant, box);
  ctx.textBaseline = "top";
  ctx.textAlign = element.align ?? "left";

  // letterSpacing phải đặt SAU font: gán font làm Chrome đặt lại giãn chữ về 0, nên đảo thứ
  // tự là tracking trong spec im lặng không có tác dụng - đúng cái bẫy "khai một đằng vẽ một
  // nẻo" mà layout-là-dữ-liệu sinh ra.
  // `weight` chỉ có nghĩa với font biến thiên - Oswald tải về là bản variable 200-700. Bỏ nó
  // đi thì trình duyệt lấy 400, nên "Oswald SemiBold" trong bản thiết kế lặng lẽ ra Regular:
  // chữ mảnh hơn hẳn mà không có gì báo.
  const applyFont = (at) => {
    ctx.font = element.weight ? `${element.weight} ${at}px "${element.font}"` : `${at}px "${element.font}"`;
    ctx.letterSpacing = `${scaleToPixels(element.tracking ?? 0, spec.design_size)}px`;
  };

  let lines = linesFor(element, state);
  let overflow = false;
  let scale = 1;
  const measure = (text, at) => { applyFont(at); return ctx.measureText(text).width; };
  if (element.wrap === "box") {
    lines = lines.flatMap((line) => wrapLines(line, { size, maxWidth: box.w, measure }));
    const fitted = fitLines(lines, { size, leading, maxHeight: box.h });
    size = fitted.size; lines = fitted.lines; overflow = fitted.overflow;
  } else {
    // Khách gõ dài hơn chữ trong bản thiết kế thì CO NHỎ lại. Không co thì chữ trườn ra ngoài
    // viền và đè lên dấu chân, trái tim, hoa hồng - đo rồi: cả năm dòng của layout 9 đều có hoạ
    // tiết nằm sát ngay bên cạnh, không dòng nào có chỗ thừa để nới ra.
    const fitted = fitWidth(lines, { size, maxWidth: designRoom(element, spec, measure, size), measure });
    scale = fitted.scale;
    overflow = fitted.overflow;
  }

  applyFont(size);
  const anchorX = element.align === "center" ? box.x + box.w / 2
    : element.align === "right" ? box.x + box.w
    : box.x;
  // Co quanh TÂM hộp: chữ nhỏ lại đúng tại chỗ bản thiết kế dành cho nó, không trôi lên trôi
  // xuống. Nét viền và giãn dòng nằm trong cùng phép biến hình nên nhỏ theo cùng nhịp.
  if (scale < 1) {
    const cx = anchorX, cy = box.y + box.h / 2;
    ctx.translate(cx, cy);
    ctx.scale(scale, scale);
    ctx.translate(-cx, -cy);
  }
  lines.forEach((line, index) => {
    const y = box.y + index * size * leading;
    // Hai lượt vẽ này CHÍNH LÀ nút chỉnh độ dày nét. stroke đo bằng pixel khung thiết kế,
    // mà canvas đang đúng khổ khung, nên gán thẳng vào lineWidth.
    if ((element.stroke ?? 0) > 0) {
      ctx.lineJoin = "round";
      ctx.lineWidth = element.stroke;
      ctx.strokeStyle = colour;
      ctx.strokeText(line, anchorX, y);
    }
    ctx.fillStyle = colour;
    ctx.fillText(line, anchorX, y);
  });
  ctx.restore();

  const print = { ...PRINT, printWidthMm: state.printWidthMm ?? PRINT.printWidthMm };
  // Tính theo cỡ chữ THẬT SỰ in ra: co nhỏ là nét cũng mảnh đi theo, cảnh báo mà vẫn lấy cỡ gốc
  // thì đúng lúc nét mảnh nhất lại là lúc nó im lặng.
  const warnings = [printWarning({ id: element.id, size: element.size * scale, stroke: (element.stroke ?? 0) * scale, font: element.font }, print)];
  if (overflow) warnings.push(`${element.id}: chữ quá dài, đã co hết mức mà vẫn tràn khung`);
  return warnings;
}

/** Vẽ chữ bằng BỘ GLYPH ẢNH thay vì bằng font.
 *
 *  Dùng cho font chỉ có trong Canva, không có file để nhúng: bộ ký tự tô sẵn thành một tấm ảnh,
 *  kèm bảng toạ độ từng chữ (xem scripts/build-sailors-glyphs.mjs).
 *
 *  Vẫn co chữ cho vừa chỗ như nhánh font thật, và vẫn co bằng HỆ SỐ quanh tâm hộp - hai nhánh phải
 *  hành xử giống nhau, không thì đổi font là bố cục nhảy.
 */
function drawGlyphText(ctx, element, spec, state, box, colour, size, assets) {
  const bo = spec.glyph_sets?.[element.glyphs];
  // Atlas đi chung một đường với mặt nạ và lớp art: bên gọi chỉ phải gom `glyphAtlasUrls(spec)`
  // vào cùng cái Set nó đang gom, không phải nuôi thêm một kênh nạp riêng cho chữ.
  const atlas = bo && assets?.[bo.atlas];
  // Thiếu bộ glyph thì vẽ trống còn hơn nổ giữa chừng: mọi lớp sau đó vẫn lên, người dựng thấy
  // ngay là thiếu asset chứ không phải cả tấm trắng bóc.
  if (!bo || !atlas) return [`${element.id}: thiếu bộ glyph "${element.glyphs}"`];

  const { lines, thieu } = capChu(linesFor(element, state), bo);
  const scale = size / bo.font_size;
  // Giãn chữ trong spec cũng phải có tác dụng ở đường vẽ này, không thì spec khai `tracking` mà
  // chữ vẽ ra không đổi - đúng cái bẫy "khai một đằng vẽ một nẻo" mà layout-là-dữ-liệu sinh ra.
  const track = scaleToPixels(element.tracking ?? 0, spec.design_size);
  const rong = (text) => glyphLineWidth(text, bo, scale, track);
  const fitted = fitWidth(lines, {
    size, maxWidth: designRoom(element, spec, (text) => rong(text), size),
    measure: (text) => rong(text),
  });

  const cao = Math.max(...lines.map((line) => Math.max(0,
    ...[...line].filter((c) => c !== " " && bo.glyphs[c]).map((c) => bo.glyphs[c].tren))));
  ctx.save();
  rotateAbout(ctx, element.rotate, box);
  slantAbout(ctx, element.slant, box);
  if (fitted.scale < 1) {
    const cx = box.x + box.w / 2, cy = box.y + box.h / 2;
    ctx.translate(cx, cy);
    ctx.scale(fitted.scale, fitted.scale);
    ctx.translate(-cx, -cy);
  }
  lines.forEach((line, index) => {
    const w = rong(line);
    const x = element.align === "center" ? box.x + (box.w - w) / 2
      : element.align === "right" ? box.x + box.w - w
      : box.x;
    // Neo theo đường chân chữ: mép trên khung mực nhảy tuỳ chữ khách gõ, neo vào đó là dòng chữ
    // trồi sụt mỗi lần đổi chữ.
    const baseline = box.y + cao * scale + index * size * leadingOf(element);
    drawGlyphLine(ctx, line, bo, atlas, x, baseline, scale, colour, track, banKinhCung(element, spec));
  });
  ctx.restore();

  const print = { ...PRINT, printWidthMm: state.printWidthMm ?? PRINT.printWidthMm };
  const warnings = [printWarning({ id: element.id, size: element.size * fitted.scale,
    stroke: 0, font: element.font }, print)];
  if (fitted.overflow) warnings.push(`${element.id}: chữ quá dài, đã co hết mức mà vẫn tràn khung`);
  if (thieu.length) warnings.push(`${element.id}: bộ glyph "${element.glyphs}" không có ký tự ${thieu.join(" ")}`);
  return warnings;
}

/** Đưa chữ khách gõ về đúng bộ ký tự mà bộ glyph có, và BÁO cái gì vẫn không có.
 *
 *  Sailors là font chữ hoa - trong atlas không có lấy một chữ thường. Cứ thế đem vẽ thì
 *  `drawGlyphLine` lặng lẽ bỏ qua từng ký tự tra không ra: khách gõ "Bella" là in lên chăn đúng
 *  một chữ "B", mà không chỗ nào báo. Nên hạ về chữ hoa trước, rồi bỏ dấu, còn thiếu thật thì
 *  trả cảnh báo chứ không nuốt.
 *
 *  Bỏ dấu chứ không bỏ chữ: "José" thành "JOSE" là cái tiệm in nào cũng làm, còn thành "JOS" thì
 *  là hỏng đơn. */
/** Dấu thanh, dấu mũ... mà normalize("NFD") tách rời ra khỏi chữ cái (U+0300..U+036F). */
const khongPhaiDau = (k) => k.codePointAt(0) < 0x300 || k.codePointAt(0) > 0x36f;

function capChu(lines, bo) {
  const thieu = new Set();
  const boDau = (c) => (c === "đ" || c === "Đ" ? "D" : [...c.normalize("NFD")].filter(khongPhaiDau).join(""));
  const ra = lines.map((line) => [...line].map((c) => {
    if (c === " " || bo.glyphs[c]) return c;
    for (const thu of [c.toUpperCase(), boDau(c).toUpperCase()]) {
      if (thu.length === 1 && bo.glyphs[thu]) return thu;
    }
    thieu.add(c);
    return c;
  }).join(""));
  return { lines: ra, thieu: [...thieu] };
}

function leadingOf(element) { return element.leading ?? 1; }

/** Vẽ một dòng chữ bằng BỘ GLYPH ẢNH thay vì bằng font.
 *
 *  Dùng cho font chỉ có trong Canva, không có file để nhúng: bộ ký tự được tô sẵn thành một tấm
 *  ảnh, kèm bảng toạ độ từng chữ (xem scripts/build-sailors-glyphs.mjs).
 *
 *  Ba điều phải khớp với bên dựng bộ glyph, sai một cái là chữ lệch:
 *
 *   - Tỉ lệ vẽ = cỡ chữ trong spec / `font_size` của bộ glyph. Đừng suy ngược từ chiều cao chữ
 *     hoa, đó là chỗ dễ sai nhất.
 *   - Bước tiến: hai mô hình, chọn theo cờ `per_glyph_advance` của bộ glyph.
 *       không có cờ - bề rộng mực + một KHE HẰNG SỐ, cộng thêm nếu giữa hai chữ có dấu cách.
 *       có cờ      - mỗi glyph mang `adv` riêng, đo từ bảng gõ lặp ba lần bên bộ dựng glyph.
 *       Font VIẾT TAY bắt buộc dùng mô hình thứ hai: nét nối làm khung mực hai chữ liền nhau chồng
 *       lên nhau, mà mức chồng tuỳ từng chữ. Ép một khe chung vào là ra khe ÂM, khớp bề rộng tổng
 *       mà sai vị trí từng chữ - dựng ra "J ames & Amelia" thay vì "James & Amelia".
 *   - Neo theo ĐƯỜNG CHÂN CHỮ, không neo mép trên khung: chữ có phần thò xuống (dấu phẩy, ngoặc)
 *     nên mép trên của khung mực nhảy lung tung tuỳ dòng chữ khách gõ.
 */
function glyphLineWidth(text, bo, scale, track) {
  if (bo.per_glyph_advance) {
    // Bề rộng MỰC của dòng: cộng bước tiến mọi ký tự trừ ký tự cuối, rồi cộng bề rộng mực của
    // ký tự cuối. Bước tiến của ký tự cuối không tính - nó là chỗ trống sau chữ, không phải mực.
    const ky = [...text].filter((c) => c === " " || bo.glyphs[c]);
    if (!ky.length) return 0;
    let tong = 0;
    for (let i = 0; i < ky.length - 1; i++) {
      tong += (ky[i] === " " ? bo.word_gap : bo.glyphs[ky[i]].adv) * scale + track;
    }
    const cuoi = ky[ky.length - 1], dau = ky[0];
    tong += (cuoi === " " ? bo.word_gap : bo.glyphs[cuoi].w) * scale;
    // Mực bắt đầu ở lề trái của chữ ĐẦU, kết thúc ở lề trái + bề rộng của chữ CUỐI. Bỏ khoản này
    // là dòng lệch khỏi tâm hộp đúng bằng nửa hiệu hai lề - thấy rõ nhất ở font viết tay, nơi lề
    // trái trải từ -38px tới +17px.
    if (bo.glyphs[dau] && bo.glyphs[cuoi]) {
      tong += ((bo.glyphs[cuoi].lsb ?? 0) - (bo.glyphs[dau].lsb ?? 0)) * scale;
    }
    return tong;
  }
  let tong = 0, coTruoc = false, cho = 0;
  for (const c of text) {
    if (c === " ") { if (coTruoc) cho++; continue; }
    const g = bo.glyphs[c];
    if (!g) continue;
    if (coTruoc) tong += glyphKhe(bo, scale, cho, track);
    tong += g.w * scale;
    coTruoc = true; cho = 0;
  }
  return tong;
}

/** Khoảng chèn giữa hai chữ liền nhau, tính bằng pixel trang in.
 *
 *  `cho` là số dấu cách nằm giữa hai chữ đó. Một dấu cách thì lấy khe của dấu cách; nhiều dấu
 *  cách liền nhau thì cộng dồn - gõ hai dấu cách ra khoảng trống gấp đôi, đúng như người gõ chờ
 *  đợi, chứ không âm thầm gộp thành một. */
function glyphKhe(bo, scale, cho, track) {
  return (bo.gap + cho * (bo.word_gap - bo.gap)) * scale + track;
}

/** Bán kính cung của dòng chữ, quy về pixel trang in. 0 nghĩa là dòng THẲNG.
 *
 *  Khai bằng BÁN KÍNH chứ không phải góc quét, vì đường cong là của TẤM NỀN chứ không phải của
 *  dòng chữ: dải ruy-băng layout 20 cong cố định, khách gõ tên ngắn hay dài thì chữ vẫn phải bám
 *  đúng đường cong ấy. Khai góc quét thì tên ngắn lại cong gắt hơn.
 *
 *  Dương = tâm đường tròn nằm DƯỚI chữ, dòng vồng lên hình mái vòm. Âm thì ngược lại. */
function banKinhCung(element, spec) {
  const arc = element.arc ?? 0;
  return arc ? scaleToPixels(arc, spec.design_size) : 0;
}

function drawGlyphLine(ctx, text, bo, atlas, x, baseline, scale, colour, track, cung = 0) {
  const rieng = Boolean(bo.per_glyph_advance);
  // Dòng CONG: mỗi con chữ đặt lên một điểm trên cung và xoay theo tiếp tuyến tại đó. Bề rộng dòng
  // không đổi - cung dài bằng đúng đoạn thẳng - nên phép đo, phép căn lề và phép co đều giữ nguyên.
  const nuaRong = cung ? glyphLineWidth(text, bo, scale, track) / 2 : 0;
  const tamX = x + nuaRong;
  // `but` là CON TRỎ. Mực của một chữ nằm ở con trỏ + lề trái của chữ đó, nên chữ đầu phải lùi
  // con trỏ lại đúng cái lề của nó thì mực mới bắt đầu ở `x`.
  const chuDau = [...text].find((c) => c !== " " && bo.glyphs[c]);
  let but = x - (rieng && chuDau ? (bo.glyphs[chuDau].lsb ?? 0) * scale : 0);
  let coTruoc = false, cho = 0;
  for (const c of text) {
    if (c === " ") {
      if (rieng) but += bo.word_gap * scale + track;
      else if (coTruoc) cho++;
      continue;
    }
    const g = bo.glyphs[c];
    if (!g) continue;
    if (!rieng && coTruoc) but += glyphKhe(bo, scale, cho, track);
    coTruoc = true; cho = 0;
    const w = g.w * scale, h = g.h * scale;
    const gy = baseline - g.tren * scale;
    // Tô màu: vẽ glyph vào một khung phụ rồi phủ màu qua `source-in`. Vẽ thẳng ra trang thì mực
    // giữ nguyên màu đen của atlas, không nhận màu spec khai.
    const cell = document.createElement("canvas");
    cell.width = Math.max(1, Math.ceil(w));
    cell.height = Math.max(1, Math.ceil(h));
    const cc = cell.getContext("2d");
    if (!cc) continue;
    cc.drawImage(atlas, g.x, g.y, g.w, g.h, 0, 0, cell.width, cell.height);
    cc.globalCompositeOperation = "source-in";
    cc.fillStyle = colour;
    cc.fillRect(0, 0, cell.width, cell.height);
    const gx = but + (rieng ? (g.lsb ?? 0) * scale : 0);
    if (cung) {
      // Góc lấy theo TÂM MỰC của con chữ, không lấy mép trái: mép trái thì chữ rộng như `W` bị
      // xoay quanh một điểm lệch hẳn sang bên, nhìn ra ngay ở cỡ chữ lớn.
      const goc = (gx + w / 2 - tamX) / cung;
      ctx.save();
      ctx.translate(tamX + cung * Math.sin(goc), baseline + cung - cung * Math.cos(goc));
      ctx.rotate(goc);
      ctx.drawImage(cell, -w / 2, -g.tren * scale, w, h);
      ctx.restore();
    } else {
      ctx.drawImage(cell, gx, gy, w, h);
    }
    but += rieng ? g.adv * scale + track : w;
  }
}

/** Bề ngang mà bản thiết kế dành cho dòng này: hộp của nó, và không bao giờ hẹp hơn chữ mặc định.
 *
 *  Hai vế vì hộp chữ trong sáu layout không cùng một loại. Layout dựng tay (1, 5, 6, 7, 8) đặt
 *  hộp rộng rãi - đó chính là chỗ người dựng dành cho dòng đó, lấy đúng nó làm trần. Layout 9
 *  dựng lại từ Canva thì hộp bám sát khung MỰC của chữ mặc định, mà lúc vẽ đo bằng bề rộng bước
 *  tiến - hai số lệch nhau chừng 2%, lấy hộp không thôi là chữ mặc định tự co 2% và bản dựng ra
 *  khác bản gốc. Lấy số lớn hơn thì cả hai loại đều đúng.
 *
 *  Nới rộng hơn thế thì khai thẳng `max_width`, kèm số đo hoạ tiết nằm cạnh - đừng đoán.
 *
 *  Chữ cố định thì trả 0: nó không đổi được nên không có gì để co. */
function designRoom(element, spec, measure, size) {
  if (element.max_width) return element.max_width * spec.design_size[0];
  if (!element.source?.startsWith("field:")) return 0;
  const goc = spec.fields?.find((field) => field.id === element.source.slice(6))?.default;
  if (!goc) return 0;
  const macDinh = Math.max(0, ...String(goc).split("\n").map((line) => measure(line, size)));
  return Math.max(element.box.w * spec.design_size[0], macDinh);
}

function drawPhoto(ctx, element, spec, state, assets) {
  const box = boxToPixels(element.box, spec.design_size);
  const photo = assets[state.photos?.[element.index]] ?? assets[`sample:${element.index}`];
  if (!photo) {
    // Chưa có ảnh thì vẽ ô rỗng để người dựng thấy khung nằm đâu - nhưng phải CẮT THEO MẶT NẠ,
    // không được tô nguyên hình chữ nhật. Hộp ô ảnh là hình chữ nhật bao quanh lòng tim, tô
    // thẳng là bốn góc thò ra ngoài viền thành một vệt mờ, nhìn y như bản dựng bị lỗi.
    const emptyMask = element.mask ? assets[element.mask] : null;
    ctx.save();
    ctx.fillStyle = "rgba(0,0,0,0.06)";
    if (emptyMask) {
      const cell = maskedCell(box, emptyMask, (cellCtx, size) => {
        cellCtx.fillStyle = "rgba(0,0,0,0.06)";
        cellCtx.fillRect(0, 0, size.w, size.h);
      });
      if (cell) ctx.drawImage(cell, box.x, box.y, box.w, box.h);
    } else {
      ctx.fillRect(box.x, box.y, box.w, box.h);
    }
    ctx.restore();
    return;
  }
  const radius = scaleToPixels(element.radius ?? 0, spec.design_size);

  ctx.save();
  // Xoay TRƯỚC khi cắt: ô ảnh nghiêng thì cái khung nghiêng theo, không phải ảnh xoay tròn
  // bên trong một ô vuông đứng yên. Layout 5 treo ba tấm polaroid nghiêng nên phải là kiểu này.
  rotateAbout(ctx, element.rotate, box);
  ctx.beginPath();
  ctx.roundRect(box.x, box.y, box.w, box.h, radius);
  ctx.clip();
  // Dịch và phóng ảnh BÊN TRONG khung. Không có mấy số này thì muốn chỉnh ảnh chỉ còn cách kéo cả
  // hộp - mà hộp của ô ảnh có mặt nạ lại gắn chặt với khung trang trí vẽ đè lên, kéo hộp là mặt nạ
  // rời khỏi khung, lộ ra một mảng ảnh nằm ngoài viền. Đúng lỗi đã gặp ở Layout 8.
  const zoom = element.zoom ?? 1;
  // Xoay ẢNH bên trong khung (khác `rotate`, cái đó xoay cả cái khung). Ảnh chụp ngang mà khung
  // là trái tim đứng thì phải xoay ảnh mới lọt được chủ thể vào giữa.
  //
  // Xoay rồi thì phải phủ RỘNG HƠN: khung xoay đi một góc có hộp bao lớn hơn chính nó, cứ dùng
  // cover cũ là bốn góc khung hở ra nền trắng. Hộp bao của khung w×h xoay θ là
  // (w·|cos|+h·|sin|) × (w·|sin|+h·|cos|) - lấy đúng số đó làm cỡ cần phủ.
  const spin = ((element.spin ?? 0) * Math.PI) / 180;
  const cos = Math.abs(Math.cos(spin)), sin = Math.abs(Math.sin(spin));
  const needW = box.w * cos + box.h * sin, needH = box.w * sin + box.h * cos;
  const cover = Math.max(needW / photo.naturalWidth, needH / photo.naturalHeight) * zoom;
  const drawW = photo.naturalWidth * cover, drawH = photo.naturalHeight * cover;
  const panX = (element.pan_x ?? 0) * box.w, panY = (element.pan_y ?? 0) * box.h;
  // Bộ lọc màu áp ĐÚNG lúc vẽ ảnh, không áp cho cả khung: mặt nạ, viền tim và chữ chung quanh
  // phải giữ nguyên màu. `ctx.filter` là thuộc tính của context nên nhớ trả về "none" sau đó,
  // không thì lớp vẽ tiếp theo ăn theo bộ lọc.
  const filter = photoFilterCss(element.filter);
  const mask = element.mask ? assets[element.mask] : null;
  if (mask) {
    const cell = maskedCell(box, mask, (cellCtx, size) => {
      const scale = size.w / box.w;
      // Chỉ MỘT đường lọc: có ctx.filter thật thì dùng nó, không thì lọc điểm ảnh sau khi vẽ. Gán cả
      // hai là ảnh bị lọc hai lần ở trình duyệt nửa hỗ trợ.
      const coThat = filter === "none" || coCanvasFilter(cellCtx);
      if (coThat) cellCtx.filter = filter;
      // Xoay quanh TÂM ô, và xoay trước khi vẽ ảnh - mặt nạ áp sau nên khung tim vẫn đứng yên,
      // chỉ ảnh bên trong quay.
      if (spin) {
        cellCtx.translate(size.w / 2, size.h / 2);
        cellCtx.rotate(spin);
        cellCtx.translate(-size.w / 2, -size.h / 2);
      }
      cellCtx.drawImage(photo, ((box.w - drawW) / 2 + panX) * scale, ((box.h - drawH) / 2 + panY) * scale, drawW * scale, drawH * scale);
      cellCtx.filter = "none";
      if (!coThat) locDiemAnh(cellCtx, size.w, size.h, filter);
    });
    if (cell) {
      ctx.drawImage(cell, box.x, box.y, box.w, box.h);
      ctx.restore();
      return;
    }
  }
  if (filter !== "none" && !coCanvasFilter(ctx)) {
    // Không có ctx.filter: vẽ ảnh vào canvas phụ đúng cỡ ô, lọc điểm ảnh, rồi đặt vào ô (vẫn trong clip).
    const phu = (ctx.canvas?.ownerDocument ?? document).createElement("canvas");
    phu.width = Math.max(1, Math.round(box.w));
    phu.height = Math.max(1, Math.round(box.h));
    const g = phu.getContext("2d");
    if (spin) {
      g.translate(phu.width / 2, phu.height / 2);
      g.rotate(spin);
      g.translate(-phu.width / 2, -phu.height / 2);
    }
    g.drawImage(photo, (box.w - drawW) / 2 + panX, (box.h - drawH) / 2 + panY, drawW, drawH);
    g.setTransform(1, 0, 0, 1, 0, 0);
    locDiemAnh(g, phu.width, phu.height, filter);
    ctx.drawImage(phu, box.x, box.y, box.w, box.h);
    ctx.restore();
    return;
  }
  ctx.filter = filter;
  if (spin) {
    const mx = box.x + box.w / 2, my = box.y + box.h / 2;
    ctx.translate(mx, my);
    ctx.rotate(spin);
    ctx.translate(-mx, -my);
  }
  ctx.drawImage(photo, box.x + (box.w - drawW) / 2 + panX, box.y + (box.h - drawH) / 2 + panY, drawW, drawH);
  ctx.filter = "none";
  ctx.restore();
}

/** Trình duyệt có THỰC SỰ vẽ `ctx.filter` không. Safari cho gán thuộc tính mà không áp gì, nên dò
 *  bằng kết quả: tô đỏ qua grayscale(1) rồi đọc lại điểm ảnh. Dò một lần cho cả trang.
 *  `globalThis.SNUGGLE_NO_CTX_FILTER = true` ép đường dự phòng để kiểm trên Chrome. */
let _coCanvasFilter = null;
function coCanvasFilter(ctx) {
  if (globalThis.SNUGGLE_NO_CTX_FILTER) return false;
  if (_coCanvasFilter !== null) return _coCanvasFilter;
  try {
    const c = (ctx.canvas?.ownerDocument ?? document).createElement("canvas");
    c.width = c.height = 1;
    const g = c.getContext("2d");
    g.filter = "grayscale(1)";
    g.fillStyle = "#ff0000";
    g.fillRect(0, 0, 1, 1);
    const d = g.getImageData(0, 0, 1, 1).data;
    _coCanvasFilter = d[1] > 0;
  } catch {
    _coCanvasFilter = true;
  }
  return _coCanvasFilter;
}

/** Áp bộ lọc bằng điểm ảnh lên TOÀN BỘ một canvas phụ chỉ chứa ảnh khách. */
function locDiemAnh(g, w, h, filter) {
  const img = g.getImageData(0, 0, w, h);
  applyFilterPixels(img.data, filter);
  g.putImageData(img, 0, 0);
}

function drawArt(ctx, element, spec, tone, assets) {
  const image = assets[element.asset];
  if (!image) return;
  const box = boxToPixels(element.box, spec.design_size);
  ctx.save();
  rotateAbout(ctx, element.rotate, box);
  if (!element.tint) { ctx.drawImage(image, box.x, box.y, box.w, box.h); ctx.restore(); return; }
  // Asset tô màu phải là hình TRẮNG nền trong: phủ màu rồi giữ lại theo alpha của hình.
  const cell = document.createElement("canvas");
  cell.width = Math.max(1, Math.round(box.w));
  cell.height = Math.max(1, Math.round(box.h));
  const cellCtx = cell.getContext("2d");
  if (!cellCtx) return;
  cellCtx.drawImage(image, 0, 0, cell.width, cell.height);
  cellCtx.globalCompositeOperation = "source-in";
  cellCtx.fillStyle = resolveColour(element.tint, tone);
  cellCtx.fillRect(0, 0, cell.width, cell.height);
  ctx.drawImage(cell, box.x, box.y, box.w, box.h);
  ctx.restore();
}

/** Vẽ gì đó rồi CẮT THEO MẶT NẠ, trả về khung phụ đã cắt.
 *
 *  Đường cắt của ô ảnh không phải hình chữ nhật nên phải mượn kênh alpha của một file: vẽ ra
 *  khung phụ rồi giữ lại theo alpha của mặt nạ - `destination-in` chính là phép đó. Cắt thẳng
 *  bằng clip() không làm được vì clip chỉ nhận đường hình học.
 *
 *  Cả ảnh thật lẫn ô rỗng đều đi qua đây. Để ô rỗng tô thẳng hình chữ nhật là bốn góc thò ra
 *  ngoài viền tim thành một vệt mờ - đúng lỗi đã thấy trên trang bán hàng. */
function maskedCell(box, mask, paint) {
  const cell = document.createElement("canvas");
  cell.width = Math.max(1, Math.round(box.w));
  cell.height = Math.max(1, Math.round(box.h));
  const cellCtx = cell.getContext("2d");
  if (!cellCtx) return null;
  // save/restore BỌC LẤY paint, không phải để lịch sự: mặt nạ phải được vẽ trong hệ toạ độ RIÊNG
  // của ô. Hàm paint xoay ảnh mà không trả phép biến hình thì mặt nạ bị xoay theo - khung tim
  // nghiêng đi trong khi viền tim vẽ sau vẫn đứng, thành ra ảnh bị cắt lệch khỏi viền. Chốt ở đây
  // để không hàm paint nào làm hỏng được, chứ không đi sửa từng chỗ gọi.
  cellCtx.save();
  paint(cellCtx, { w: cell.width, h: cell.height });
  cellCtx.restore();
  cellCtx.globalCompositeOperation = "destination-in";
  cellCtx.drawImage(mask, 0, 0, cell.width, cell.height);
  return cell;
}

/** Xoay hệ toạ độ quanh TÂM hộp. Gọi trước khi dựng đường cắt thì cả khung xoay theo, gọi sau
 *  thì chỉ ruột xoay còn khung vẫn thẳng - hai kết quả khác hẳn nhau. Khung ảnh polaroid treo
 *  nghiêng cần kiểu thứ nhất. */
function rotateAbout(ctx, degrees, box) {
  if (!degrees) return;
  const cx = box.x + box.w / 2, cy = box.y + box.h / 2;
  ctx.translate(cx, cy);
  ctx.rotate((degrees * Math.PI) / 180);
  ctx.translate(-cx, -cy);
}

/** Nghiêng chữ quanh đường ngang giữa hộp: đỉnh chữ ngả sang phải, chân giữ nguyên bề ngang.
 *
 *  Khác `rotate` ở chỗ dòng chữ vẫn NẰM NGANG, chỉ từng nét đứng ngả đi - đúng cái mà chữ
 *  nghiêng (oblique) làm. Có nó là vì font gốc của mấy bản thiết kế Canva là font nghiêng bán
 *  riêng, tải về không được; font thay thế gần dáng nhất lại đứng thẳng. Nghiêng là phép biến
 *  hình thuần nên làm ngay ở đây rẻ hơn nhiều so với đi kiếm một font nghiêng sẵn mà dáng chữ
 *  lệch hẳn. */
function slantAbout(ctx, degrees, box) {
  if (!degrees) return;
  const cy = box.y + box.h / 2;
  ctx.translate(0, cy);
  ctx.transform(1, 0, -Math.tan((degrees * Math.PI) / 180), 1, 0, 0);
  ctx.translate(0, -cy);
}

// ── app/blanket-mockup.mjs ──────────────────────────────────────
// Ghép mockup thật cho Blanket ngay trong trình duyệt.
//
// Dữ liệu do scripts/build-blanket-mockup.mjs bóc ra từ smart object trong file PSD của
// nhà cung cấp, mỗi cảnh gồm ba tấm cùng kích thước:
//   uv    toạ độ trên khổ in, 16 bit mỗi trục (R,G = ngang · B,A = dọc)
//   gain  chênh lệch giữa lượt render thiết kế trắng và thiết kế đen
//   base  lượt render thiết kế đen, đã gồm cả phông nền và vật thể che phía trước
//
// Công thức ghép: kết_quả = thiết_kế[uv] * gain + base.
// Chỗ nào bị che hoặc nằm ngoài chăn thì gain bằng 0 nên base tự lộ ra, không cần mask riêng.

const BLANKET_MOCKUP_META = "/blanket-mockup/meta.json";
/** Bộ mockup cho chất liệu Sherpa - PSD riêng, cảnh riêng, không dùng chung với Fleece. */
const SHERPA_MOCKUP_META = "/sherpa-mockup/meta.json";
/** Hai chất liệu của cùng một sản phẩm; khoá là giá trị hiện trên option Style. */
const BLANKET_STYLES = [
  { key: "Fleece Blanket", meta: BLANKET_MOCKUP_META },
  { key: "Sherpa Blanket", meta: SHERPA_MOCKUP_META },
];

function blanketScenes(meta) {
  return meta?.scenes ?? [];
}

function blanketSceneByKey(meta, key) {
  return blanketScenes(meta).find((scene) => scene.key === key) ?? null;
}

/** Gộp hai byte thành toạ độ 0..1. Vì thế tấm uv phải lấy mẫu kiểu NEAREST: nội suy
 *  riêng từng byte sẽ nhảy bậy ngay chỗ byte cao đổi giá trị. */
function decodeUv(high, low) {
  return ((high << 8) | low) / 65535;
}

/** Đổi toạ độ khổ in sang pixel của khung thiết kế 800x800 mà studio đang vẽ. */
function designPixel(meta, u, v) {
  const rect = meta.print_rect;
  return [rect.x + u * rect.width, rect.y + v * rect.height];
}

/** Bản ghép thuần JS, dùng cho máy không có WebGL2 và cho test chạy trong Node. */
/** `designSize` là [rộng, cao] của khung thiết kế. Khung không nhất thiết vuông:
 *  fixture của nhà cung cấp là 800x800, còn Snuggle vẽ thẳng trên tờ in 2400x3250. */
/** Số lần lặp bản đồ hạt vải theo hai trục, tính từ kích thước THẬT của phôi chăn.
 *
 *  Đây là chỗ "đồng bộ với kích thước thật": một ô hạt ứng với `tile_mm` milimet vải, phôi rộng
 *  `print_width_mm`, nên số lần lặp ngang là thương của hai số đó. Trục dọc suy ra từ tỉ lệ
 *  khung thiết kế - lấy chung một số cho cả hai trục là hạt bị kéo dài theo chiều cao. */
function grainRepeats(meta) {
  const grain = meta.grain;
  if (!grain?.tile_mm || !meta.print_width_mm) return [1, 1];
  const [dw, dh] = meta.design_size;
  const across = meta.print_width_mm / grain.tile_mm;
  return [across, across * (dh / dw)];
}

/** Ép tờ in vào vùng an toàn của MỘT cảnh mốc, rồi dùng chung kết quả cho mọi cảnh.
 *
 *  Cảnh mốc là "nằm phẳng" - ảnh thấy gần trọn tấm chăn, người dựng lấy nó làm chuẩn. Mọi cảnh
 *  dùng CÙNG một print_rect nên thiết kế nằm đúng một chỗ trên vải ở cả ba ảnh.
 *
 *  CHỈ dùng cho bản xem trực tiếp, và chỉ khi người dùng tự bật `fit_to_scene` - mặc định tắt.
 *  Ép riêng theo từng cảnh cũng đã thử: thiết kế nhảy cỡ mỗi lần lật cảnh, mà tệ hơn là ép kiểu
 *  gì cũng phải THU tờ in lại cho lọt vào phần chăn nhìn thấy được, nên rìa chăn hở ra dải vải
 *  trơn - cảnh giường hở tới 23% mặt vải, trông như in thiếu.
 *
 *  Vì thế ảnh sản phẩm trên store ghép NGUYÊN KHỔ, không gọi hàm này. Chỗ nào cảnh đó che thì cứ
 *  để che - chụp tấm chăn in thật cũng ra đúng như vậy.
 *
 *  File in xuất ra thì không đụng tới trong cả hai kiểu.
 *
 *  Nhân một hệ số cho cả hai trục chứ không phải mỗi trục một hệ số: vùng an toàn cảnh phẳng
 *  rộng 0.958 cao 0.951, chia riêng là thiết kế bị kéo dãn theo chiều dọc. */
function fitPrintRectToReference(meta) {
  const rect = meta.print_rect;
  const safe = meta.safe_area?.per_scene?.[meta.safe_area?.reference_scene ?? "phang"];
  if (!safe) return rect;
  const scale = Math.max(1 / safe.width, 1 / safe.height);
  const width = rect.width * scale, height = rect.height * scale;
  return {
    x: rect.x + rect.width / 2 - (safe.x + safe.width / 2) * width,
    y: rect.y + rect.height / 2 - (safe.y + safe.height / 2) * height,
    width,
    height,
  };
}

/** Lặp gương một toạ độ 0..1: 1.2 thành 0.8, -0.3 thành 0.3. Ảnh vải không liền mạch nên lặp
 *  thẳng sẽ hiện đường kẻ ô; lật gương thì mép nối trùng chính nó, không thấy đường. */
function mirror(value) {
  const wrapped = value % 2, positive = wrapped < 0 ? wrapped + 2 : wrapped;
  return positive > 1 ? 2 - positive : positive;
}

function composeMockup({ meta, uv, gain, base, design, size, designSize, grain }) {
  // Cả ba bản đồ đánh chỉ số theo bước nhảy 4. Đưa vào mảng 3 kênh thì mọi pixel lệch dần và
  // ảnh ra méo xệch mà không có lỗi nào - kiểm độ dài ở đây để hỏng thì hỏng cho rõ ràng.
  for (const [name, buffer] of [["uv", uv], ["gain", gain], ["base", base]]) {
    if (buffer.length !== size * size * 4) {
      throw new Error(`${name} phải là RGBA ${size}x${size} (${size * size * 4} byte), đang có ${buffer.length}`);
    }
  }
  const out = new Uint8ClampedArray(size * size * 4);
  const [dw, dh] = designSize, rect = meta.print_rect, pad = meta.pad_colour ?? [255, 255, 255];
  for (let i = 0; i < size * size; i++) {
    const o = i * 4;
    const g = [gain[i * 4], gain[i * 4 + 1], gain[i * 4 + 2]];
    if (g[0] === 0 && g[1] === 0 && g[2] === 0) {
      out[o] = base[i * 4]; out[o + 1] = base[i * 4 + 1]; out[o + 2] = base[i * 4 + 2]; out[o + 3] = 255;
      continue;
    }
    const u = decodeUv(uv[i * 4], uv[i * 4 + 1]);
    const v = decodeUv(uv[i * 4 + 2], uv[i * 4 + 3]);
    const rawX = rect.x + u * rect.width, rawY = rect.y + v * rect.height;
    const dx = Math.min(dw - 1, Math.max(0, Math.round(rawX)));
    const dy = Math.min(dh - 1, Math.max(0, Math.round(rawY)));
    // Chạm ra ngoài tờ in thì là vải trơn. Kẹp về mép như mặc định là kéo dài hàng pixel biên
    // thành vệt sọc dọc - đúng lỗi thấy ở dải chăn vắt qua người trong cảnh giường.
    const outside = rawX < 0 || rawX > dw - 1 || rawY < 0 || rawY > dh - 1;
    const d = (dy * dw + dx) * 4;
    // Hạt vải: lấy theo toạ độ bề mặt (u, v) nên nó cong theo nếp gấp, và chỉ đắp lên phần là
    // vải - `cloth` tắt dần ở rìa vùng bị che, khỏi rắc hạt lên bàn tay hay thanh cũi.
    let factor = 1;
    if (grain?.strength) {
      const gx = Math.min(grain.size - 1, Math.floor(mirror(u * grain.repeat[0]) * grain.size));
      const gy = Math.min(grain.size - 1, Math.floor(mirror(v * grain.repeat[1]) * grain.size));
      const cloth = Math.min(1, Math.max(0, (Math.max(g[0], g[1], g[2]) / 255 - 0.01) / 0.07));
      factor = 1 + (grain.data[gy * grain.size + gx] / 255 - 0.5) * grain.strength * cloth;
    }
    for (let c = 0; c < 3; c++) out[o + c] = (((outside ? pad[c] : design[d + c]) / 255) * g[c] + base[i * 4 + c]) * factor;
    out[o + 3] = 255;
  }
  return out;
}

const VERTEX = `#version 300 es
in vec2 position;
out vec2 st;
void main() {
  st = vec2(position.x * 0.5 + 0.5, 0.5 - position.y * 0.5);
  gl_Position = vec4(position, 0.0, 1.0);
}`;

const FRAGMENT = `#version 300 es
precision highp float;
in vec2 st;
out vec4 colour;
uniform sampler2D uvMap;
uniform sampler2D gainMap;
uniform sampler2D baseMap;
uniform sampler2D designMap;
uniform sampler2D grainMap;
uniform vec4 printRect;   // x, y, rong, cao - tinh theo ti le cua khung thiet ke
uniform vec2 grainRepeat; // so lan lap hat vai theo hai truc, tinh tu kho in that
uniform float grainStrength;
uniform vec3 padColour;   // mau vai tron cho phan cham ra ngoai to in
void main() {
  vec4 packed = texture(uvMap, st);
  vec3 gain = texture(gainMap, st).rgb;
  vec3 base = texture(baseMap, st).rgb;
  float u = (packed.r * 255.0 * 256.0 + packed.g * 255.0) / 65535.0;
  float v = (packed.b * 255.0 * 256.0 + packed.a * 255.0) / 65535.0;
  vec2 designSt = printRect.xy + vec2(u, v) * printRect.zw;
  // Khi ep to in nho lai thi printRect tran ra ngoai [0,1]: cho nao cham ra ngoai phai la VAI
  // TRON. De mac dinh CLAMP_TO_EDGE thi hang pixel bien bi keo dai thanh vet soc doc.
  bool outside = designSt.x < 0.0 || designSt.x > 1.0 || designSt.y < 0.0 || designSt.y > 1.0;
  vec3 design = outside ? padColour : texture(designMap, designSt).rgb;
  vec3 lit = design * gain + base;
  // Hat vai lay theo toa do BE MAT (u,v), khong phai toa do man hinh: co vay no moi cong theo
  // nep gap va nho dan theo phoi canh. Chi dap len phan la vai - cho nao gain = 0 la vat the
  // che (ban tay, thanh cui), dap hat vai len do la sai hoan toan.
  float cloth = smoothstep(0.01, 0.08, max(gain.r, max(gain.g, gain.b)));
  float grain = texture(grainMap, vec2(u, v) * grainRepeat).r - 0.5;
  colour = vec4(lit * (1.0 + grain * grainStrength * cloth), 1.0);
}`;

function compile(gl, type, source) {
  const shader = gl.createShader(type);
  gl.shaderSource(shader, source);
  gl.compileShader(shader);
  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(shader) ?? "shader lỗi");
  return shader;
}

/** Trả về hàm vẽ, hoặc null nếu máy không có WebGL2 - lúc đó gọi bên gọi tự lùi về composeMockup. */
function createBlanketRenderer(canvas) {
  const gl = canvas.getContext("webgl2", { preserveDrawingBuffer: true, antialias: false });
  if (!gl) return null;

  const program = gl.createProgram();
  gl.attachShader(program, compile(gl, gl.VERTEX_SHADER, VERTEX));
  gl.attachShader(program, compile(gl, gl.FRAGMENT_SHADER, FRAGMENT));
  gl.linkProgram(program);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(program) ?? "link lỗi");
  gl.useProgram(program);

  const buffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
  const position = gl.getAttribLocation(program, "position");
  gl.enableVertexAttribArray(position);
  gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);

  const makeTexture = (unit, smooth) => {
    const texture = gl.createTexture();
    gl.activeTexture(gl.TEXTURE0 + unit);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    const filter = smooth ? gl.LINEAR : gl.NEAREST;
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filter);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    return texture;
  };
  // Tấm uv phải NEAREST, ba tấm còn lại nội suy được nên để LINEAR cho mượt.
  const textures = { uv: makeTexture(0, false), gain: makeTexture(1, true), base: makeTexture(2, true), design: makeTexture(3, true), grain: makeTexture(4, true) };
  for (const [name, unit] of [["uvMap", 0], ["gainMap", 1], ["baseMap", 2], ["designMap", 3], ["grainMap", 4]]) {
    gl.uniform1i(gl.getUniformLocation(program, name), unit);
  }
  // Hạt vải lặp lại nhiều lần nên phải cho phép tràn mép. Lật gương chứ không lặp thẳng: ảnh
  // vải tự sinh không liền mạch, lặp thẳng là hiện đường kẻ ô đều tăm tắp.
  gl.activeTexture(gl.TEXTURE0 + 4);
  gl.bindTexture(gl.TEXTURE_2D, textures.grain);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.MIRRORED_REPEAT);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.MIRRORED_REPEAT);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);

  const printRectLocation = gl.getUniformLocation(program, "printRect");
  const grainRepeatLocation = gl.getUniformLocation(program, "grainRepeat");
  const grainStrengthLocation = gl.getUniformLocation(program, "grainStrength");
  const padColourLocation = gl.getUniformLocation(program, "padColour");
  gl.uniform1f(grainStrengthLocation, 0);
  gl.uniform3f(padColourLocation, 1, 1, 1);

  const upload = (unit, texture, source) => {
    gl.activeTexture(gl.TEXTURE0 + unit);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, source);
  };

  return {
    setScene(images) {
      upload(0, textures.uv, images.uv);
      upload(1, textures.gain, images.gain);
      upload(2, textures.base, images.base);
    },
    setGrain(image) {
      upload(4, textures.grain, image);
      // Một ô hạt trải ra chỉ vài chục pixel màn hình, không có mipmap là nhiễu rung lăn tăn.
      gl.generateMipmap(gl.TEXTURE_2D);
    },
    draw(designCanvas, meta) {
      const rect = meta.print_rect, [dw, dh] = meta.design_size;
      upload(3, textures.design, designCanvas);
      gl.uniform4f(printRectLocation, rect.x / dw, rect.y / dh, rect.width / dw, rect.height / dh);
      const repeat = grainRepeats(meta);
      gl.uniform2f(grainRepeatLocation, repeat[0], repeat[1]);
      gl.uniform1f(grainStrengthLocation, meta.grain?.strength ?? 0);
      const pad = meta.pad_colour ?? [255, 255, 255];
      gl.uniform3f(padColourLocation, pad[0] / 255, pad[1] / 255, pad[2] / 255);
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    },
  };
}

// ── app/snuggle-ai.mjs ──────────────────────────────────────────
// ── AI Portrait: vẽ thú cưng bằng AI rồi nạp cutout vào slot ──────────────
// Spec: docs/superpowers/specs/2026-09-08-hakhatu-ai-portrait-design.md
//
// Phần THUẦN (test được bằng node) ở trên; phần chạm DOM/mạng ở dưới. Không có khoá `ai` trong
// config thì không hàm nào ở đây được gọi - bộ vẽ hành xử y như trước.

// Danh sách ĐÓNG CỨNG, cùng dạng với `SNUGGLE_GLYPH_SETS`: style nào backend `hk-ai` có thì tên
// phải thêm vào CUỐI mảng này, không thì bộ vẽ lọc mất và chip không hiện. Chỉ thêm tên - mỗi sản
// phẩm vẫn tự chọn trong `config.ai.styles`, nên thêm ở đây không đụng gì tới hàng đang bán.
const AI_STYLES = ["oil", "watercolour", "sketch", "scene"];
const AI_LABEL = { oil: "Oil painting", watercolour: "Watercolour", sketch: "Pencil sketch", scene: "Oil painting scene" };

function aiEnabled(config) {
  return !!(config?.ai?.api && aiStyles(config).length);
}

function aiStyles(config) {
  return (config?.ai?.styles ?? []).filter((s) => AI_STYLES.includes(s));
}

function aiProperties(r) {
  return { "AI Style": AI_LABEL[r.style], "AI Source": r.original_url, "AI Asset": r.cutout_url };
}

function pollPlan() { return { everyMs: 2000, maxTries: 45 }; }

/** Các chặng của một lượt vẽ, theo thứ tự, kèm khoảng phần trăm trên thanh tiến độ.
 *
 *  Backend không báo phần trăm, chỉ báo chặng (`gen` rồi `bg`). Nên trong một chặng, thanh nhích
 *  theo thời gian và chậm dần (`tau`, ms), không bao giờ tự chạm mép trên: không biết trước lúc
 *  xong thì đừng hứa là sắp xong. Qua chặng mới là nhảy lên mép dưới của chặng đó.
 *  Mốc đo 2026-09-17 (hk-ai/docs/tai.md): từ lúc có job tới lúc có tranh p50 18 s, chậm nhất 33 s;
 *  bước tải tranh, cất Files và tách nền mất ~7 s. */
const AI_CHANG = {
  prep: { tu: 0, den: 10, tau: 1500 },     // thu ảnh, lấy token Turnstile
  start: { tu: 10, den: 22, tau: 2500 },   // gửi ảnh, tạo job
  gen: { tu: 22, den: 82, tau: 7000 },     // Magnific vẽ
  bg: { tu: 82, den: 95, tau: 3000 },      // tách nền, cất Files
  apply: { tu: 95, den: 99, tau: 800 },    // nạp tranh vào khung
};

/** Câu hiện dưới thanh tiến độ, theo chặng. */
const AI_CHU_CHANG = {
  prep: "Getting your photo ready…",
  start: "Uploading your photo…",
  gen: "Painting your photo…",
  bg: "Cutting out the painting…",
  apply: "Placing it on your blanket…",
};

/** Phần trăm của thanh tiến độ khi đã ở chặng `chang` được `ms` mili giây.
 *
 *  Nhân 0.97: chờ lâu thì `1 - e^(-t/tau)` tròn thành đúng 1 trong số thực, thanh chạm mép trên rồi
 *  đứng im - trông như treo. Chừa 3% của chặng thì thanh vẫn còn chỗ để nhích. */
function aiPhanTram(chang, ms) {
  if (chang === "done") return 100;
  const c = AI_CHANG[chang];
  if (!c) return 0;
  return c.tu + (c.den - c.tu) * 0.97 * (1 - Math.exp(-Math.max(0, ms) / c.tau));
}

// ── phần chạm DOM / mạng ─────────────────────────────────────────────────────

/** Thu ảnh về cạnh dài ≤1024, JPEG 0.86, trả base64 (không có tiền tố data:). */
async function downscaleToBase64(file, max = 1024) {
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((ok, no) => { const i = new Image(); i.onload = () => ok(i); i.onerror = no; i.src = url; });
    const k = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
    const c = document.createElement("canvas");
    c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    const dataUrl = c.toDataURL("image/jpeg", 0.86);
    return dataUrl.slice(dataUrl.indexOf(",") + 1);
  } finally { URL.revokeObjectURL(url); }
}

/** Nạp Turnstile một lần, trả token mỗi lần gọi. Widget "execute": không hiện gì trừ khi bị nghi.
 *  `ts` giữ { id, resolve, reject } - callback của widget gọi vào cặp resolve/reject của LẦN gọi
 *  hiện tại, nên mỗi lần lấy token chỉ việc reset rồi execute lại cùng một widget. */
let tsWidget = null;
function turnstileToken(sitekey, mount, timeoutMs = 20000) {
  return new Promise((resolve, reject) => {
    // Không bao giờ treo: render ném, script không nạp, hay widget im lặng -> đều reject để khách
    // thấy thông báo và bấm lại được. Treo là chip mờ vĩnh viễn, tệ hơn mọi lỗi.
    const timer = setTimeout(() => finish(new Error("Please try again.")), timeoutMs);
    const finish = (err, token) => { clearTimeout(timer); err ? reject(err) : resolve(token); };
    const run = () => {
      try {
        // Panel dựng lại sau mỗi lượt (openDrawer) -> ô mount MỚI. Widget cũ bám vào ô đã rời DOM thì
        // im lặng không callback (đo thật: style thứ hai luôn "Please try again."). Mount đổi hoặc
        // rời DOM thì huỷ widget cũ, render lại lên ô mới.
        if (tsWidget && (tsWidget.mount !== mount || !document.contains(tsWidget.mount))) {
          try { window.turnstile.remove(tsWidget.id); } catch {}
          tsWidget = null;
        }
        if (!tsWidget) {
          const holder = { mount };
          holder.id = window.turnstile.render(mount, { sitekey, execution: "execute", appearance: "interaction-only",
            callback: (t) => holder.resolve?.(t),
            "error-callback": (code) => holder.reject?.(new Error(`Please try again. (${code ?? "turnstile"})`)),
            "expired-callback": () => holder.reject?.(new Error("Please try again.")) });
          if (holder.id == null) throw new Error("turnstile render");
          tsWidget = holder;
        } else {
          window.turnstile.reset(tsWidget.id);
        }
        tsWidget.resolve = (t) => finish(null, t); tsWidget.reject = (e) => finish(e);
        window.turnstile.execute(tsWidget.id);
      } catch (e) { finish(new Error("Please try again.")); }
    };
    if (window.turnstile) return run();
    const s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    s.async = true; s.onload = run; s.onerror = () => finish(new Error("Please try again."));
    document.head.appendChild(s);
  });
}

/** Gọi start rồi poll tới khi xong. onStage(chặng) báo chặng đang chạy - một khoá của `AI_CHANG`.
 *  Ném Error(message) khi hỏng. */
async function requestPortrait({ api, image, style, product, token, onStage = () => {} }) {
  onStage("start");
  const r = await fetch(`${api}/api/ai/start`, { method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ image, style, product, token }) });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) { const e = new Error(j.message ?? "AI is busy. Your photo is unchanged."); e.code = j.error; throw e; }
  if (j.done) return j;
  onStage("gen");
  const { everyMs, maxTries } = pollPlan();
  for (let i = 0; i < maxTries; i++) {
    await new Promise((ok) => setTimeout(ok, everyMs));
    const p = await fetch(`${api}/api/ai/job/${j.job_id}`);
    const pj = await p.json().catch(() => ({}));
    if (pj.stage === "done") return pj;
    if (pj.stage === "failed") throw new Error("AI could not paint this one. Your photo is unchanged.");
    onStage(pj.stage === "bg" ? "bg" : "gen");
  }
  throw new Error("AI is taking too long. Your photo is unchanged.");
}

// ── app/snuggle-anh.mjs ─────────────────────────────────────────
// Ảnh khách trước khi vào đơn: nén về đúng số điểm ảnh cần để in và tải lên ngầm lúc khách còn đang
// chỉnh, để bấm Add to cart không phải chờ tải cả chục MB.
//
// Đo 2026-09-19 trên trang thật (Photo Grid 8 ảnh, 4G 30/8 Mbps): tải 18,8 MB ảnh gốc mất 48,8 s sau
// khi bấm Add to cart. Thời gian chờ tỉ lệ gần thẳng với tổng MB: Shopify chỉ tốn ~0,3-0,5 s mỗi file.
// Bật bằng khoá `photo_upload` trong cấu hình sản phẩm: `{ dpi, api?, product? }`.

/** Khổ in lớn nhất của chăn Snuggle: 60 in ngang (60x80). Chiều cao suy từ tỉ lệ khung thiết kế. */
const KHO_IN_NGANG_IN = 60;

/** Cỡ ảnh cần để ô `box` (tỉ lệ 0..1 của khung thiết kế `designSize` [rộng, cao]) in đủ `dpi` khi ảnh
 *  PHỦ KÍN ô (zoom 1) trên khổ ngang `khoIn` inch.
 *
 *  Trả {w, h} nhỏ hơn ảnh gốc, giữ tỉ lệ; hoặc null khi ảnh gốc không dư điểm ảnh - khi đó giữ nguyên,
 *  không bao giờ phóng to. Khách phóng to ảnh trong ô (zoom > 1) thì độ nét giảm theo tỉ lệ zoom, như
 *  với ảnh gốc; ngưỡng 150 dpi là ở zoom 1 (người vận hành chọn 2026-09-19). */
function coCanIn(box, designSize, imgW, imgH, dpi = 150, khoIn = KHO_IN_NGANG_IN) {
  if (!box || !designSize || !(imgW > 0) || !(imgH > 0)) return null;
  const [DW, DH] = designSize;
  const canW = box.w * khoIn * dpi;
  const canH = box.h * khoIn * (DH / DW) * dpi;
  const k = Math.max(canW / imgW, canH / imgH);
  if (!(k > 0) || k >= 1) return null;
  return { w: Math.max(1, Math.ceil(imgW * k)), h: Math.max(1, Math.ceil(imgH * k)) };
}

/** Ảnh có điểm trong suốt không - dò trên bản thu nhỏ 48x48. PNG/WebP nền trong mà đổi sang JPEG là
 *  mất nền trong, trong khi ô xem trước vẽ nó đè lên nền chăn: in ra sẽ khác cái khách đã thấy. */
function coTrongSuot(img) {
  const c = document.createElement("canvas");
  c.width = 48; c.height = 48;
  const g = c.getContext("2d", { willReadFrequently: true });
  g.drawImage(img, 0, 0, 48, 48);
  const d = g.getImageData(0, 0, 48, 48).data;
  for (let i = 3; i < d.length; i += 4) if (d[i] < 250) return true;
  return false;
}

/** Vẽ lại ảnh khách ở cỡ `co` (hoặc giữ cỡ khi `co` null) rồi lưu JPEG.
 *
 *  `img` là ảnh ĐÃ NẠP cho ô xem trước (HTMLImageElement). Trình duyệt đã xoay theo EXIF lúc nạp, nên
 *  file nén ra đứng đúng chiều khách nhìn thấy; tự giải mã lại file thì Safari cũ có thể ra ảnh nằm
 *  ngang - xưởng in đúng tấm ảnh nằm. Lưu lại cũng bỏ luôn EXIF, kể cả toạ độ GPS của ảnh điện thoại.
 *
 *  Trả File mới, hoặc null = cứ gửi file gốc: định dạng lạ, ảnh trong suốt, khung vượt trần canvas của
 *  iPhone (~16,7 triệu điểm ảnh), nén xong không nhẹ hơn ít nhất `toiThieuGiam`, hết giờ, hoặc lỗi bất kỳ. */
async function nenAnh(img, file, co, { quality = 0.9, dienTichToiDa = 16_000_000, toiThieuGiam = 0.1, hetGio = 20000 } = {}) {
  try {
    if (!/^image\/(jpeg|png|webp)$/.test(file?.type ?? "")) return null;
    const w0 = img?.naturalWidth, h0 = img?.naturalHeight;
    if (!w0 || !h0) return null;
    if (file.type !== "image/jpeg" && coTrongSuot(img)) return null;
    const w = co?.w ?? w0, h = co?.h ?? h0;
    if (w * h > dienTichToiDa) return null;
    const c = document.createElement("canvas");
    c.width = w; c.height = h;
    const g = c.getContext("2d");
    g.imageSmoothingEnabled = true;
    g.imageSmoothingQuality = "high";
    if (file.type !== "image/jpeg") { g.fillStyle = "#fff"; g.fillRect(0, 0, w, h); }
    g.drawImage(img, 0, 0, w, h);
    const blob = await Promise.race([
      new Promise((xong) => c.toBlob(xong, "image/jpeg", quality)),
      new Promise((xong) => setTimeout(() => xong(null), hetGio)),
    ]);
    // Nhả bộ nhớ canvas ngay: iPhone tính trần bộ nhớ canvas cho cả trang, tám tấm 8 triệu điểm ảnh
    // giữ lại là chạm trần và canvas xem trước vẽ ra trắng.
    c.width = 0; c.height = 0;
    if (!blob || blob.size > file.size * (1 - toiThieuGiam)) return null;
    const ten = String(file.name || "photo").replace(/\.[a-z0-9]+$/i, "") + ".jpg";
    return new File([blob], ten, { type: "image/jpeg", lastModified: Date.now() });
  } catch {
    return null;
  }
}

/** Tải một ảnh lên hk-ai (`POST {api}/api/upload`), trả URL CDN của Shopify Files.
 *
 *  Dùng XMLHttpRequest vì fetch không báo tiến độ TẢI LÊN, mà con số tiến độ là thứ duy nhất cho khách
 *  biết trang không đơ. `onTienDo(0..1)`. Trả `{ lenh: Promise<url>, huy() }` - khách đổi ảnh khác thì
 *  huỷ lượt cũ, đừng để nó tải xong rồi ghi đè link của ảnh mới. */
function taiLenNgam(api, file, { product = "", slot = "", onTienDo, hetGio = 90000 } = {}) {
  const xhr = new XMLHttpRequest();
  const lenh = new Promise((xong, hong) => {
    const q = new URLSearchParams({ product, slot: String(slot), name: file?.name || "photo.jpg" });
    xhr.open("POST", `${String(api).replace(/\/+$/, "")}/api/upload?${q}`);
    xhr.timeout = hetGio;
    xhr.setRequestHeader("Content-Type", file?.type || "application/octet-stream");
    xhr.upload.onprogress = (e) => { if (e.lengthComputable && e.total) onTienDo?.(e.loaded / e.total); };
    xhr.onload = () => {
      let j = null;
      try { j = JSON.parse(xhr.responseText); } catch { /* thân không phải JSON */ }
      if (xhr.status === 200 && typeof j?.url === "string" && /^https:\/\//.test(j.url)) xong(j.url);
      else hong(Object.assign(new Error(j?.error ?? `upload ${xhr.status}`), { status: xhr.status }));
    };
    xhr.onerror = () => hong(new Error("network"));
    xhr.ontimeout = () => hong(new Error("timeout"));
    xhr.onabort = () => hong(Object.assign(new Error("abort"), { huy: true }));
    xhr.send(file);
  });
  return { lenh, huy: () => { try { xhr.abort(); } catch { /* đã xong */ } } };
}

// ── app/snuggle-embed.mjs ───────────────────────────────────────
// Bộ cá nhân hoá Snuggle nhúng vào trang sản phẩm Shopify.
//
// Dùng ĐÚNG renderSnuggle của studio - không vẽ lại lần thứ hai. Khách gõ chữ nào, kéo ảnh thế
// nào, thì cái họ thấy ở đây chính là cái file in sẽ ra, vì cùng một hàm vẽ trên cùng một spec.
//
// Giao diện theo lối bảng trượt: danh sách option ở cột phải, bấm một dòng thì một tấm trượt từ
// mép phải ra đè lên đúng cột đó. Tấm trượt KHÔNG che canvas - sửa chữ mà không nhìn thấy chăn
// đổi theo thì mất luôn lý do có bộ này.






/** Danh sách ô ảnh của khách, lấy từ cấu hình sản phẩm.
 *
 *  Layout 9 và 10 chỉ có MỘT ô nên cấu hình của chúng khai `config.photo` số ít. Layout 11 có sáu
 *  tấm polaroid nên khai `config.photos` số nhiều. Quy cả hai về một mảng ngay tại đây thì phần
 *  còn lại của bộ này chỉ có một đường đi - giữ hai nhánh song song là mỗi lần sửa phải nhớ sửa
 *  cả hai, mà nhánh một-ô thì không ai chạy lại để phát hiện. */
function photoSlots(config) {
  if (Array.isArray(config.photos) && config.photos.length) {
    return config.photos.map((item, i) => ({ ...item, slot: item.slot ?? i + 1 }));
  }
  return config.photo ? [{ ...config.photo, slot: config.photo.slot ?? 1 }] : [];
}

/** Ô ảnh thứ `slot` nằm ở lớp nào trong spec, và mang khoá gì trong danh sách option. */
const photoId = (slot) => `photo-${slot}`;
const photoKey = (slot) => `__photo:${slot}`;
const slotOfKey = (key) => Number(String(key).slice(8));

/** Khoá của dòng chọn bộ nền. */
const BG_KEY = "__background";

/** Chữ hiện ra khi khách chưa chọn ảnh. Vừa để đọc, vừa là mốc tô đỏ hàng còn thiếu - hai chỗ
 *  lệch nhau một chữ là hàng thiếu thôi không đỏ nữa mà chẳng ai thấy. */
const NO_PHOTO = "Not selected";

/** Hai câu cho ô cảnh báo. Tách ra vì cùng một ô dùng cho hai chuyện khác nhau. */
const WARN_MISSING = "Add your pet photo before you add this to the cart.";
const WARN_UNREADABLE = "We could not read that file. Please choose a JPG or PNG photo.";
const WARN_EMPTY_TEXT = "Fill in every line before you add this to the cart.";
const warnSample = (mau) => `“${mau}” is only a sample. Type your own before you add this to the cart.`;

/** Bản nháp giữ trong máy khách. Không giữ ẢNH: một tấm ảnh điện thoại đã vượt hạn mức ~5MB của
 *  localStorage, mà nhét vào là hỏng luôn cả bản nháp lẫn mọi thứ khác đang lưu cùng tên miền. */
const DRAFT_KEY = "snuggle-draft";
const DRAFT_DAYS = 7;

/** Sàn và trần của thanh Zoom.
 *
 *  1× là mức ảnh vừa đúng phủ kín ô. Nhỏ hơn 1× là hở ra lớp nằm dưới, và với ô có MẶT NẠ (trái
 *  tim của layout 9, 10) chỗ hở đó là một mảng trống hình lưỡi liềm trong lòng tim - nhìn ra ngay
 *  là hỏng. Nên mặc định vẫn là 1.
 *
 *  Ô ảnh hình chữ nhật thì khác: chỗ hở là một dải kem đều bốn phía nằm trong viền trắng polaroid,
 *  trông như tấm ảnh có pass-partout. Layout nào chấp nhận được thì hạ sàn qua `config.zoom_min` -
 *  đổi lại khách lồng được trọn con vật vào khung thay vì bắt buộc phải cắt. */
const MIN_ZOOM_MAC = 1;
const MAX_ZOOM = 3;

/** Khoá của một ô: `key` là id trong spec studio, `property` là tên hiện trong giỏ và trong đơn.
 *  Cấu hình cũ chưa có `key` thì lấy tạm `property` - vẫn chạy, chỉ là chữ không nối được vào
 *  đúng ô của bộ vẽ nên xem trước sẽ giữ nguyên chữ mặc định. */
const keyOf = (field) => field.key ?? field.property;

/** Ô chữ còn để nguyên CHỮ MẪU hay không.
 *
 *  Ô khai `sample: true` thì chữ mặc định chỉ để tấm chăn xem trước trông trọn vẹn, không phải chữ
 *  để in. Layout 23 để sẵn "Toby & Sparky" làm giá trị thật của ô tên, mà bộ chặn mua cũ chỉ chặn
 *  ô TRỐNG: khách tải ảnh lên rồi bấm mua luôn là đơn về với "Toby & Sparky".
 *
 *  `daGo` là các ô khách đã tự gõ. Gõ lại đúng chữ mẫu vẫn tính là của khách - có người nuôi đúng
 *  Toby và Sparky. */
function conChuMau(field, value, daGo) {
  return !!field.sample && !daGo.has(keyOf(field)) && (value ?? "") === (field.default ?? "");
}

/** Hạ `v` xuống nấc gần nhất của thanh trượt bắt đầu từ `san`, bước `buoc`.
 *
 *  Hạ XUỐNG chứ không làm tròn: dùng cho zoom "vừa khít" của tranh AI, làm tròn lên là tranh lại
 *  bị cắt mép. Nhưng chừa sai số một phần nghìn nấc: tranh 3:4 vào ô 2400×3200.015 tính ra
 *  0.999995, hạ thẳng là rớt hẳn xuống 0.9 (đo thật 2026-09-17). Làm tròn 3 chữ số để 0.1 + 0.2
 *  không ra 0.30000000000000004 trên nhãn. */
function nacXuong(v, buoc, san) {
  const k = Math.floor((v - san) / buoc + 1e-3);
  return Math.round(Math.max(san, san + k * buoc) * 1000) / 1000;
}

/** Phần tử này có phải ô GIÁ của sản phẩm đang xem không - xem `doiGia`.
 *
 *  Phải nằm trong một khối có "price" trong tên class. Không được nằm trong bảng: mô tả và tab Size
 *  Guide có bảng giá của mọi cỡ, trùng số là bị sửa theo - đo thật 2026-09-17, "$39.95" của Sherpa
 *  30x40 trong bảng thành "$29.95" khi khách chuyển từ Sherpa sang Fleece. Cũng không được nằm trong
 *  thẻ của sản phẩm khác (gợi ý mua kèm): cùng giá là cùng bị đổi. */
function laOGiaSanPham(node) {
  return !!node.closest('[class*="price"]') && !node.closest('table, [class*="card"], [class*="recommend"]');
}

/** Gom các ô nhập thành từng DÒNG option.
 *
 *  Ô nào khai cùng `group` và nằm liền nhau thì chung một dòng, mở ra là một tấm trượt chứa đủ
 *  mấy ô đó. Ba dòng tiêu đề là một khối người ta đọc liền mạch - tách thành ba dòng riêng thì
 *  khách phải mở ba lần mới sửa xong một câu, mà mỗi lần lại chỉ thấy một mẩu. */
function optionRows(config) {
  const out = [];
  for (const field of config.fields ?? []) {
    const last = out[out.length - 1];
    if (field.group && last?.group === field.group) { last.fields.push(field); continue; }
    out.push({
      key: field.group ? `group:${field.group}` : keyOf(field),
      label: field.group ?? field.label,
      group: field.group,
      fields: [field],
    });
  }
  return out;
}

function mountSnuggleEmbed(root, options = {}) {
  const config = options.config ?? JSON.parse(root.dataset.config || "{}");
  // Asset của theme Shopify nằm phẳng một thư mục và URL có kèm mã phiên bản, không ghép được từ
  // đường dẫn trong spec. Nên nhận thẳng một bảng tra: đường dẫn trong spec -> URL thật.
  const urls = options.urls ?? JSON.parse(root.dataset.urls || "{}");
  const specUrl = options.spec ?? root.dataset.spec;
  const form = options.form ?? root.closest("form") ?? document.querySelector('form[action*="/cart/add"]');
  if (!specUrl || !form) return null;

  const SLOTS = photoSlots(config);
  const MIN_ZOOM = Math.min(MAX_ZOOM, Math.max(0.3, config.zoom_min ?? MIN_ZOOM_MAC));
  // `photo_panel`: giao diện mới của tấm trượt ảnh (layout 23). Không khai thì y như cũ.
  //   zoom_min_ai - sàn zoom khi ô đang có tranh AI (mặc định 0.1)
  //   steps       - { zoom, pan, spin }: thanh trượt nhảy theo nấc
  //   art         - thẻ "Turn it into art" thay cho hàng chip nhỏ, có thanh tiến độ
  const PP = config.photo_panel ?? null;
  const AI_MIN_ZOOM = Math.min(MAX_ZOOM, Math.max(0.1, PP?.zoom_min_ai ?? 0.1));
  const BUOC = PP?.steps ?? null;
  // Câu nhắc thiếu ảnh. Mặc định nói "pet photo" (các chăn thú cưng); layout 23 nhận cả người nên khai
  // `photo_panel.missing_photo` riêng.
  const warnMissing = PP?.missing_photo ?? WARN_MISSING;
  const state = {
    tone: toneByKey(options.tone ?? "beige"),
    printWidthMm: 1524,
    fields: {},
    photos: {},
    edits: {},
    background: config.background?.default ?? config.backgrounds?.[0]?.key ?? "",
    ai: {},   // theo slot: { style, cutout_url, original_url } | undefined  (undefined = ảnh gốc)
  };
  const assets = {};
  let spec = null;
  /** Ảnh khách đã chọn, theo số ô. Chỉ sống trong phiên xem trước - bản gửi đi là file gốc nằm
   *  trong ô upload của form. */
  const photoUrls = {};
  /** Ảnh gốc khách chọn, theo slot - giữ để bấm "Original" là quay lại không gọi mạng. */
  const originalFiles = {};
  /** Ô ảnh đang mở ngăn kéo. Kéo tay, ba thanh trượt và lớp gợi ý đều nhắm vào ô này. */
  let activeSlot = SLOTS[0]?.slot ?? 1;
  // Hẹn giờ dựng ảnh xem trước. Phải khai Ở ĐÂY, trên `return` của hàm: phần dưới `return` chỉ
  // được phép là khai báo `function` (trình duyệt cẩu lên trước). Một dòng `let` đặt dưới đó
  // không bao giờ chạy và kẹt luôn ở vùng chết - gọi tới là văng, mà văng lặng lẽ trong hàm async.
  let previewTimer = 0;
  let warpTimer = 0;
  let sliders = {};      // ba thanh phóng/dịch, để kéo tay xong chúng chạy theo
  let gapWarn = null;    // cảnh báo "khung bị hở" của ô đang chỉnh (không chặn, chỉ báo)
  let draftTimer = 0;
  let paintPending = false;   // gộp nhiều lần kéo về một khung hình
  let warper = null;      // bộ ghép mockup WebGL, có thì mới bọc được thiết kế lên chăn thật
  let sceneMeta = null;
  let cuonCu = "";      // giá trị overflow của body trước khi mở khung xem to
  // Ảnh đang hiện trong khung xem to. Thu hồi khi đóng - mỗi lần mở là một tấm vài trăm KB, không
  // thu hồi thì mở ra đóng vào chục lần là ngốn cả trăm MB.
  //
  // Khai Ở ĐÂY chứ không phải dưới `return`: phần dưới đó chỉ được phép có khai báo `function`
  // (trình duyệt cẩu lên trước). Một dòng `let` đặt dưới đó không bao giờ chạy, kẹt luôn ở vùng
  // chết, và hàm nào đụng vào nó là văng.
  let toUrl = "";
  let scenePack = null;    // giữ để trả khung về đúng tỉ lệ sau khi thôi chỉnh ảnh
  /** Ô chữ khách đã tự gõ, theo khoá ô - xem `conChuMau`. */
  const daGo = new Set();
  /** Lượt vẽ AI đang chạy, theo slot: { style, chang, tChang, max }. Để NGOÀI panel: panel dựng
   *  lại mỗi lần mở ngăn kéo, mà dựng lại mất thanh tiến độ thì khách tưởng hỏng rồi bấm vẽ lần
   *  nữa - tốn thêm một lượt trong 5 lượt/ngày của họ. */
  const dangVe = {};
  /** Câu báo sau lượt vẽ gần nhất, theo slot: { text, kind: "ok" | "loi", het }. */
  const tinVe = {};
  let tienTimer = 0;
  /** Khoá của dòng đang mở ngăn kéo, "" khi đóng. Vẽ xong chỉ dựng lại panel nếu khách còn ở đó. */
  let moDangMo = "";
  /** URL ảnh GỐC của từng slot, để thẻ "Original" vẫn có ảnh khi ô đã mang tranh AI. */
  const anhGoc = {};
  /** `photo_panel`-kiểu cho ảnh khách: nén về số điểm ảnh cần in, và (có `api`) tải lên ngầm - xem
   *  ve/snuggle-anh.mjs. Không khai thì y như cũ: file gốc đi thẳng vào form. */
  const PU = config.photo_upload ?? null;
  /** Theo slot: { trangThai: "nen" | "dang" | "xong" | "loi", pt: 0..1, url, huy }. */
  const taiNgam = {};
  /** Lượt bấm mua đang chờ ảnh tải xong: { nut, html, hen } | null. */
  let choMua = null;

  const ui = build(root, config);
  // "Hiện hết" (2026-09-25, khoá `show_all` trong snuggle_fields): mọi khung chỉnh (ảnh, nền, chữ) hiện sẵn
  // thành các mục xếp dọc, khách thấy hết lựa chọn mà không phải bấm từng dòng mở tấm trượt. Các hàm dựng
  // panel giữ nguyên; `openDrawer` lúc này chỉ dựng lại MỤC của bước đó. `ui.body` trỏ vào khối các mục
  // để mọi chỗ tra panel (thanh tiến độ vẽ AI…) vẫn tìm thấy.
  const HIEN_HET = !!config.show_all;
  const mucBuoc = new Map();
  if (HIEN_HET) {
    root.classList.add("sng-hien-het");
    ui.body = el("div", "sng-muc-list");
    ui.rows.after(ui.body);
    if (!document.getElementById("sng-hien-het-css")) {
      const css = el("style");
      css.id = "sng-hien-het-css";
      css.textContent = [
        ".sng-hien-het .sng-rows,.sng-hien-het .sng-scrim,.sng-hien-het .sng-drawer{display:none!important}",
        ".sng-muc-list{display:grid;gap:10px}",
        ".sng-muc{display:grid;gap:10px;padding:12px;border:1px solid rgba(0,0,0,.14);border-radius:12px;background:#fff;min-width:0}",
        ".sng-muc__title{font-size:1.3rem;font-weight:700}",
      ].join("");
      document.head.append(css);
    }
  }
  ui.rows.addEventListener("click", (event) => {
    const row = event.target.closest("[data-key]");
    if (row) openDrawer(row.dataset.key);
  });
  ui.close.addEventListener("click", closeDrawer);
  ui.scrim.addEventListener("click", closeDrawer);
  ui.zoom.addEventListener("click", moToLen);
  ui.lightClose.addEventListener("click", dongToLen);
  // Bấm ra nền tối cũng đóng - nhưng chỉ khi bấm trúng CHÍNH cái nền, không phải bấm vào ảnh.
  ui.lightbox.addEventListener("click", (event) => { if (event.target === ui.lightbox) dongToLen(); });
  document.addEventListener("keydown", (event) => { if (event.key === "Escape") dongToLen(); });
  if (ui.tiles) {
    for (const [slot, o] of ui.tiles) o.node.addEventListener("click", () => openDrawer(photoKey(slot)));
  }

  /** Đổi ảnh và vẽ lại. Gọi sau MỌI thay đổi, kể cả lúc mới nạp xong. */
  const draw = () => {
    if (!spec) return;
    napNenDangChon();
    renderSnuggle(ui.ctx, spec, state, assets);
    paintGhost();
    capNhatHoMep();
    scheduleWarp();
    schedulePreview();
    scheduleDraft();
  };

  donOFile();
  guardBuy();
  guardVariant();
  enableDrag();
  start();
  return { draw, get spec() { return spec; } };

  async function start() {
    spec = await (await fetch(specUrl)).json();
    ui.canvas.width = spec.design_size[0];
    ui.canvas.height = spec.design_size[1];
    ui.stage.style.aspectRatio = `${spec.design_size[0]} / ${spec.design_size[1]}`;
    // Lớp gợi ý vẽ ở khổ NHỎ (chia 3): nó chỉ để khách ước lượng đầu đuôi con vật nằm đâu, vẽ nó
    // ở khổ in trong lúc kéo là phí sạch một phần ba khung hình.
    ui.ghost.width = Math.round(spec.design_size[0] / 3);
    ui.ghost.height = Math.round(spec.design_size[1] / 3);

    for (const field of spec.fields ?? []) state.fields[field.id] = field.default ?? "";
    restoreDraft();
    syncInputs();
    // Dòng tóm tắt dựng sẵn bằng chữ mặc định; vẽ lại ngay để ô chữ mẫu hiện đúng dấu "sample".
    refreshRows();
    if (HIEN_HET) dungHienHet();

    // Ảnh nền và lớp hoạ tiết đi qua CDN của Shopify nên đã được nén và resize sẵn; ở đây chỉ
    // việc nạp. Mặt nạ thì KHÔNG resize - nó là kênh alpha, thu nhỏ là mép tim răng cưa.
    // Nền: chỉ bộ ĐANG CHỌN; các bộ khác nạp sau (napNenConLai) hoặc khi khách chọn (draw).
    const nenTatCa = new Set(backgroundOptionUrls(spec));
    const nenNgay = new Set(urlNenCua(state.background));
    await Promise.all([...assetUrls(spec)].filter((url) => !nenTatCa.has(url) || nenNgay.has(url)).map(async (url) => {
      const at = urls[url];
      if (!at) throw new Error(`thiếu URL cho asset ${url}`);
      assets[url] = await loadImage(urlNhe(at));
    }));
    await loadFonts(spec);
    draw();
    root.classList.add("is-ready");
    suKien("sng_ready", { ms: Math.round(performance.now()) });
    // Bộ bản đồ warp nạp SAU khi tấm thiết kế đã hiện. Nó nặng hơn 1MB; chờ nó rồi mới vẽ là
    // khách nhìn ô trống mất mấy giây, mà thứ họ cần thấy trước tiên chỉ là thiết kế của mình.
    await loadScene();
    napNenConLai();
  }

  /** Bọc tấm thiết kế lên chăn thật. Không có WebGL2 hoặc thiếu bộ bản đồ thì cứ để nguyên tấm
   *  phẳng - vẫn đúng thiết kế, chỉ là không có nếp vải. */
  async function loadScene() {
    const sceneUrl = root.dataset.scene;
    if (!sceneUrl || !urls) return;
    try {
      const pack = await (await fetch(sceneUrl)).json();
      const at = (file) => urls[file] ?? file;
      const [uv, gain, base, grain] = await Promise.all([
        loadImage(at(pack.files.uv)), loadImage(at(pack.files.gain)), loadImage(at(pack.files.base)),
        pack.grain ? loadImage(at(pack.grain.file)) : null,
      ]);
      ui.mockup.width = pack.size[0];
      ui.mockup.height = pack.size[1];
      warper = createBlanketRenderer(ui.mockup);
      warper.setScene({ uv, gain, base });
      if (grain) warper.setGrain(grain);
      // Tờ in phủ TRỌN tấm thiết kế: `print_rect` của bộ mockup gốc tính cho fixture 800×800 của
      // nhà cung cấp, còn Snuggle vẽ thẳng trên tờ in 2400×3250.
      //
      // Phần chăn ngoài tờ in để TRẮNG, không phải màu nền thiết kế: chỗ đó rút gọn còn gain+base,
      // tức là đúng tấm vải chưa in - nhờ vậy mép chăn hiện thành viền không in như mockup thật.
      sceneMeta = {
        ...pack,
        design_size: spec.design_size,
        print_rect: { x: 0, y: 0, width: spec.design_size[0], height: spec.design_size[1] },
        pad_colour: [255, 255, 255],
      };
      scenePack = pack;
      cropToBlanket(pack);
      warp();
      root.classList.add("is-real");
    } catch {
      warper = null;   // im lặng lùi về tấm phẳng, đừng chặn khách mua hàng vì một cái mockup
    }
  }

  /** Cắt khung xem sát mép chăn.
   *
   *  Ảnh cảnh là ảnh VUÔNG chụp chăn nằm trên nền, chăn chỉ chiếm 68%×88% khung - bày nguyên ảnh
   *  là hai phần ba khung dành cho chỗ trống, mà chỗ trống thì không bán được cho ai.
   *
   *  Cắt bằng cách phóng canvas to hơn khung rồi kéo lệch đi, chứ không vẽ lại vào canvas nhỏ:
   *  bộ vẽ mockup cần đủ cả ảnh cảnh mới dựng được nếp vải. Khung `overflow:hidden` lo phần xén. */
  function cropToBlanket(pack) {
    const rect = pack.blanket_rect;
    if (!rect) {
      ui.stage.style.aspectRatio = pack.size[0] + " / " + pack.size[1];
      return;
    }
    ui.stage.style.aspectRatio = `${pack.size[0] * rect.width} / ${pack.size[1] * rect.height}`;
    ui.mockup.style.position = "absolute";
    ui.mockup.style.width = `${100 / rect.width}%`;
    ui.mockup.style.height = `${100 / rect.height}%`;
    ui.mockup.style.left = `${(-rect.x / rect.width) * 100}%`;
    ui.mockup.style.top = `${(-rect.y / rect.height) * 100}%`;
  }

  function scheduleWarp() {
    if (!warper) return;
    clearTimeout(warpTimer);
    warpTimer = setTimeout(warp, 160);
  }

  function warp() {
    if (!warper || !sceneMeta) return;
    warper.draw(ui.canvas, sceneMeta);
  }

  /** Đường dẫn (trong spec) mọi asset của một bộ nền; khoá lạ thì rơi về bộ đầu như boNen. */
  function urlNenCua(key) {
    const ds = spec?.background_options ?? [];
    const bo = ds.find((b) => b.key === key) ?? ds[0];
    if (!bo) return [];
    return [bo.background, ...Object.values(bo.patch ?? {}).map((p) => p?.asset)].filter(Boolean);
  }

  /** Màn hẹp: ảnh 1600px đổi sang 1000px - khung xem trên điện thoại chỉ ~1050 px thiết bị. */
  function urlNhe(u) {
    return typeof matchMedia === "function" && matchMedia("(max-width: 767.98px)").matches
      ? String(u).replace(/_1600x\.(png|jpe?g|webp)(?=[?#]|$)/i, "_1000x.$1") : u;
  }

  /** Nền đang chọn chưa nạp thì nạp rồi vẽ lại. Gọi từ draw() nên mọi đường đổi nền đều đi qua. */
  function napNenDangChon() {
    const dang = (napNenDangChon.dang ??= new Set());
    const can = urlNenCua(state.background).filter((u) => !assets[u] && urls[u] && !dang.has(u));
    if (!can.length) return;
    for (const u of can) dang.add(u);
    Promise.all(can.map(async (u) => {
      try { assets[u] = await loadImage(urlNhe(urls[u])); } finally { dang.delete(u); }
    })).then(() => draw()).catch(() => {});
  }

  /** Nạp dần (tuần tự, không tranh băng thông) các bộ nền chưa có, để đổi màu là hiện ngay. */
  async function napNenConLai() {
    if (navigator.connection?.saveData) return;
    for (const u of backgroundOptionUrls(spec)) {
      if (assets[u] || !urls[u]) continue;
      try { assets[u] = await loadImage(urlNhe(urls[u])); } catch {}
    }
  }

  function assetUrls(source) {
    const urls = new Set();
    if (source.background?.asset) urls.add(source.background.asset);
    for (const element of source.elements) {
      if (element.asset) urls.add(element.asset);
      if (element.mask) urls.add(element.mask);
    }
    for (const url of glyphAtlasUrls(source)) urls.add(url);
    // Asset của MỌI bộ nền, không chỉ bộ đang chọn: khách bấm đổi nền là hiện ngay, không chớp
    // một nhịp trống. Thiếu thì bộ vẽ tra `assets[url]` không thấy gì rồi lặng lẽ bỏ qua lớp đó.
    for (const url of backgroundOptionUrls(source)) urls.add(url);
    return urls;
  }

  /** document.fonts.ready CHỈ chờ font đã có ai đó yêu cầu. Font khai trong @font-face mà chưa
   *  chỗ nào dùng thì nó coi như xong ngay, canvas vẽ bằng font hệ thống - chữ vẫn ra, chỉ sai
   *  kiểu và sai bề rộng, nhìn qua tưởng bố cục hỏng. */
  async function loadFonts(source) {
    if (!document.fonts?.load) return;
    const faces = new Set();
    const glyphs = source.elements.filter((e) => e.type === "text").map((e) => e.text).join(" ");
    for (const element of source.elements) {
      // Dòng vẽ bằng bộ glyph ảnh vẫn khai `font` để tra ngưỡng nét mảnh lúc soát bản in, nhưng
      // không có face nào để nạp - xin trình duyệt nạp "Sailors" là chờ một lời hứa chắc chắn hỏng.
      if (element.type !== "text" || !element.font || element.glyphs) continue;
      faces.add(`${element.weight ? `${element.weight} ` : ""}100px "${element.font}"`);
    }
    await Promise.all([...faces].map((face) => document.fonts.load(face, glyphs).catch(() => {})));
  }

  // ── ô nhập ẩn của giỏ hàng ─────────────────────────────────────────────────
  // Giá trị thật gửi lên Shopify nằm ở đây chứ không ở tấm trượt: tấm trượt đóng lại là DOM của
  // nó biến mất, còn dòng chữ thì vẫn phải theo đơn hàng ra xưởng in.
  /** Ô của form mang tên `properties[...]`, tạo mới nếu chưa có.
   *
   *  Tìm theo TÊN chứ không theo thẻ `input`: ô chọn nền do snippet liquid in ra là một `<select>`
   *  (để đường không-js vẫn chọn được). Chỉ tìm `input` thì hàm này không thấy nó, tự dựng thêm
   *  một ô ẩn trùng tên - form có hai ô cùng tên, và cái đi vào đơn hàng lại là cái CŨ: khách bấm
   *  Blush Pink, chăn đổi sang hồng ngay trước mắt, mà giỏ hàng vẫn ghi Sky Blue. */
  function inputFor(property) {
    const name = `properties[${property}]`;
    let input = form.querySelector(`[name="${cssEscape(name)}"]`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }
    return input;
  }

  /** Ô upload ẩn cho ảnh xem trước. Không đặt `required` - ảnh này do máy dựng, thiếu nó thì đơn
   *  vẫn phải đi được. */
  function previewInput() {
    const name = "properties[Preview]";
    let input = form.querySelector(`input[name="${cssEscape(name)}"]`);
    if (!input) {
      input = document.createElement("input");
      input.type = "file";
      input.name = name;
      input.hidden = true;
      form.appendChild(input);
    }
    return input;
  }

  // ── ảnh xem trước gửi kèm giỏ hàng ─────────────────────────────────────────
  // Theme đọc `properties[Preview]` làm ảnh của dòng giỏ hàng, và ảnh đó theo luôn vào đơn: xưởng
  // in mở đơn ra là thấy đúng tấm khách đã dựng, khỏi phải tự ghép lại từ mấy dòng chữ rời.
  //
  // Dựng SẴN sau mỗi lần vẽ chứ không đợi lúc bấm Thêm vào giỏ: `toBlob` là bất đồng bộ mà nút
  // thêm vào giỏ gửi form ngay - chờ không kịp thì đơn về không có ảnh nào.
  function schedulePreview() {
    clearTimeout(previewTimer);
    previewTimer = setTimeout(attachPreview, 500);
  }

  async function attachPreview() {
    if (!spec || typeof DataTransfer !== "function") return;
    const width = 900;
    const small = document.createElement("canvas");
    small.width = width;
    small.height = Math.round((width * ui.canvas.height) / ui.canvas.width);
    small.getContext("2d")?.drawImage(ui.canvas, 0, 0, small.width, small.height);
    const blob = await new Promise((done) => small.toBlob(done, "image/jpeg", 0.86));
    if (!blob) return;
    const data = new DataTransfer();
    data.items.add(new File([blob], `${spec.id}-preview.jpg`, { type: "image/jpeg" }));
    previewInput().files = data.files;

    // Ô bắt đầu bằng dấu gạch dưới thì Shopify GIẤU khỏi giỏ và trang thanh toán nhưng vẫn giữ
    // trong đơn. Chỗ này ghi đủ thứ cần để dựng lại file in y hệt, kể cả những thứ không hiện
    // thành chữ: bộ lọc màu, và ảnh khách đã kéo/phóng bao nhiêu trong khung tim.
    inputFor("_Snuggle").value = JSON.stringify({
      layout: spec.id,
      tone: state.tone?.key,
      // Chỉ ghi khi layout có option nền, để đơn của layout cũ không mọc thêm một khoá rỗng.
      ...(state.background ? { background: state.background } : {}),
      // Ghi TỪNG ô một: sáu tấm polaroid kéo, phóng và chọn tông khác nhau - gộp một cụm là mất sạch.
      photos: Object.fromEntries(SLOTS.map((one) => {
        const p = state.edits[photoId(one.slot)] ?? {};
        return [one.slot, { zoom: p.zoom ?? 1, pan_x: p.pan_x ?? 0, pan_y: p.pan_y ?? 0, spin: p.spin ?? 0,
          filter: p.filter ?? "none", ...(state.ai[one.slot] ? { ai: state.ai[one.slot] } : {}) }];
      })),
      fields: state.fields,
    });
  }

  function syncInputs() {
    if (config.filter?.property) inputFor(config.filter.property).value = tomTatTone();
    if (config.background?.property) inputFor(config.background.property).value = bgLabel(state.background);
    for (const field of config.fields ?? []) {
      inputFor(field.property).value = state.fields[keyOf(field)] ?? "";
    }
    syncAiInputs();
  }

  // ── danh sách option ───────────────────────────────────────────────────────
  // Khai bằng `function` chứ không phải `const`: `start()` chạy ngay lúc mount và gọi
  // `syncInputs()`, mà chỗ đó cần hai hàm này - viết `const` là rơi vào vùng chết, mount hỏng
  // ngay từ dòng đầu và cả bộ không hiện.
  /** Tông màu của MỘT ô ảnh. */
  function filterOf(slot) { return state.edits[photoId(slot ?? SLOTS[0]?.slot ?? 1)]?.filter ?? "none"; }

  function setFilter(key, slot) {
    const at = photoId(slot ?? activeSlot);
    (state.edits[at] ?? (state.edits[at] = {})).filter = key;
  }

  /** Một dòng chữ cho giỏ hàng, tóm tắt tông màu của mọi ô.
   *
   *  Tông là của TỪNG ô, mà giỏ hàng chỉ có một ô chữ để ghi - nên phải gói lại. Mọi ô cùng một
   *  tông thì ghi đúng tên tông đó (gần như luôn là trường hợp này, và cũng là mọi trường hợp của
   *  sản phẩm một ảnh). Khác nhau thì kể ra từng ô.
   *
   *  Dữ liệu đầy đủ cho xưởng in nằm ở ô ẩn `_Snuggle` dưới dạng JSON; dòng này là để NGƯỜI đọc. */
  function tomTatTone() {
    const ds = SLOTS.map((one) => filterOf(one.slot));
    if (ds.every((k) => k === ds[0])) return filterLabel(ds[0]);
    return SLOTS.map((one, i) => `Photo ${one.slot}: ${filterLabel(ds[i])}`).join(" · ");
  }
  /** Nhãn tiếng Anh của bộ nền, để ghi vào giỏ. Ghi khoá thô ("blush") thì xưởng in đọc không ra. */
  function bgLabel(key) {
    const item = (config.backgrounds ?? []).find((one) => one.key === key);
    return item?.en ?? item?.label ?? key ?? "";
  }
  /** Ô ảnh đầu tiên còn trống, hoặc `null` nếu đã đủ. */
  function missingPhoto() { return SLOTS.find((one) => !photoUrls[one.slot]) ?? null; }
  function filterLabel(key) {
    const item = SNUGGLE_PHOTO_FILTERS.find((one) => one.key === key);
    return item?.en ?? item?.label ?? key;
  }

  // Hàm khai báo chứ không phải `const`, vì cùng lý do với hai hàm trên: mount gọi tới trước khi
  // dòng khai báo chạy. Năm dòng option nên tính lại mỗi lần cũng không tốn gì.
  function rowByKey(key) { return optionRows(config).find((row) => row.key === key); }

  function valueOf(key) {
    if (key.startsWith("__photo")) return photoUrls[slotOfKey(key)] ? "Photo added" : NO_PHOTO;
    if (key === BG_KEY) return bgLabel(state.background);
    if (key === "__filter") return tomTatTone();
    const row = rowByKey(key);
    if (!row) return "—";
    const chu = row.fields.map((field) => state.fields[keyOf(field)] || "—").join(" · ");
    return conMau(key) ? `${chu} (sample)` : chu;
  }

  /** Dòng option có ô nào còn để nguyên chữ mẫu không. */
  function conMau(key) {
    return !!rowByKey(key)?.fields.some((field) => conChuMau(field, state.fields[keyOf(field)], daGo));
  }

  /** Dòng option đầu tiên còn để nguyên chữ mẫu, kèm chữ mẫu đó; hoặc null. */
  function sampleField() {
    for (const row of optionRows(config)) {
      const field = row.fields.find((one) => conChuMau(one, state.fields[keyOf(one)], daGo));
      if (field) return { key: row.key, text: field.default ?? "" };
    }
    return null;
  }

  function refreshRows() {
    // KHÔNG tự cất cảnh báo ở đây: nó còn dùng để báo "file không đọc được", mà lúc đó khách có
    // thể vẫn đang giữ một tấm ảnh cũ hợp lệ. Chỉ lúc nạp ảnh THÀNH CÔNG mới cất đi.
    // Chỉ khoá cuộn trên khung xem KHI ĐÃ có ảnh. Chưa có ảnh thì chẳng kéo gì được, mà khoá thì
    // khách vuốt trúng tấm chăn là trang đứng im - tấm chăn to gần hết bề ngang điện thoại.
    root.classList.toggle("has-photo", !!photoUrls[activeSlot]);
    // Khung kéo cũng theo luật đó, và phải xét Ở ĐÂY chứ không chỉ lúc mở ngăn kéo: khách mở ngăn
    // ảnh KHI CHƯA CÓ ẢNH rồi mới chọn - lúc `setEditing` chạy thì ô đó còn rỗng nên khung
    // bị ẩn, chọn ảnh xong không ai bật lại. Hàm này chạy sau mọi thay đổi nên nó là chỗ đúng.

    for (const row of ui.rows.querySelectorAll("[data-key]")) {
      const value = valueOf(row.dataset.key);
      row.querySelector(".sng-row__value").textContent = value;
      // Còn chữ mẫu cũng tô đỏ như ô trống: cả hai đều là chỗ khách chưa điền.
      row.classList.toggle("is-empty", value === "—" || value === NO_PHOTO || conMau(row.dataset.key));
    }
    lamMoiO();
  }

  /** Cập nhật lưới ô ảnh: ảnh thu nhỏ, trạng thái đầy/trống, và số đã chọn. */
  function lamMoiO() {
    if (!ui.tiles) return;
    let du = 0;
    for (const [slot, o] of ui.tiles) {
      const url = photoUrls[slot];
      if (url) du++;
      o.node.classList.toggle("is-filled", !!url);
      if (url) {
        o.img.src = url;
        o.img.hidden = false;
      } else {
        o.img.removeAttribute("src");
        o.img.hidden = true;
        // Chỉ bỏ dấu đỏ khi ô đã đầy; ô trống giữ dấu cho tới lúc khách bù vào.
      }
      if (url) o.node.classList.remove("is-missing");
      // Nhãn vẽ AI nằm ngay trên ô ảnh, để đóng ngăn kéo rồi vẫn thấy ảnh này đã thành tranh chưa -
      // khách tải ảnh xong bấm "Done" luôn là mua về một tấm ảnh thường mà không biết.
      if (PP?.art && aiEnabled(config)) {
        let nhan = o.node.querySelector(".sng-tile__ai");
        if (!nhan) { nhan = el("span", "sng-tile__ai"); o.node.append(nhan); }
        const tt = !url ? "" : dangVe[slot] ? "dang-ve" : state.ai[slot] ? "da-ve" : "chua-ve";
        nhan.dataset.ai = tt;
        nhan.hidden = !tt;
        nhan.textContent = tt === "dang-ve" ? (PP.art.tile_busy ?? "Painting…")
          : tt === "da-ve" ? (PP.art.tile_done ?? "✓ Painted")
          : tt === "chua-ve" ? (PP.art.tile_todo ?? "✨ Tap to paint it") : "";
      }
    }
    if (ui.count) {
      ui.count.textContent = `${du}/${ui.tiles.size} added`;
      ui.count.classList.toggle("is-done", du === ui.tiles.size);
    }
  }

  /** Giữ cho đơn nào cũng có ảnh của khách. Hai đường làm rơi ảnh, chặn cả hai.
   *
   *  1. THANH MUA DÍNH ở đáy trang là một FORM RIÊNG, không có ô file nào. Bấm nó thì theme chép
   *     được mấy ô chữ sang nhưng file thì không - đơn về đủ chữ mà không có ảnh: xưởng không in
   *     được, còn khách thì tưởng mua xong rồi. Trên điện thoại thanh đó hiện suốt nửa dưới trang
   *     nên đây là đường mua DỄ nhất, không phải trường hợp hiếm.
   *     Chữa: bấm nút mua ở form khác thì bắn lại vào đúng nút mua của form này - form này là
   *     multipart và đang giữ cả ảnh gốc lẫn ảnh dựng. Hai form dùng chung một `id` biến thể
   *     (đổi size bên nào bên kia cũng đổi theo) nên bắn sang không sợ mua nhầm cỡ; chỉ số lượng
   *     là của riêng từng form nên phải chép tay.
   *
   *  2. Ô file khai `required` nhưng theme gửi giỏ bằng fetch nên bỏ qua kiểm tra của trình duyệt:
   *     bấm mua với ô ảnh trống vẫn vào giỏ như thường.
   *     Chữa: chưa có ảnh thì chặn, kéo bộ dựng vào tầm mắt rồi mở sẵn ngăn chọn ảnh.
   *
   *  Bắt ở pha CAPTURE của document để chạy TRƯỚC handler của theme. Để pha bubble thì theme đã
   *  gửi đi rồi, chặn cũng vô nghĩa. */
  function guardBuy() {
    document.addEventListener("click", (event) => {
      const button = buyButton(event.target);
      const owner = button?.closest("form");
      // Chỉ đụng vào form mua hàng. Form tìm kiếm, đăng ký nhận tin thì kệ.
      if (!owner || !owner.querySelector('[name="id"]')) return;
      if (chanNeuThieu(event)) return;
      if (owner === form) return;                 // đúng form rồi, cứ để đi
      event.preventDefault();
      event.stopImmediatePropagation();
      const wanted = owner.querySelector('[name="quantity"]')?.value;
      const box = form.querySelector('[name="quantity"]');
      if (wanted && box) box.value = wanted;
      form.querySelector('[type="submit"]')?.click();
    }, true);
    // Gõ Enter trong ô nhập cũng gửi form mà không đi qua nút nào.
    form.addEventListener("submit", (event) => { chanNeuThieu(event); }, true);

    // Riêng thanh mua dính thì chặn bằng sự kiện KHÔNG ĂN, phải thay hẳn cái nút - xem adoptButtons.
    adoptButtons();
    let hen = 0;
    new MutationObserver(() => { clearTimeout(hen); hen = setTimeout(adoptButtons, 200); })
      .observe(document.body, { childList: true, subtree: true });
  }

  /** Thay nút mua của các form KHÁC bằng nút của mình.
   *
   *  Vì sao không chặn bằng sự kiện: theme gắn handler của nó từ lúc tải trang, tức là TRƯỚC bộ
   *  này. Hai listener cùng nằm ở pha capture trên `document` thì cái đăng ký trước chạy trước,
   *  `stopImmediatePropagation` không với ngược lên được - đã thử, thanh dính vẫn thêm vào giỏ như
   *  thường. Nhân bản cái nút thì bản sao KHÔNG mang theo listener nào, thế là dứt điểm.
   *
   *  Đổi luôn `type` sang "button" để nó thôi gửi cái form rỗng của nó.
   *
   *  Theme dựng lại thanh dính mỗi lần đổi biến thể nên phải theo dõi DOM mà nhận lại nút mới. */
  function adoptButtons() {
    for (const button of document.querySelectorAll("button, input")) {
      if (button.type !== "submit") continue;
      const owner = button.closest("form");
      if (!owner || owner === form || !owner.querySelector('[name="id"]')) continue;
      // Nhận rồi thì thôi: không đánh dấu là mỗi lần DOM đổi lại nhân bản một lần nữa, mà chính
      // việc thay nút cũng là một thay đổi DOM - thành vòng lặp không dứt.
      if (button.dataset.sngBuy) continue;
      const clone = button.cloneNode(true);
      clone.dataset.sngBuy = "1";
      clone.type = "button";
      button.replaceWith(clone);
      clone.addEventListener("click", (event) => {
        event.preventDefault();
        if (chanNeuThieu(event)) return;
        const wanted = owner.querySelector('[name="quantity"]')?.value;
        const box = form.querySelector('[name="quantity"]');
        if (wanted && box) box.value = wanted;
        form.querySelector('[type="submit"]')?.click();
      });
    }
  }

  /** Giữ cho ô `id` của form luôn trỏ đúng biến thể khách đang chọn.
   *
   *  ── Vì sao bộ cá nhân hoá phải lo việc này ────────────────────────────────
   *  Theme dựng bộ chọn cỡ/chất liệu bằng thẻ `<xo-product-variant>`. Nó vẽ ra mấy nút radio và
   *  đánh dấu cái đang chọn, NHƯNG không bao giờ ghi lại ô ẩn `name="id"` - mà đó mới là thứ
   *  Shopify đọc để biết khách mua biến thể nào.
   *
   *  Đo trên trang thật: bấm "60x80 inches" thì radio chuyển, còn `id` vẫn đứng nguyên ở biến thể
   *  30x40 Fleece. Khách chọn bản 60x80 Sherpa $75.95, đơn về là 30x40 Fleece $39.95 - vừa thu
   *  thiếu tiền vừa in sai khổ. Cả ba sản phẩm Snuggle đều dính.
   *
   *  Đây đúng loại việc `guardBuy` đang làm: giữ cho đơn đi ra khớp với thứ khách đã chọn. Và đặt
   *  ở đây thì chỉ ba trang Snuggle chịu ảnh hưởng, không đụng tới phần còn lại của cửa hàng.
   *
   *  ── Vì sao không tải lại trang với `?variant=` ────────────────────────────
   *  Đường đó server dựng lại đúng hết - nhưng tải lại là MẤT SẠCH ảnh khách đã tải lên. Chữ thì
   *  còn trong bản nháp, ảnh thì không (ảnh không nhét vừa localStorage). Khách chọn xong sáu ảnh
   *  rồi đổi cỡ là làm lại từ đầu.
   *
   *  ── Không đụng vào theme khi theme không hỏng ─────────────────────────────
   *  Chỉ chạy khi thấy đúng bộ radio của thẻ đó, và chỉ ghi khi giá trị đang SAI. Theme nào tự
   *  cập nhật đúng thì hàm này im lặng không làm gì. */
  async function guardVariant() {
    const oRadio = () => [...document.querySelectorAll('input[type="radio"]')]
      .filter((r) => /^\[SIGNAL_\d+_(\d+)\]/.test(r.name));
    if (!oRadio().length || !form.querySelector('[name="id"]')) return;
    const bang = await bangBienThe();
    if (!bang?.length) return;

    // Bắt ở pha CAPTURE trên document: theme vẽ lại cụm radio khi đổi lựa chọn, nên gắn thẳng vào
    // từng nút là sau một lần bấm chúng đã bị thay và mất hết handler.
    document.addEventListener("change", (event) => {
      if (event.target instanceof HTMLInputElement && /^\[SIGNAL_\d+_\d+\]/.test(event.target.name)) dongBoId(bang);
    }, true);
    dongBoId(bang);
  }

  /** Bảng biến thể: thử JSON theme nhúng sẵn trước, không có thì hỏi Ajax API của Shopify.
   *  Ưu tiên bản nhúng vì nó đã nằm sẵn trong trang, không tốn thêm một lượt gọi. */
  async function bangBienThe() {
    const hopLe = (j) => Array.isArray(j?.variants)
      && j.variants.every((v) => v.id && Array.isArray(v.options)) ? j.variants : null;
    for (const the of document.querySelectorAll('script[type="application/json"]')) {
      try {
        const ra = hopLe(JSON.parse(the.textContent));
        if (ra) return ra;
      } catch {}
    }
    try {
      const r = await fetch(`${location.pathname}.js`, { headers: { Accept: "application/json" } });
      return r.ok ? hopLe(await r.json()) : null;
    } catch { return null; }
  }

  /** Ghi ô `id` theo đúng tổ hợp lựa chọn đang bật, và sửa luôn giá đang hiện. */
  function dongBoId(bang) {
    // Tên ô có dạng `[SIGNAL_<mã sp>_<thứ tự>]<Tên option>` - con số đó chính là thứ tự option,
    // phải xếp theo nó thì mới so được với mảng `options` của biến thể.
    const chon = [];
    for (const r of document.querySelectorAll('input[type="radio"]:checked')) {
      const m = /^\[SIGNAL_\d+_(\d+)\]/.exec(r.name);
      if (m) chon[Number(m[1])] = r.value;
    }
    if (!chon.length || chon.some((v) => v === undefined)) return;
    const bt = bang.find((v) => v.options.length === chon.length && v.options.every((o, i) => o === chon[i]));
    if (!bt) return;

    const cu = bang.find((v) => String(v.id) === String(form.querySelector('[name="id"]')?.value));
    // Sửa MỌI ô `id` trên trang: thanh mua dính ở đáy trang là một form riêng và có ô `id` của nó.
    let doi = false;
    for (const o of document.querySelectorAll('[name="id"]')) {
      if (String(o.value) === String(bt.id)) continue;
      o.value = String(bt.id);
      o.dispatchEvent(new Event("change", { bubbles: true }));
      doi = true;
    }
    if (doi && cu && cu.price !== bt.price) doiGia(cu.price, bt.price);
  }

  /** Đổi giá đang hiện trên trang.
   *
   *  Chỉ thay những ô đang hiện ĐÚNG giá cũ. Quét bừa mọi ô có dấu $ là đè luôn giá gạch ngang và
   *  giá theo đơn vị. Nhưng khớp số thôi thì CHƯA đủ: bảng giá trong mô tả cũng có đúng con số đó,
   *  nên chỉ xét ô nằm trong khối giá của sản phẩm (`laOGiaSanPham`).
   *
   *  Ký hiệu tiền tệ và cách viết lấy TỪ CHÍNH chuỗi đang hiện, không tự dựng: cửa hàng đổi sang
   *  euro hay đổi dấu phân cách là bản tự dựng lệch ngay. */
  function doiGia(cu, moi) {
    const so = (xu) => (xu / 100).toFixed(2);
    const cuChu = so(cu), moiChu = so(moi);
    for (const node of document.querySelectorAll("*")) {
      if (node.children.length || !node.textContent.includes(cuChu) || !laOGiaSanPham(node)) continue;
      node.textContent = node.textContent.split(cuChu).join(moiChu);
    }
  }

  /** Nút bấm vào có phải nút gửi form không.
   *
   *  Phải hỏi thuộc tính `.type` của phần tử, ĐỪNG dùng bộ chọn CSS `[type="submit"]`: `<button>`
   *  không khai type thì mặc định vẫn là submit, mà bộ chọn thuộc tính chỉ khớp khi thuộc tính có
   *  mặt thật. Nút của thanh mua dính chính là loại không khai type - dùng bộ chọn CSS là nó lọt
   *  lưới, mà nó lại đúng là cái nút cần chặn. */
  function buyButton(node) {
    const button = node?.closest?.("button, input");
    return button && button.type === "submit" ? button : null;
  }

  /** Đơn còn thiếu thì chặn và trả true: thiếu ảnh, ô chữ trống, hoặc ô chữ còn để chữ mẫu. Ba
   *  đường mua (nút của form này, Enter trong ô nhập, nút của thanh mua dính) cùng gọi hàm này nên
   *  thêm một điều kiện chỉ phải thêm một chỗ. */
  /** Đẩy một bước hành trình trong bộ vẽ sang GA4 (`window.hkGa4`) và Shopify customer events.
   *  Không bao giờ ném: đo lường hỏng thì bộ vẽ vẫn phải chạy. */
  function suKien(ten, thamSo = {}) {
    const p = { ...thamSo, sng_layout: spec?.id ?? "", sng_product: location.pathname.split("/").pop() };
    try {
      const dich = Array.isArray(window.hkGa4) ? window.hkGa4 : [];
      if (dich.length) {
        window.dataLayer = window.dataLayer || [];
        const gtag = typeof window.gtag === "function" ? window.gtag : function () { window.dataLayer.push(arguments); };
        gtag("event", ten, { ...p, send_to: dich });
      }
    } catch {}
    try { window.Shopify?.analytics?.publish?.(ten, p); } catch {}
  }

  function chanNeuThieu(event) {
    const thieuAnh = missingPhoto();
    if (thieuAnh) { suKien("sng_buy_blocked", { reason: "photo" }); blockBuy(event, photoKey(thieuAnh.slot), warnMissing); return true; }
    const trong = emptyField();
    if (trong) { suKien("sng_buy_blocked", { reason: "text", field: trong }); blockBuy(event, trong, WARN_EMPTY_TEXT); return true; }
    const mau = sampleField();
    if (mau) { suKien("sng_buy_blocked", { reason: "sample", field: mau.key }); blockBuy(event, mau.key, warnSample(mau.text)); return true; }
    if (dangXuLyAnh()) { choTaiXong(event); return true; }
    return false;
  }

  /** Chặn lại rồi chỉ thẳng cho khách chỗ cần bấm. */
  function blockBuy(event, key, message) {
    event.preventDefault();
    event.stopImmediatePropagation();
    ui.warn.textContent = message;
    ui.warn.hidden = false;
    // Cảnh báo về CHỮ thì tự cất khi khách gõ đủ (xem textPanel). Cảnh báo về ảnh giữ nguyên luật
    // cũ: chỉ cất khi nạp ảnh thành công.
    ui.warn.dataset.loai = key.startsWith("__photo") ? "anh" : "chu";
    root.scrollIntoView({ behavior: "smooth", block: "start" });
    // Thiếu ảnh mà lại MỞ NGĂN KÉO thì khách chỉ thấy đúng một ô, không biết còn thiếu mấy ô nữa.
    // Tô đỏ hết ô trống trên lưới rồi kéo lưới vào tầm mắt - nhìn một cái là biết còn thiếu bao
    // nhiêu và thiếu ở đâu.
    if (HIEN_HET && dungLuoiAnh.chinh && key.startsWith("__photo")) {
      for (const [slot, o] of ui.tiles) o.node.classList.toggle("is-missing", !photoUrls[slot]);
      ui.photos.scrollIntoView({ behavior: "smooth", block: "center" });
      refreshRows();
      return;
    }
    if (HIEN_HET) {
      const than = mucBuoc.get(key);
      than?.querySelector(".sng-warn--drawer")?.remove();
      than?.querySelector(".sng-panel")?.prepend(el("p", "sng-warn sng-warn--drawer", message));
      than?.closest(".sng-muc")?.scrollIntoView({ behavior: "smooth", block: "center" });
      than?.querySelector("input[type=text]")?.select();
      refreshRows();
      return;
    }
    if (ui.tiles && key.startsWith("__photo")) {
      for (const [slot, o] of ui.tiles) o.node.classList.toggle("is-missing", !photoUrls[slot]);
      ui.tiles.get(slotOfKey(key))?.node.scrollIntoView({ behavior: "smooth", block: "nearest" });
      refreshRows();
      return;
    }
    openDrawer(key);
    // Trên điện thoại tấm trượt phủ kín cột option, che mất ô cảnh báo ở trên: khách chỉ thấy ô chữ
    // tự bật ra mà không biết vì sao. Nhắc lại câu cảnh báo ngay trong tấm trượt, và bôi đen chữ
    // đang có để gõ là thay luôn.
    ui.body.querySelector(".sng-panel")?.prepend(el("p", "sng-warn sng-warn--drawer", message));
    ui.body.querySelector("input")?.select();
    refreshRows();
  }

  /** Khoá của DÒNG option đầu tiên còn ô chữ bỏ trống, hoặc null nếu đủ cả.
   *
   *  Dòng nào trống thì danh sách đã tô đỏ sẵn rồi mà vẫn cho mua - đánh dấu là thiếu sót nhưng
   *  không chặn thì tín hiệu mâu thuẫn, và chăn in ra có một khoảng trống trông như lỗi in. */
  function emptyField() {
    for (const row of optionRows(config)) {
      for (const field of row.fields) {
        if (!String(state.fields[keyOf(field)] ?? "").trim()) return row.key;
      }
    }
    return null;
  }

  // ── tấm trượt ──────────────────────────────────────────────────────────────
  /** Chế độ chỉnh ảnh: hiện tấm PHẲNG kèm khung kéo, cất chăn thật đi.
   *
   *  Vì sao phải đổi sang tấm phẳng: chăn thật là ảnh đã bọc theo nếp vải, ô ảnh trên đó không
   *  còn là hình chữ nhật nên không có chỗ nào đặt bốn cái tay nắm cho đúng. Và nó là lý do THẬT
   *  của cảm giác lag: tấm phẳng vẽ xong sau 6ms, còn chăn thật phải bọc lại nên bị giãn nhịp
   *  160ms - khách kéo tay mà ảnh đứng im một nhịp rồi mới nhảy.
   *
   *  Đóng ngăn kéo là trả lại chăn thật ngay. */
  function setEditing(on) {
    if (!spec) return;
    root.classList.toggle("is-editing", on);

    paintGhost();
    if (on) ui.stage.style.aspectRatio = `${spec.design_size[0]} / ${spec.design_size[1]}`;
    else if (scenePack) cropToBlanket(scenePack);
    if (!on) warp();
  }

  /** Vẽ phần ảnh NẰM NGOÀI trái tim, mờ đi.
   *
   *  Vì sao bỏ cái khung có bốn tay nắm: ảnh luôn phải phủ kín trái tim nên nó LUÔN to hơn ô ảnh,
   *  thường to hơn cả khung xem - khung bao quanh nó thành ra tràn ra ngoài, bốn tay nắm nằm ngoài
   *  tầm với, nhìn như hỏng. Đó không phải lỗi vẽ khung, đó là cái khung sai kiểu.
   *
   *  Lối này quen thuộc hơn nhiều: trái tim là Ô NGẮM, ảnh chạy phía sau, phần thò ra ngoài hiện
   *  mờ để khách biết đầu đuôi con vật đang nằm đâu mà kéo cho vừa. Không có tay nắm nào để lạc.
   *
   *  Vẽ ở khổ nhỏ (chia 3) vì nó chỉ là lớp gợi ý: mỗi khung hình lúc kéo vẽ lại cả khổ in là phí. */
  function paintGhost() {
    const slot = spec?.elements.find((item) => item.id === photoId(activeSlot));
    const photo = assets[photoUrls[activeSlot]];
    const mask = slot?.mask ? assets[slot.mask] : null;
    const ctx = ui.ghost.getContext("2d");
    if (!ctx) return;
    ctx.clearRect(0, 0, ui.ghost.width, ui.ghost.height);
    if (!slot || !photo || !root.classList.contains("is-editing")) return;

    const [DW, DH] = spec.design_size;
    const s = ui.ghost.width / DW;
    const bw = slot.box.w * DW, bh = slot.box.h * DH;
    const bx = slot.box.x * DW, by = slot.box.y * DH;
    const p = state.edits[photoId(activeSlot)] ?? {};
    const rad = ((p.spin ?? 0) * Math.PI) / 180;
    const cos = Math.abs(Math.cos(rad)), sin = Math.abs(Math.sin(rad));
    const cover = Math.max((bw * cos + bh * sin) / photo.naturalWidth,
                           (bw * sin + bh * cos) / photo.naturalHeight) * (p.zoom ?? 1);
    const drawW = photo.naturalWidth * cover, drawH = photo.naturalHeight * cover;
    const dx = (p.pan_x ?? 0) * bw, dy = (p.pan_y ?? 0) * bh;
    const midX = bx + bw / 2 + dx * Math.cos(rad) - dy * Math.sin(rad);
    const midY = by + bh / 2 + dx * Math.sin(rad) + dy * Math.cos(rad);

    ctx.save();
    ctx.translate(midX * s, midY * s);
    ctx.rotate(rad);
    ctx.drawImage(photo, (-drawW / 2) * s, (-drawH / 2) * s, drawW * s, drawH * s);
    ctx.restore();
    // Đục trái tim ra SAU KHI đã trả phép biến hình: chỗ đó đã có ảnh nét trên tấm thiết kế rồi,
    // để lớp mờ đè lên nữa thì lòng tim bị đục ngầu.
    if (mask) {
      ctx.globalCompositeOperation = "destination-out";
      ctx.drawImage(mask, bx * s, by * s, bw * s, bh * s);
      ctx.globalCompositeOperation = "source-over";
    }
  }

  function openDrawer(key) {
    if (HIEN_HET) { dungMuc(key); return; }
    const laAnh = key.startsWith("__photo");
    // Đặt ô đang chỉnh TRƯỚC khi bật chế độ chỉnh: `setEditing` vẽ lại lớp gợi ý, mà lớp đó nhìn
    // vào `activeSlot` - đặt sau thì khung gợi ý của lần mở này vẽ theo ô của lần mở trước.
    if (laAnh) activeSlot = slotOfKey(key);
    moDangMo = key;
    setEditing(laAnh);
    ui.body.replaceChildren(
      laAnh ? photoPanel(activeSlot)
        : key === "__filter" ? filterPanel(null)
        : key === BG_KEY ? backgroundPanel()
        : textPanel(key),
    );
    ui.title.textContent = laAnh ? (SLOTS.find((one) => one.slot === activeSlot)?.label ?? "Photo")
      : key === "__filter" ? (config.filter?.label ?? "Photo tone")
      : key === BG_KEY ? (config.background?.label ?? "Background")
      : (rowByKey(key)?.label ?? key);
    root.classList.add("is-open");
    // Panel AI vừa dựng phải mang ngay trạng thái lượt vẽ đang chạy (nút khoá, thanh tiến độ), đừng
    // đợi nhịp hẹn giờ kế tiếp - hở 200 ms là đủ cho khách bấm vẽ thêm một lượt.
    veTien();
    const first = ui.body.querySelector("input, button");
    if (first) first.focus({ preventScroll: true });
  }

  /** Mở khung xem to.
   *
   *  Chụp từ TẤM PHẲNG chứ không phải tấm chăn đã bọc: tấm chăn dựng từ bộ bản đồ warp 700px, phóng
   *  to lên là nhoè; tấm phẳng là khổ in 2400×3250, cắt ra bao nhiêu cũng nét. Mà thứ khách vào đây
   *  soi cũng đúng là chữ với ảnh, không phải nếp vải.
   *
   *  Thu về 1400px rồi mới chụp: `toBlob` nguyên khổ 2400×3250 ra tấm ảnh mấy MB, mà màn hình nào
   *  cũng chỉ hiện được chừng đó pixel. */
  function moToLen() {
    if (!spec) return;
    const [W, H] = spec.design_size;
    const rong = Math.min(W, 1400);
    const o = document.createElement("canvas");
    o.width = rong;
    o.height = Math.round((H * rong) / W);
    const octx = o.getContext("2d");
    if (!octx) return;
    octx.drawImage(ui.canvas, 0, 0, o.width, o.height);
    o.toBlob((blob) => {
      if (!blob) return;
      if (toUrl) URL.revokeObjectURL(toUrl);
      toUrl = URL.createObjectURL(blob);
      ui.lightImg.src = toUrl;
      ui.lightbox.hidden = false;
      // Khoá cuộn trang: mở khung phủ toàn màn mà nền vẫn cuộn được thì vuốt một cái là trang chạy
      // sau lưng, đóng ra không biết mình đang ở đâu.
      cuonCu = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      ui.lightClose.focus({ preventScroll: true });
    }, "image/jpeg", 0.92);
  }

  function dongToLen() {
    if (ui.lightbox.hidden) return;
    ui.lightbox.hidden = true;
    document.body.style.overflow = cuonCu;
    if (toUrl) { URL.revokeObjectURL(toUrl); toUrl = ""; }
    ui.lightImg.removeAttribute("src");
    ui.zoom.focus({ preventScroll: true });
  }

  /** Các bước theo đúng thứ tự khách thấy: từng ô ảnh, rồi các dòng (tông màu, nền, chữ). */
  function cacBuoc() {
    const ds = ui.tiles ? [...ui.tiles.keys()].map((slot) => photoKey(slot)) : [];
    for (const r of ui.rows.querySelectorAll(".sng-row[data-key]")) ds.push(r.dataset.key);
    return ds;
  }

  /** Tên một bước, cũng là tiêu đề mục/tấm trượt của bước đó. */
  function tenBuoc(key) {
    return key.startsWith("__photo") ? (SLOTS.find((one) => one.slot === slotOfKey(key))?.label ?? "Photo")
      : key === "__filter" ? (config.filter?.label ?? "Photo tone")
      : key === BG_KEY ? (config.background?.label ?? "Background")
      : (rowByKey(key)?.label ?? key);
  }

  /** Dựng khối các mục một lần; sau đó mỗi mục tự dựng lại qua `dungMuc`. */
  function dungHienHet() {
    const luoi = SLOTS.length > 1 && !!ui.tiles && !!ui.photos;
    if (luoi) dungLuoiAnh();
    for (const key of cacBuoc()) {
      if (luoi && key.startsWith("__photo")) continue;
      const muc = el("section", "sng-muc");
      muc.dataset.key = key;
      const than = el("div", "sng-muc__than");
      muc.append(el("span", "sng-muc__title", tenBuoc(key)), than);
      ui.body.append(muc);
      mucBuoc.set(key, than);
      // Chạm vào mục ảnh (thanh trượt, thẻ vẽ AI) thì canvas sang tấm phẳng có lớp gợi ý như lúc mở
      // ngăn kéo ảnh trước đây; chạm mục khác hoặc ra ngoài bộ vẽ thì trả lại chăn thật.
      muc.addEventListener("pointerdown", () => chinhAnh(key));
      muc.addEventListener("focusin", () => chinhAnh(key));
      dungMuc(key);
    }
    document.addEventListener("pointerdown", (event) => { if (!root.contains(event.target)) chinhAnh(""); });
  }

  /** Chăn nhiều ảnh ở chế độ hiện hết: ảnh là lưới ô, không phải mỗi ảnh một mục. Trạng thái nhớ trên chính
   *  hàm (dungLuoiAnh.chinh / .tieuDe): khai const trong thân mount thì nằm sau lệnh return, không khởi tạo. */
  function dungLuoiAnh() {
    const khoi = el("section", "sng-muc sng-muc--luoi");
    khoi.append(ui.photos);
    ui.body.append(khoi);
    const chinh = el("section", "sng-muc sng-muc--chinh-anh");
    const tieuDe = el("span", "sng-muc__title", "");
    const than = el("div", "sng-muc__than");
    chinh.append(tieuDe, than);
    chinh.hidden = true;
    ui.body.append(chinh);
    chinh.addEventListener("pointerdown", () => chinhAnh(photoKey(activeSlot)));
    chinh.addEventListener("focusin", () => chinhAnh(photoKey(activeSlot)));
    dungLuoiAnh.chinh = chinh;
    dungLuoiAnh.tieuDe = tieuDe;
    for (const [slot, o] of ui.tiles) {
      mucBuoc.set(photoKey(slot), than);
      // Ô trống: input file phủ lên ô, chạm là mở thư viện ảnh (không phải qua nút thứ hai).
      const bao = el("div", "sng-tile-wrap");
      o.node.replaceWith(bao);
      bao.append(o.node);
      const f = el("input", "sng-tile__file");
      f.type = "file";
      f.accept = "image/jpeg,image/png,image/webp";
      f.setAttribute("aria-label", "Add photo " + slot);
      f.addEventListener("change", async () => {
        const chosen = f.files?.[0];
        if (!chosen) return;
        if (await nhanFile(chosen, slot, f)) openDrawer(photoKey(slot));
      });
      bao.append(f);
      o.file = f;
    }
  }

  /** Chọn một ô trong lưới: tiêu đề mục chỉnh theo ô đó, viền ô đang chọn, ô đã có ảnh thì gỡ input phủ. */
  function chonO(slot) {
    dungLuoiAnh.tieuDe.textContent = tenBuoc(photoKey(slot));
    dungLuoiAnh.chinh.hidden = false;
    for (const [s, o] of ui.tiles) {
      o.node.classList.toggle("is-active", s === slot);
      if (o.file) o.file.hidden = !!photoUrls[s];
    }
  }

  function chinhAnh(key) {
    const laAnh = key.startsWith("__photo") && !!photoUrls[slotOfKey(key)];
    if (laAnh) { activeSlot = slotOfKey(key); moDangMo = key; }
    if (root.classList.contains("is-editing") !== laAnh) setEditing(laAnh);
  }

  function dungMuc(key) {
    const than = mucBuoc.get(key);
    if (!than) return;
    const laAnh = key.startsWith("__photo");
    // `moDangMo` giữ ô ảnh: các chỗ dựng lại panel sau khi tải ảnh / vẽ AI xong đều hỏi nó.
    if (laAnh) { activeSlot = slotOfKey(key); moDangMo = key; }
    if (laAnh && dungLuoiAnh.chinh) chonO(slotOfKey(key));
    than.replaceChildren(
      laAnh ? photoPanel(slotOfKey(key))
        : key === "__filter" ? filterPanel(null)
        : key === BG_KEY ? backgroundPanel()
        : textPanel(key),
    );
    if (laAnh && SLOTS.length > 1 && !dungLuoiAnh.chinh) gonChinhAnh(than, slotOfKey(key));
    veTien();
  }

  /** Chăn nhiều ảnh ở chế độ hiện hết: phần tinh chỉnh (thanh trượt, tông màu…) gấp vào "Adjust this photo".
   *  Nút chọn ảnh, câu gợi ý và câu cảnh báo vẫn nằm ngoài. Lần đầu ô có ảnh thì mở sẵn cho khách thấy. */
  function gonChinhAnh(than, slot) {
    // Nhớ ô đã mở trên chính hàm: khai const ở thân mount thì nằm SAU lệnh return, chưa bao giờ được khởi tạo.
    const daMoChinh = gonChinhAnh.daMo || (gonChinhAnh.daMo = new Set());
    const panel = than.querySelector(".sng-panel");
    if (!panel) return;
    const ngoai = (c) => c.classList.contains("sng-pick") || c.classList.contains("sng-help") || c.classList.contains("sng-warn");
    const trong = [...panel.children].filter((c) => !ngoai(c));
    if (!trong.length) return;
    const d = el("details", "sng-muc__chinh");
    if (photoUrls[slot] && !daMoChinh.has(slot)) {
      // Chỉ để mở phần chỉnh của ô VỪA có ảnh; ô trước gấp lại cho trang khỏi dài.
      for (const o of ui.body.querySelectorAll("details.sng-muc__chinh[open]")) o.open = false;
      d.open = true;
      daMoChinh.add(slot);
    }
    d.append(el("summary", "", "Adjust this photo"), ...trong);
    panel.append(d);
  }

  function closeDrawer() {
    root.classList.remove("is-open");
    moDangMo = "";
    // Ra khỏi chế độ chỉnh ảnh luôn: đóng ngăn kéo mà vẫn để tấm phẳng kèm khung kéo thì khách
    // nhìn mãi tấm phẳng, không bao giờ thấy chăn thật nữa.
    setEditing(false);
    refreshRows();
  }

  /** Một tấm trượt cho cả DÒNG option: một ô nhập nếu dòng đó chỉ có một, ba ô xếp dọc nếu là
   *  khối tiêu đề. Mỗi ô vẫn ghi thẳng vào line item property riêng của nó. */
  function textPanel(key) {
    const row = rowByKey(key);
    const wrap = el("div", "sng-panel");
    for (const field of row.fields) {
      const one = el("label", "sng-line");
      if (row.fields.length > 1) one.append(el("span", "sng-line__label", field.label));
      const input = el("input", "sng-input");
      const at = keyOf(field);
      input.type = "text";
      input.value = state.fields[at] ?? "";
      input.maxLength = field.max;
      const count = el("i", "sng-count");
      // Chạm trần thì bộ đếm đổi màu. Không có gì báo thì khách gõ tiếp, chữ không vào, tưởng
      // bàn phím hỏng - trình duyệt chặn ở `maxLength` mà chặn không kèn không trống.
      const tick = () => {
        count.textContent = `${input.value.length}/${field.max}`;
        count.classList.toggle("is-full", input.value.length >= field.max);
      };
      tick();
      input.addEventListener("input", () => {
        state.fields[at] = input.value;
        daGo.add(at);
        inputFor(field.property).value = input.value;
        tick();
        draw();
        // Dòng tóm tắt phải đổi NGAY, đừng đợi đóng tấm trượt: gõ xong liếc xuống thấy chữ cũ là
        // tưởng chưa ăn, gõ lại lần nữa.
        refreshRows();
        if (ui.warn.dataset.loai === "chu" && !emptyField() && !sampleField()) {
          ui.warn.hidden = true;
          wrap.querySelector(".sng-warn--drawer")?.remove();
        }
      });
      one.append(input, count);
      wrap.append(one);
      if (field.help) wrap.append(el("p", "sng-help", field.help));
    }
    return wrap;
  }

  /** Bộ lọc màu ảnh, hiện thành LƯỚI THẺ CÓ ẢNH.
   *
   *  Trước đây là một cột sáu dòng chữ - "Sepia", "Warm", "Cool" đọc lên thì ai cũng đoán được,
   *  nhưng đoán không ra nó làm ảnh CỦA MÌNH trông thế nào, nên khách bấm thử từng cái rồi nhìn
   *  lên tấm chăn. Thấy ngay trên thẻ thì chọn một phát là xong.
   *
   *  Ảnh trên thẻ lấy CHÍNH ẢNH KHÁCH VỪA TẢI LÊN khi có - không gì trực quan bằng nhìn đúng con
   *  vật của mình qua sáu tông. Chưa có ảnh (layout một ô, khách mở dòng tông màu trước khi tải
   *  ảnh) thì rơi về một ảnh mẫu.
   *
   *  Bộ lọc áp bằng `style.filter` của trình duyệt, đúng chuỗi mà bộ vẽ dùng - không dựng sáu
   *  ảnh mẫu đã tô sẵn. Dựng sẵn là sáu file phải nhớ dựng lại mỗi lần chỉnh công thức lọc, mà
   *  quên thì thẻ nói một đằng chăn vẽ một nẻo. */
  function filterPanel(slot) {
    const o = slot ?? activeSlot;
    const anh = photoUrls[o] ?? (config.tone_sample ? urls[config.tone_sample] : null);
    const wrap = el("div", `sng-panel sng-tones${anh ? "" : " sng-tones--chu"}`);
    for (const item of SNUGGLE_PHOTO_FILTERS) {
      const option = el("label", "sng-tone");
      const radio = el("input");
      radio.type = "radio";
      radio.name = "sng-photo-filter";
      radio.checked = filterOf(o) === item.key;
      radio.addEventListener("change", () => {
        setFilter(item.key, o);
        if (config.filter?.property) inputFor(config.filter.property).value = tomTatTone();
        draw();
        refreshRows();
      });
      const ten = item.en ?? item.label;
      if (anh) {
        const hinh = el("img", "sng-tone__img");
        hinh.src = anh;
        hinh.alt = "";
        hinh.loading = "lazy";
        if (item.css !== "none") hinh.style.filter = item.css;
        option.append(radio, hinh);
      } else {
        option.append(radio);
      }
      option.append(el("span", "sng-tone__ten", ten));
      wrap.append(option);
    }
    return wrap;
  }

  /** Chọn bộ nền, cùng dạng LƯỚI THẺ với tông màu.
   *
   *  Mỗi thẻ hiện MÉP TRÊN của chính tấm nền bộ đó - thấy cả viền len lẫn ruột kem, tức là đúng
   *  hai thứ đổi màu. Một ô màu phẳng thì không nói được: năm bộ chỉ khác nhau ở viền, mà ruột
   *  bộ nào cũng kem nhạt gần giống nhau.
   *
   *  Ảnh nền vốn đã nạp sẵn cả năm bộ từ lúc mount (xem `backgroundOptionUrls`), nên thẻ hiện ra
   *  ngay, không tốn thêm lượt tải nào. */
  function backgroundPanel() {
    const wrap = el("div", "sng-panel sng-tones sng-tones--nen");
    for (const item of config.backgrounds ?? []) {
      const option = el("label", "sng-tone");
      const radio = el("input");
      radio.type = "radio";
      radio.name = "sng-background";
      radio.checked = state.background === item.key;
      radio.addEventListener("change", () => {
        state.background = item.key;
        if (config.background?.property) inputFor(config.background.property).value = bgLabel(item.key);
        draw();
        refreshRows();
      });
      option.append(radio);
      const nen = anhNen(item);
      if (nen) {
        const hinh = el("img", "sng-tone__img");
        hinh.src = String(nen).replace(/_(\d{3,4})x\.(png|jpe?g|webp)(?=[?#]|$)/i, "_240x.$2"); // ô màu dùng ảnh nhỏ
        hinh.alt = "";
        hinh.loading = "lazy";
        option.append(hinh);
      } else if (item.swatch) {
        // Không tra ra ảnh thì còn hơn không: một ô màu nhấn của bộ đó.
        const o = el("span", "sng-tone__o");
        o.style.background = item.swatch;
        option.append(o);
      }
      option.append(el("span", "sng-tone__ten", item.en ?? item.key));
      wrap.append(option);
    }
    return wrap;
  }

  /** URL theme của ảnh nền một bộ. Cấu hình chỉ khai khoá và nhãn, còn đường dẫn nằm trong spec -
   *  tra qua đó rồi mới đổi sang URL thật của theme. */
  function anhNen(item) {
    const bo = spec?.background_options?.find((one) => one.key === item.key);
    return bo?.background ? urls[bo.background] : null;
  }

  /** Dọn sạch mọi ô upload ngay lúc mount.
   *
   *  Trình duyệt KHÔI PHỤC ô file khi tải lại trang. Bắt được trên store thật: mở lại trang thì
   *  ô "Pet Photo 1" tự có sẵn một file của phiên trước, tên còn nguyên.
   *
   *  Nguy ở chỗ hai bên có thể lệch nhau: `photoUrls` luôn rỗng sau mỗi lần mount, nên nếu file
   *  khôi phục không chạy qua `nhanFile` thì tấm chăn hiện ô trống trong khi đơn hàng lại mang
   *  một tấm ảnh - khách mua một đằng, xưởng in nhận một nẻo. Dọn hết rồi bắt đầu từ số không thì
   *  cái khách nhìn thấy luôn đúng bằng cái họ mua.
   *
   *  Chỉ dọn ô ẢNH của bộ này, không đụng ô nào khác của theme. */
  function donOFile() {
    for (const one of SLOTS) {
      const o = form.querySelector(`input[type=file][name="${cssEscape(`properties[${one.property}]`)}"]`);
      if (o) o.value = "";
    }
  }

  /** Nhận một file khách chọn vào ô ảnh `slot`. Dùng chung cho lưới ô và cho ngăn kéo - hai chỗ
   *  gọi cùng một hàm thì không thể lệch nhau, mà đây là hàm KHÔNG được phép lệch: nó vừa quyết
   *  định ảnh nào lên chăn, vừa quyết định file nào đi vào đơn hàng.
   *
   *  Trả về true khi nhận được, false khi file hỏng. */
  async function nhanFile(chosen, slot, oFile) {
    const info = SLOTS.find((one) => one.slot === slot) ?? SLOTS[0];
    // NẠP THỬ TRƯỚC, GHI STATE SAU. Ghi URL vào ô rồi mới nạp thì gặp file không đọc được là hàm
    // này dừng giữa chừng: ảnh không lên chăn, nhưng ô đã "có ảnh" nên bộ chặn mua tưởng đã có
    // ảnh và cho đơn đi ra với ô trống - đúng cái lỗ vừa bịt, mở lại bằng cửa khác.
    //
    // Không phải trường hợp hiếm: ảnh iPhone mặc định là HEIC, Chrome không giải mã được.
    let image, url;
    try {
      url = URL.createObjectURL(chosen);
      image = await loadImage(url);
    } catch {
      if (url) URL.revokeObjectURL(url);
      ui.warn.textContent = WARN_UNREADABLE;
      ui.warn.hidden = false;
      if (oFile) oFile.value = "";   // xoá đi thì chọn LẠI đúng file đó vẫn nổ sự kiện change
      suKien("sng_photo_fail", { reason: "unreadable", file_type: chosen?.type || "?" });
      return false;
    }
    // Ảnh chỉ sống trong phiên xem trước; bản gửi đi là chính file gốc trong ô upload của form,
    // nên khách không phải tải lên hai lần và xưởng in nhận đúng ảnh gốc chứ không phải bản đã
    // bị canvas nén lại.
    if (photoUrls[slot]) URL.revokeObjectURL(photoUrls[slot]);
    // Ô đang mang tranh AI thì `photoUrls` là URL tranh, còn URL ảnh gốc nằm ở `anhGoc` - thu hồi
    // luôn, không thì mỗi lần đổi ảnh lại rơi một tấm ảnh điện thoại trong bộ nhớ.
    if (anhGoc[slot] && anhGoc[slot] !== photoUrls[slot]) URL.revokeObjectURL(anhGoc[slot]);
    photoUrls[slot] = url;
    anhGoc[slot] = url;
    assets[url] = image;
    state.photos[slot] = url;
    originalFiles[slot] = chosen;
    delete state.ai[slot];   // ảnh mới thì mọi tranh cũ của ô này hết hiệu lực
    delete tinVe[slot];
    syncAiInputs();
    moveFileToForm(chosen, info);
    // File gốc đã nằm trong form: nén/tải ngầm có hỏng giữa chừng thì đơn vẫn đi như cũ.
    xuLyAnhVao(chosen, image, slot, info);
    ui.warn.textContent = warnMissing;
    ui.warn.hidden = true;
    draw();
    refreshRows();
    suKien("sng_photo_added", { slot, file_type: chosen?.type || "?" });
    return true;
  }

  // ── AI Portrait ──────────────────────────────────────────────────────────
  /** Sàn zoom theo slot: ảnh thô giữ MIN_ZOOM (dưới 1× là ô ảnh thủng), còn cutout nền trong thì
   *  cho thu tới AI_MIN_ZOOM (mặc định 0.1×) để cả con vật lọt vào khung. 0 tuyệt đối là ảnh biến
   *  mất, nên sàn thấp nhất là 0.1. Layout 23 đặt cả hai sàn 0.3 (người vận hành chọn 2026-09-17). */
  function minZoom(slot) { return state.ai[slot] ? AI_MIN_ZOOM : MIN_ZOOM; }

  /** Zoom để ảnh nằm TRỌN trong hộp của slot (contain), tính tương đối so với cover = 1. */
  function containZoom(slot, image) {
    const e = spec?.elements?.find((x) => x.type === "photo_slot" && x.index === slot);
    if (!e?.box || !image?.naturalWidth) return 1;
    const bw = e.box.w * spec.design_size[0], bh = e.box.h * spec.design_size[1];
    const kx = bw / image.naturalWidth, ky = bh / image.naturalHeight;
    return Math.max(0.1, Math.min(kx, ky) / Math.max(kx, ky));
  }

  /** Ghi 3 property AI vào form theo slot đang có tranh; không có thì để rỗng. */
  function syncAiInputs() {
    if (!aiEnabled(config)) return;
    const r = Object.values(state.ai).find(Boolean);
    const props = r ? aiProperties(r) : { "AI Style": "", "AI Source": "", "AI Asset": "" };
    for (const [k, v] of Object.entries(props)) inputFor(k).value = v;
  }

  /** Nạp cutout vào slot: ảnh xem trước + file đi vào đơn. Lỗi thì ném, người gọi giữ ảnh gốc. */
  async function applyPortrait(slot, r) {
    const info = SLOTS.find((one) => one.slot === slot) ?? SLOTS[0];
    const image = await loadImage(r.cutout_url);
    const blob = await (await fetch(r.cutout_url)).blob();
    photoUrls[slot] = r.cutout_url;
    assets[r.cutout_url] = image;
    state.photos[slot] = r.cutout_url;
    state.ai[slot] = { style: r.style, cutout_url: r.cutout_url, original_url: r.original_url };
    // Tranh vừa vẽ: đặt sẵn zoom "contain" và về giữa, cả con vật nằm gọn trong khung ngay.
    // Thanh trượt có nấc thì hạ xuống nấc gần nhất - để lệch nấc là thanh chỉ một số, tranh vẽ theo
    // một số khác. Không thấp hơn sàn: ảnh quá dẹt (toàn cảnh 3:1) thì chịu cắt mép một chút.
    const at = photoId(slot);
    const vua = Math.max(minZoom(slot), containZoom(slot, image));
    const zoom = BUOC?.zoom ? nacXuong(vua, BUOC.zoom, minZoom(slot)) : vua;
    state.edits[at] = { ...(state.edits[at] ?? {}), zoom, pan_x: 0, pan_y: 0 };
    moveFileToForm(new File([blob], `ai-${r.style}.png`, { type: "image/png" }), info);
    syncAiInputs();
    syncSliders();
    draw();
  }

  /** Về ảnh gốc của slot, không gọi mạng. */
  async function revertPortrait(slot) {
    const chosen = originalFiles[slot];
    if (!chosen) return;
    delete state.ai[slot];
    // Về ảnh thô thì zoom không được dưới sàn thường - dưới 1× là ô ảnh thủng.
    const e = state.edits[photoId(slot)];
    if (e && (e.zoom ?? 1) < MIN_ZOOM) e.zoom = MIN_ZOOM;
    await nhanFile(chosen, slot, null);
  }

  /** Bấm một kiểu: "original" là quay về ảnh gốc (không gọi mạng), kiểu khác là gọi AI vẽ. */
  async function chonKieu(slot, key, tsMount) {
    if (dangVe[slot] || key === (state.ai[slot]?.style ?? "original")) return;
    if (key === "original") {
      delete tinVe[slot];
      await revertPortrait(slot);
      if (moDangMo === photoKey(slot)) openDrawer(photoKey(slot));
      return;
    }
    await veTranh(slot, key, tsMount);
  }

  /** Một lượt vẽ AI, từ ảnh gốc tới tranh nằm trong khung. Hai kiểu panel (hàng chip cũ, thẻ
   *  "Turn it into art") cùng gọi hàm này - thêm một bước chỉ phải thêm một chỗ. */
  async function veTranh(slot, key, tsMount) {
    const chosen = originalFiles[slot];
    if (!chosen) return;
    dangVe[slot] = { style: key, chang: "prep", tChang: performance.now(), max: 0 };
    const tVe = performance.now();
    suKien("sng_ai_start", { style: key });
    delete tinVe[slot];
    const sangChang = (chang) => {
      const v = dangVe[slot];
      if (v && v.chang !== chang) { v.chang = chang; v.tChang = performance.now(); }
      veTien();
    };
    batTien();
    lamMoiO();
    try {
      const image = await downscaleToBase64(chosen);
      const token = await turnstileToken(config.ai.turnstile_sitekey, tsMount);
      const r = await requestPortrait({ api: config.ai.api, image, style: key,
        product: config.ai.product ?? location.pathname.split("/products/")[1]?.split(/[/?#]/)[0],
        token, onStage: sangChang });
      sangChang("apply");
      // Khách đổi sang ảnh khác trong lúc chờ: tranh này là của ảnh cũ, đừng đè lên ảnh mới.
      if (originalFiles[slot] !== chosen) throw new Error("You changed the photo, so that painting was not used.");
      await applyPortrait(slot, { ...r, style: key });
      suKien("sng_ai_done", { style: key, ms: Math.round(performance.now() - tVe) });
      tinVe[slot] = { kind: "ok", at: Date.now(), text: PP?.art?.done_note ?? "Done! Drag or zoom the painting to fit the blanket." };
    } catch (e) {
      suKien("sng_ai_fail", { style: key, code: e.code || "loi", ms: Math.round(performance.now() - tVe) });
      tinVe[slot] = { kind: "loi", text: e.message || "AI is busy. Your photo is unchanged.",
        het: e.code === "limit" || e.code === "cap" };
    } finally {
      delete dangVe[slot];
    }
    // Chỉ dựng lại panel khi khách còn đang mở đúng ô này. Họ đã đóng ngăn kéo hay sang dòng khác
    // thì tranh vẫn lên chăn và ô ảnh vẫn đổi nhãn, nhưng đừng giật ngăn kéo về đây.
    if (moDangMo === photoKey(slot)) openDrawer(photoKey(slot));
    else veTien();
    refreshRows();
  }

  function batTien() {
    if (!tienTimer) tienTimer = setInterval(veTien, 200);
    veTien();
  }

  /** Vẽ trạng thái vẽ AI lên panel đang mở (nếu có): thanh tiến độ, câu báo, khoá nút.
   *  Đọc từ `dangVe`/`tinVe` chứ không giữ tham chiếu DOM, vì panel bị thay mỗi lần mở ngăn kéo. */
  function veTien() {
    const panel = ui.body.querySelector(".sng-art, .sng-ai");
    if (panel) {
      const slot = Number(panel.dataset.slot);
      const v = dangVe[slot];
      // Câu "Done!" chỉ để báo ngay lúc vẽ xong; mở lại ngăn kéo sau đó thì thôi nhắc.
      const tin = tinVe[slot]?.kind === "ok" && Date.now() - tinVe[slot].at > 8000 ? null : tinVe[slot];
      panel.classList.toggle("is-busy", !!v);
      // Hết lượt vẽ trong ngày thì thôi mời: thẻ AI đã khoá, nháy với "Recommended" là mời bấm vào
      // một nút không bấm được.
      panel.classList.toggle("is-moi", !v && !state.ai[slot] && !!photoUrls[slot] && !tin?.het);
      for (const b of panel.querySelectorAll("button[data-style]")) {
        b.disabled = !!v || (!!tin?.het && b.dataset.style !== "original");
      }
      const tien = panel.querySelector(".sng-art__tien");
      const so = panel.querySelector(".sng-art__so");
      const status = panel.querySelector(".sng-ai__status");
      if (v) {
        v.max = Math.max(v.max, aiPhanTram(v.chang, performance.now() - v.tChang));
        const pt = Math.floor(v.max);
        if (tien) {
          tien.hidden = false;
          tien.firstChild.style.width = `${v.max}%`;
          tien.setAttribute("aria-valuenow", String(pt));
        }
        if (so) so.textContent = `${pt}%`;
        const chu = AI_CHU_CHANG[v.chang] ?? AI_CHU_CHANG.gen;
        if (status && status.textContent !== chu) status.textContent = chu;
        if (status) { status.hidden = false; status.classList.remove("is-loi", "is-ok"); }
      } else {
        if (tien) {
          tien.hidden = tin?.kind !== "ok";
          tien.firstChild.style.width = "100%";
          tien.setAttribute("aria-valuenow", "100");
        }
        if (so) so.textContent = tin?.kind === "ok" ? "100%" : "";
        if (status) {
          status.hidden = !tin;
          status.textContent = tin?.text ?? "";
          status.classList.toggle("is-loi", tin?.kind === "loi");
          status.classList.toggle("is-ok", tin?.kind === "ok");
        }
      }
    }
    if (!Object.keys(dangVe).length && tienTimer) { clearInterval(tienTimer); tienTimer = 0; }
  }

  /** Hàng chip nhỏ - giao diện cũ, dùng khi cấu hình không khai `photo_panel.art`. */
  function aiPanel(slot) {
    const wrap = el("div", "sng-panel sng-ai");
    wrap.dataset.slot = String(slot);
    const status = el("p", "sng-ai__status");
    status.hidden = true;
    const chips = el("div", "sng-ai__chips");
    const tsMount = el("div", "sng-ai__turnstile");   // khai TRƯỚC vòng lặp: handler bên trong đóng lên nó
    const current = state.ai[slot]?.style ?? "original";
    const options = [["original", "Original"], ...aiStyles(config).map((s) => [s, AI_LABEL[s]])];
    for (const [key, label] of options) {
      const b = el("button", `sng-ai__chip${current === key ? " is-on" : ""}`, label);
      b.type = "button";
      b.dataset.style = key;
      b.addEventListener("click", () => chonKieu(slot, key, tsMount));
      chips.append(b);
    }
    wrap.append(chips, status, tsMount);
    return wrap;
  }

  /** Thẻ "Turn it into art" (`photo_panel.art`).
   *
   *  Thay hàng chip nhỏ vì khách lướt qua nó mà không biết đó chính là chỗ biến ảnh thành tranh -
   *  thứ sản phẩm này bán. Hai thẻ lớn có ảnh: "Original" là ảnh của chính khách, thẻ AI là tranh
   *  mẫu (vẽ xong thì thành tranh của khách). Chưa vẽ thì thẻ AI mang nhãn "Recommended" và nháy
   *  nhẹ vài nhịp. Lúc vẽ có thanh tiến độ theo chặng (`aiPhanTram`). */
  function artPanel(slot) {
    const art = PP.art;
    const current = state.ai[slot]?.style ?? "original";
    const wrap = el("div", "sng-panel sng-art");
    wrap.dataset.slot = String(slot);
    const dau = el("div", "sng-art__dau");
    dau.append(el("span", "sng-art__ten", art.title ?? "Turn it into art"));
    if (art.badge) dau.append(el("span", "sng-art__nhan", art.badge));
    wrap.append(dau);
    if (art.pitch) wrap.append(el("p", "sng-art__loi", art.pitch));

    const chon = el("div", "sng-art__chon");
    const tsMount = el("div", "sng-ai__turnstile");
    const options = [["original", "Original", art.original_note ?? "Your photo as it is"],
      ...aiStyles(config).map((s) => [s, AI_LABEL[s], art.ai_note ?? "Painted by AI"])];
    for (const [key, label, note] of options) {
      const laAi = key !== "original";
      const b = el("button", `sng-art__the${laAi ? " sng-art__the--ai" : ""}${current === key ? " is-on" : ""}`);
      b.type = "button";
      b.dataset.style = key;
      b.setAttribute("aria-pressed", String(current === key));
      const khung = el("span", "sng-art__khung");
      const nguon = !laAi ? anhGoc[slot]
        : state.ai[slot]?.style === key ? state.ai[slot].cutout_url : art.sample;
      if (nguon) {
        const hinh = el("img", "sng-art__hinh");
        hinh.src = nguon;
        hinh.alt = "";
        khung.append(hinh);
      }
      b.append(khung, el("span", "sng-art__nut", label),
        el("span", "sng-art__phu", current === key ? (art.selected_note ?? "Selected") : note));
      b.addEventListener("click", () => chonKieu(slot, key, tsMount));
      chon.append(b);
    }
    wrap.append(chon);

    const tien = el("div", "sng-art__tien");
    tien.setAttribute("role", "progressbar");
    tien.setAttribute("aria-label", "Painting progress");
    tien.setAttribute("aria-valuemin", "0");
    tien.setAttribute("aria-valuemax", "100");
    tien.append(el("i"));
    tien.hidden = true;
    const dong = el("div", "sng-art__dong");
    const status = el("p", "sng-ai__status");
    status.setAttribute("aria-live", "polite");
    status.hidden = true;
    dong.append(status, el("span", "sng-art__so"));
    wrap.append(tien, dong,
      el("p", "sng-art__meo", art.wait_note ?? "Usually 20–30 seconds. Please keep this page open."), tsMount);
    return wrap;
  }

  function photoPanel(slot) {
    const info = SLOTS.find((one) => one.slot === slot) ?? SLOTS[0];
    const daCo = !!photoUrls[slot];
    const wrap = el("div", "sng-panel");

    // Nút chọn ảnh đứng ĐẦU và to: đây là việc khách vào đây để làm, chín trên mười lần.
    // <label> bọc <input type=file> chứ không phải nút gọi click() - trên iOS cú click() do js
    // phát ra có lúc không được tính là thao tác người dùng nên thư viện không mở.
    const pick = el("label", "sng-pick", daCo ? "Replace photo" : "Choose photo");
    const file = el("input");
    file.type = "file";
    file.accept = "image/jpeg,image/png,image/webp";
    file.addEventListener("change", async () => {
      const chosen = file.files?.[0];
      if (!chosen) return;
      // Dựng lại chính tấm trượt này sau khi nhận được ảnh: lúc mở nó chưa có ảnh nên bốn thanh
      // và tông màu đang ẩn, không dựng lại thì khách phải đóng ra mở vào mới thấy.
      if (await nhanFile(chosen, slot, file)) openDrawer(photoKey(slot));
    });
    pick.prepend(file);
    wrap.append(pick);
    // Dòng gợi ý là lời khuyên CHỌN ảnh, nên chỉ cần lúc chưa có ảnh. Đã chọn rồi mà vẫn để đó
    // thì nó chỉ đẩy bốn thanh trượt xuống thấp thêm hai dòng.
    if (info.help && !daCo) wrap.append(el("p", "sng-help", info.help));
    // Chưa có ảnh thì không có gì để chỉnh - hiện bốn thanh trượt trống trơn chỉ tổ rối.
    if (!daCo) return wrap;

    // Có thẻ "Turn it into art" thì nó đứng NGAY dưới nút chọn ảnh, trên các thanh trượt: vẽ là
    // bước chính của sản phẩm, và vẽ xong bộ vẽ tự đặt lại zoom/vị trí cho vừa khung - chỉnh thanh
    // trượt trước khi vẽ là chỉnh công cốc.
    const theArt = aiEnabled(config) && PP?.art;
    if (theArt) wrap.append(artPanel(slot), el("hr", "sng-sep"));

    // Ba thanh này sửa `edits` của ô ảnh, đúng ba khoá mà bộ vẽ đọc. Không cho kéo cả hộp: hộp ô
    // ảnh khoá cứng vào viền tim, kéo rời là lộ mảng ảnh nằm ngoài viền.
    // Ba thanh này và thao tác kéo tay sửa CÙNG một chỗ (`edits` của ô ảnh). Giữ lại tham chiếu
    // để kéo xong thanh chạy theo - hai bộ điều khiển nói hai số khác nhau là khách hết tin cả hai.
    sliders = {};
    for (const [key, label, min, max, step] of [
      ["zoom", "Zoom", minZoom(slot), MAX_ZOOM, BUOC?.zoom ?? 0.01],
      ["pan_x", "Horizontal", -1, 1, BUOC?.pan ?? 0.005],
      ["pan_y", "Vertical", -1, 1, BUOC?.pan ?? 0.005],
      ["spin", "Rotate", -180, 180, BUOC?.spin ?? 1],
    ]) {
      const at = photoId(slot);
      const patch = state.edits[at] ?? (state.edits[at] = { zoom: 1, pan_x: 0, pan_y: 0 });
      // Lấy mặc định theo TỪNG khoá, đừng đọc thẳng `patch[key]`: gói `edits` chỉ được khởi tạo
      // với zoom/pan_x/pan_y, nên thanh Rotate đọc ra `undefined` và in ra chữ "undefined" ngay
      // trên trang bán hàng. Đúng công thức mà `syncSliders` đang dùng - hai chỗ phải nói một số.
      const value = patch[key] ?? (key === "zoom" ? 1 : 0);
      const row = el("label", `sng-slider${BUOC ? " sng-slider--nac" : ""}`);
      const out = el("i", "", hienSo(key, value));
      const range = el("input");
      range.type = "range";
      range.min = min; range.max = max; range.step = step; range.value = value;
      range.addEventListener("input", () => {
        patch[key] = Number(range.value);
        out.textContent = hienSo(key, patch[key]);
        draw();
      });
      // Có nấc thì đánh thêm vạch ở vài mốc chính (datalist): trình duyệt tự vẽ vạch dưới thanh và
      // hút núm về vạch khi kéo ngang qua.
      if (BUOC) {
        const moc = el("datalist");
        moc.id = `sng-nac-${key}-${slot}`;
        for (const v of mocChinh(key, min, max)) {
          const o = el("option");
          o.value = String(v);
          moc.append(o);
        }
        range.setAttribute("list", moc.id);
        row.append(moc);
      }
      // Nhãn - thanh - số trên CÙNG một dòng. Xếp thành hai dòng thì bốn thanh chiếm tám dòng,
      // đẩy lưới tông màu xuống dưới màn hình.
      row.append(el("span", "", label), range, out);
      wrap.append(row);
      sliders[key] = { range, out };
    }

    // Kéo/phóng quá phần dư của ảnh thì mép khung HỞ nền - preview nhỏ khó thấy nhưng ra tấm in là
    // một dải trống (đơn #1011, cả bốn ô). Không chặn tay khách, chỉ báo cho thấy để tự chỉnh lại.
    gapWarn = el("p", "sng-warn sng-warn--gap",
      "Part of this frame is empty and will print blank. Zoom in a little or move the photo back to fill the frame.");
    gapWarn.dataset.slot = String(slot);
    gapWarn.style.display = "none"; // style chứ không `hidden`: CSS .sng-warn có thể đè thuộc tính hidden
    wrap.append(gapWarn);
    requestAnimationFrame(capNhatHoMep);

    // Tông màu gom vào đây luôn, thay cho một dòng option riêng. Nó áp cho TẤT CẢ ô ảnh - sáu tấm
    // polaroid mỗi tấm một tông là hỏng bố cục, mà giỏ hàng cũng chỉ có đúng một ô để ghi. Phải
    // nói thẳng điều đó ra: đặt trong tấm trượt của ô số 3 mà đổi cả sáu ô thì không nói là khách
    // tưởng hỏng.
    if (aiEnabled(config) && !theArt) {
      wrap.append(el("hr", "sng-sep"));
      wrap.append(el("span", "sng-label", "Turn it into art"));
      wrap.append(aiPanel(slot));
    }

    if (ui.tiles && config.filter) {
      wrap.append(el("hr", "sng-sep"));
      // Tông là của RIÊNG ô này. Nhiều ô thì nói rõ ra, không thì khách đổi tông ở ô 3 rồi tưởng
      // cả sáu ô đổi theo và không đi chỉnh mấy ô kia nữa.
      const nhan = config.filter.label ?? "Photo tone";
      wrap.append(el("span", "sng-label", SLOTS.length > 1 ? `${nhan} · this photo only` : nhan));
      wrap.append(filterPanel(slot));
    }
    return wrap;
  }

  /** Kéo, phóng và xoay ảnh ngay trên khung xem.
   *
   *  Ba việc dùng CHUNG một máy: bấm vào tay nắm góc thì phóng, bấm vào tay nắm trên thì xoay,
   *  bấm vào giữa thì kéo. Tách ba máy riêng là ba chỗ phải nhớ bắt con trỏ, ba chỗ phải nhớ
   *  đồng bộ thanh trượt.
   *
   *  Quy hết về đơn vị mà bộ vẽ đọc: `pan` theo TỈ LỆ bề rộng/chiều cao hộp ảnh, nên kéo bao nhiêu
   *  pixel trên màn thì chia cho bề rộng khung xem. Nhờ vậy màn to màn nhỏ kéo một quãng như nhau
   *  trên tấm in. */
  function enableDrag() {
    const stage = ui.stage;
    // Đọc `activeSlot` mỗi lần gọi chứ không chụp một lần: hàm này gắn sự kiện đúng một lượt lúc
    // mount, mà ô đang chỉnh thì đổi theo ngăn kéo khách mở.
    const patch = () => {
      const at = photoId(activeSlot);
      return state.edits[at] ?? (state.edits[at] = { zoom: 1, pan_x: 0, pan_y: 0 });
    };
    const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
    let dragging = 0, fromX = 0, fromY = 0, baseX = 0, baseY = 0;

    stage.addEventListener("pointerdown", (event) => {
      // Nút kính lúp nằm TRÊN khung xem, nên cú bấm vào nó cũng rơi xuống đây. Không loại ra thì
      // bấm kính lúp là bắt đầu kéo ảnh, ảnh xê dịch một nhịp rồi khung to mới mở.
      if (event.target.closest(".sng-zoom")) return;
      if (!photoUrls[activeSlot] || event.button !== 0) return;
      dragging = event.pointerId;
      fromX = event.clientX; fromY = event.clientY;
      const p = patch();
      baseX = p.pan_x ?? 0; baseY = p.pan_y ?? 0;
      // Bắt con trỏ để kéo ra ngoài khung vẫn theo. Bọc try vì nó NÉM khi con trỏ đã nhấc lên
      // giữa chừng - ném ra là hỏng luôn cả nhánh kéo, mà bắt hụt thì cùng lắm là kéo ra ngoài
      // khung thì mất dấu.
      try { stage.setPointerCapture(event.pointerId); } catch {}
      stage.classList.add("is-dragging");
      event.preventDefault();
    });

    stage.addEventListener("pointermove", (event) => {
      if (dragging !== event.pointerId) return;
      const box = stage.getBoundingClientRect();
      const p = patch();
      p.pan_x = clamp(baseX + (event.clientX - fromX) / box.width, -1, 1);
      p.pan_y = clamp(baseY + (event.clientY - fromY) / box.height, -1, 1);
      syncSliders();
      drawFast();
    });

    for (const done of ["pointerup", "pointercancel"]) {
      stage.addEventListener(done, (event) => {
        if (dragging !== event.pointerId) return;
        dragging = 0;
        stage.classList.remove("is-dragging");
        // Nhấc tay mới dựng lại chăn thật, ảnh gửi giỏ và bản nháp. Làm mấy việc đó trong lúc kéo
        // là vừa phí vừa giật: bọc mockup hết cả trăm mili giây cho một khung hình sắp bị đè.
        draw();
      });
    }

    // Cuộn để phóng. `passive:false` vì có preventDefault - không khai thì trình duyệt bỏ qua và
    // trang cuộn thay vì ảnh phóng.
    stage.addEventListener("wheel", (event) => {
      if (!photoUrls[activeSlot]) return;
      event.preventDefault();
      const p = patch();
      p.zoom = clamp((p.zoom ?? 1) * (event.deltaY < 0 ? 1.06 : 1 / 1.06), minZoom(activeSlot), MAX_ZOOM);
      syncSliders();
      draw();
    }, { passive: false });
  }

  /** Vẽ lại NHANH trong lúc kéo: chỉ tấm phẳng, gộp về mỗi khung hình một lần.
   *
   *  Không bọc chăn thật, không dựng ảnh gửi giỏ, không lưu bản nháp - ba việc đó tính bằng trăm
   *  mili giây và khung hình nào cũng sắp bị đè ngay sau đó. Nhấc tay mới làm, một lần.
   *
   *  Gộp về khung hình vì chuột gửi sự kiện dày hơn màn hình vẽ được: không gộp thì mỗi khung
   *  hình vẽ lại canvas 2400×3250 vài lần, phí sạch. */
  function drawFast() {
    if (!spec || paintPending) return;
    paintPending = true;
    requestAnimationFrame(() => {
      paintPending = false;
      renderSnuggle(ui.ctx, spec, state, assets);
      paintGhost();
      capNhatHoMep();
    });
  }

  /** Giữ lại chữ khách đã gõ, để lỡ bấm back hay tải lại trang thì không phải làm lại từ đầu.
   *
   *  KHÔNG giữ ảnh: một tấm ảnh điện thoại đã vượt hạn mức ~5MB của localStorage, mà ghi tràn hạn
   *  mức thì nó ném và làm hỏng luôn mọi thứ khác đang lưu cùng tên miền. Khách vẫn phải chọn lại
   *  ảnh - nhưng gõ lại năm dòng chữ mới là phần khiến người ta bỏ đi.
   *
   *  Bọc try cho MỌI lần đụng tới localStorage: Safari ở chế độ riêng tư ném ngay lúc ghi, và
   *  ném ở đây là chết cả bộ dựng chỉ vì một tiện ích phụ. */
  function scheduleDraft() {
    clearTimeout(draftTimer);
    draftTimer = setTimeout(saveDraft, 400);
  }

  function saveDraft() {
    // Giống hệt mặc định thì xoá hẳn, đừng lưu. Không có nhánh này thì bấm "Start over" xong
    // `draw()` lưu đè lại ngay, bản nháp không bao giờ mất.
    const doiKhacMacDinh = (spec.fields ?? []).some((f) => (state.fields[f.id] ?? "") !== (f.default ?? ""));
    const daChinhAnh = SLOTS.some((one) => {
      const a = state.edits[photoId(one.slot)] ?? {};
      return (a.zoom ?? 1) !== 1 || (a.pan_x ?? 0) !== 0 || (a.pan_y ?? 0) !== 0 || (a.spin ?? 0) !== 0
        || (a.filter ?? "none") !== "none";
    });
    const doiNen = !!state.background && state.background !== (config.background?.default ?? config.backgrounds?.[0]?.key);
    if (!doiKhacMacDinh && !daChinhAnh && !doiNen) return forgetDraft();
    try {
      localStorage.setItem(`${DRAFT_KEY}:${spec.id}`, JSON.stringify({
        at: Date.now(),
        fields: state.fields,
        background: state.background,
        // KHÔNG đè `filter` chung nữa: mỗi ô giữ tông của chính nó, và nó đã nằm sẵn trong `edits`.
        edits: Object.fromEntries(SLOTS.map((one) =>
          [photoId(one.slot), { ...state.edits[photoId(one.slot)] }])),
      }));
    } catch {}
  }

  /** Đọc bản nháp cũ. Quá hạn thì bỏ - quay lại sau vài tháng mà thấy tên thú cưng cũ nằm sẵn
   *  trên chăn thì đáng sợ hơn là tiện. */
  function restoreDraft() {
    let draft;
    try { draft = JSON.parse(localStorage.getItem(`${DRAFT_KEY}:${spec.id}`) || "null"); } catch {}
    if (!draft?.fields) return;
    if (!(Date.now() - (draft.at ?? 0) < DRAFT_DAYS * 86400000)) { forgetDraft(); return; }
    // Chỉ nhận những ô mà spec HIỆN TẠI còn khai. Đổi layout rồi mà đổ bừa vào là chữ chui vào ô
    // không còn tồn tại, im lặng đi thẳng vào đơn hàng.
    let count = 0;
    for (const field of spec.fields ?? []) {
      const value = draft.fields[field.id];
      // Chữ trong bản nháp khác chữ mặc định là chữ khách đã gõ - không còn là chữ mẫu.
      if (typeof value === "string" && value !== state.fields[field.id]) { state.fields[field.id] = value; daGo.add(field.id); count++; }
    }
    for (const one of SLOTS) {
      const cu = draft.edits?.[photoId(one.slot)];
      if (!cu) continue;
      // Bản nháp cũ có thể còn zoom dưới 1× từ lúc chưa có luật này - kéo lên, không thì khách
      // quay lại là thấy ô ảnh thủng mà chẳng hiểu vì sao.
      state.edits[photoId(one.slot)] = { ...cu, zoom: Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, cu.zoom ?? 1)), ...(config.filter ? {} : { filter: "none" }) };
    }
    // Chỉ nhận bộ nền mà cấu hình HIỆN TẠI còn khai - đổi bảng màu rồi mà đổ bừa vào là bộ vẽ
    // rơi về bộ đầu, còn giỏ hàng lại ghi tên bộ đã bỏ.
    if ((config.backgrounds ?? []).some((one) => one.key === draft.background)) state.background = draft.background;
    // Hàng tóm tắt dựng từ lúc `build()` nên nó đang mang chữ MẶC ĐỊNH. Không vẽ lại thì chăn
    // hiện chữ cũ mà danh sách bên cạnh nói chữ mặc định - khách không biết tin cái nào.
    refreshRows();
    if (count) showDraftNote();
  }

  function forgetDraft() {
    try { localStorage.removeItem(`${DRAFT_KEY}:${spec.id}`); } catch {}
  }

  /** Nói cho khách biết chữ trên chăn là của lần trước, kèm nút quay về mặc định. Đổ chữ cũ vào
   *  mà không nói thì khách không nhớ mình đã gõ, tưởng trang hỏng. */
  function showDraftNote() {
    ui.note.hidden = false;
    ui.noteReset.onclick = (event) => {
      event.preventDefault();
      for (const field of spec.fields ?? []) state.fields[field.id] = field.default ?? "";
      daGo.clear();
      for (const one of SLOTS) {
        state.edits[photoId(one.slot)] = { ...state.edits[photoId(one.slot)], zoom: 1, pan_x: 0, pan_y: 0, spin: 0, filter: "none" };
      }
      state.background = config.background?.default ?? config.backgrounds?.[0]?.key ?? "";
      forgetDraft();
      ui.note.hidden = true;
      syncInputs();
      if (root.classList.contains("is-open")) closeDrawer();
      if (HIEN_HET) for (const k of mucBuoc.keys()) dungMuc(k);
      draw();
      refreshRows();
    };
  }

  /** Ảnh của ô `slot` có để HỞ khung không - cùng công thức drawPhoto (phủ kín hộp × zoom, căn
   *  giữa, cộng pan × cỡ hộp). Ảnh xoay thì bỏ qua (hộp bao đã phủ rộng hơn, tính xấp xỉ dễ báo oan). */
  function hoMep(slot) {
    const e = spec?.elements.find((x) => x.type === "photo_slot" && x.index === slot);
    const photo = assets[state.photos?.[slot]];
    if (!e || !photo?.naturalWidth) return false;
    const p = state.edits[photoId(slot)] ?? {};
    if ((p.spin ?? 0) % 360) return false;
    const [W, H] = spec.design_size;
    const bw = e.box.w * W, bh = e.box.h * H;
    const cover = Math.max(bw / photo.naturalWidth, bh / photo.naturalHeight) * (p.zoom ?? 1);
    const du = (photo.naturalWidth * cover - bw) / 2, dv = (photo.naturalHeight * cover - bh) / 2;
    const TOL = 2; // px tờ in - lệch nhỏ hơn nét viền khung thì không đáng báo
    return Math.abs((p.pan_x ?? 0) * bw) > du + TOL || Math.abs((p.pan_y ?? 0) * bh) > dv + TOL;
  }

  function capNhatHoMep() {
    if (gapWarn?.isConnected) gapWarn.style.display = hoMep(Number(gapWarn.dataset.slot)) ? "" : "none";
  }

  /** Kéo tay xong thì ba thanh trượt phải chỉ đúng số mới. */
  function syncSliders() {
    const p = state.edits[photoId(activeSlot)] ?? {};
    for (const [key, ui2] of Object.entries(sliders)) {
      if (!ui2?.range?.isConnected) continue;
      const value = p[key] ?? (key === "zoom" ? 1 : 0);
      ui2.range.value = value;
      ui2.out.textContent = hienSo(key, value);
    }
  }

  /** Số hiện cạnh thanh trượt. Có nấc (`photo_panel.steps`) thì in theo đơn vị khách đọc được:
   *  zoom "1.2×", dịch theo phần trăm bề ngang/cao khung, xoay theo độ. Không nấc thì giữ lối cũ.
   *  Kéo tay trên khung xem thì số lẻ vẫn có (kéo mượt), nên phải làm tròn ở đây. */
  function hienSo(key, v) {
    if (!BUOC) return String(Math.round(v * 1000) / 1000);
    if (key === "zoom") return `${v.toFixed(1)}×`;
    if (key === "spin") return `${Math.round(v)}°`;
    return String(Math.round(v * 100));
  }

  /** Mấy mốc chính để đánh vạch trên thanh có nấc: sàn và mỗi 0.5× của zoom, mỗi nửa khung của
   *  hai thanh dịch, mỗi 90° của thanh xoay. Vạch ở MỌI nấc thì 27 vạch trên thanh 190px, dày đặc. */
  function mocChinh(key, min, max) {
    const buoc = key === "zoom" ? 0.5 : key === "spin" ? 90 : 0.5;
    const ra = new Set([min, max]);
    for (let v = Math.ceil(min / buoc) * buoc; v <= max + 1e-9; v += buoc) ra.add(Math.round(v * 1000) / 1000);
    return [...ra].sort((a, b) => a - b);
  }

  // ── Ảnh khách: nén + tải ngầm (config.photo_upload, ve/snuggle-anh.mjs) ──────────────────────
  /** Sau khi ảnh đã lên chăn: nén về đúng số điểm ảnh cần in rồi thay file trong form; có `api` thì
   *  tải lên luôn, xong thì form gửi LINK thay cho byte ảnh. Chạy nền - khách chỉnh ảnh tiếp như thường. */
  async function xuLyAnhVao(chosen, image, slot, info) {
    if (!PU) return;
    boTaiNgam(slot, info);
    const t = taiNgam[slot] = { trangThai: "nen", pt: 0 };
    let file = chosen;
    const e = spec?.elements?.find((x) => x.type === "photo_slot" && (x.index ?? 1) === slot);
    const co = e?.box ? coCanIn(e.box, spec.design_size, image.naturalWidth, image.naturalHeight, PU.dpi ?? 150) : null;
    const nen = await nenAnh(image, chosen, co);
    if (taiNgam[slot] !== t || originalFiles[slot] !== chosen) return;   // khách đã đổi ảnh trong lúc nén
    if (nen) { file = nen; moveFileToForm(nen, info); }
    // Chăn có AI thì ảnh trong form có thể bị tranh vẽ thay bất cứ lúc nào - không tải ngầm ảnh gốc.
    if (!PU.api || aiEnabled(config)) { delete taiNgam[slot]; veNutCho(); return; }
    t.trangThai = "dang";
    const product = PU.product ?? location.pathname.split("/products/")[1]?.split(/[/?#]/)[0] ?? "";
    const viec = taiLenNgam(PU.api, file, { product, slot, onTienDo: (x) => { t.pt = x; veNutCho(); } });
    t.huy = viec.huy;
    try {
      const url = await viec.lenh;
      if (taiNgam[slot] !== t) return;
      t.trangThai = "xong"; t.url = url; t.pt = 1;
      datLinkVaoForm(info, url);
    } catch (err) {
      if (err?.huy || taiNgam[slot] !== t) return;
      // File (đã nén) vẫn nằm trong form: bấm mua là gửi file như cách cũ, chỉ chậm hơn.
      t.trangThai = "loi";
    }
    veNutCho();
  }

  /** Ô file tắt thì không đi vào FormData - form không gửi lại byte ảnh. Link nằm ở một ô ẩn CÙNG TÊN
   *  property, nên giỏ hàng và đơn vẫn có đúng dòng "Pet Photo 1" như cũ, chỉ giá trị là link. */
  function datLinkVaoForm(info, url) {
    const oFile = form.querySelector(`input[type=file][name="${cssEscape(`properties[${info.property}]`)}"]`);
    if (oFile) oFile.disabled = true;
    const oLink = oLinkCua(info.property);
    oLink.value = url;
    oLink.disabled = false;
  }

  /** Bỏ lượt tải ngầm cũ của ô (khách chọn ảnh khác): huỷ, bật lại ô file, xoá link. */
  function boTaiNgam(slot, info) {
    taiNgam[slot]?.huy?.();
    delete taiNgam[slot];
    const oFile = form.querySelector(`input[type=file][name="${cssEscape(`properties[${info.property}]`)}"]`);
    if (oFile) oFile.disabled = false;
    const oLink = form.querySelector(`input[data-sng-link="${cssEscape(info.property)}"]`);
    if (oLink) { oLink.value = ""; oLink.disabled = true; }
  }

  function oLinkCua(property) {
    let o = form.querySelector(`input[data-sng-link="${cssEscape(property)}"]`);
    if (!o) {
      o = document.createElement("input");
      o.type = "hidden";
      o.name = `properties[${property}]`;
      o.dataset.sngLink = property;
      form.appendChild(o);
    }
    return o;
  }

  function dangXuLyAnh() {
    return Object.values(taiNgam).some((t) => t.trangThai === "nen" || t.trangThai === "dang");
  }

  /** Khách bấm mua khi ảnh còn đang nén/tải: giữ lại, hiện tiến độ ngay trên nút, xong thì tự gửi.
   *  Quá 90 s thì thôi chờ: huỷ các lượt còn dở, form gửi file như cách cũ. */
  function choTaiXong(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (choMua) return;
    const nut = form.querySelector('[type="submit"]');
    choMua = { nut, html: nut?.innerHTML ?? "", hen: setTimeout(() => {
      for (const t of Object.values(taiNgam)) {
        if (t.trangThai === "nen" || t.trangThai === "dang") { t.huy?.(); t.trangThai = "loi"; }
      }
      veNutCho();
    }, 90000) };
    if (nut) nut.disabled = true;
    veNutCho();
  }

  /** Vẽ lại nút mua đang chờ; hết việc thì trả nút về như cũ rồi gửi lại đơn. */
  function veNutCho() {
    if (!choMua) return;
    const { nut } = choMua;
    if (!dangXuLyAnh()) {
      clearTimeout(choMua.hen);
      if (nut) { nut.innerHTML = choMua.html; nut.disabled = false; }
      choMua = null;
      form.querySelector('[type="submit"]')?.click();
      return;
    }
    const coAnh = SLOTS.filter((one) => photoUrls[one.slot]);
    const xong = coAnh.filter((one) => { const t = taiNgam[one.slot]; return !t || t.trangThai === "xong" || t.trangThai === "loi"; }).length;
    const dang = Object.values(taiNgam).filter((t) => t.trangThai === "dang");
    const pt = dang.length ? Math.round((dang.reduce((s, t) => s + (t.pt ?? 0), 0) / dang.length) * 100) : 0;
    if (nut) nut.textContent = `Uploading photos ${xong}/${coAnh.length}${pt ? ` · ${pt}%` : ""}…`;
  }

  /** Đưa file khách chọn vào ô upload thật của form, để Shopify nhận đúng file gốc. */
  function moveFileToForm(chosen, info) {
    const target = form.querySelector(`input[type=file][name="${cssEscape(`properties[${info.property}]`)}"]`);
    if (!target || typeof DataTransfer !== "function") return;
    const data = new DataTransfer();
    data.items.add(chosen);
    target.files = data.files;
  }
}

// ── dựng khung ───────────────────────────────────────────────────────────────
function build(root, config) {
  // Hai khung chồng nhau: tấm thiết kế phẳng vẽ trước và hiện ngay, chăn thật đè lên khi bộ bản
  // đồ warp nạp xong. Giữ cả hai chứ không thay thế - tấm phẳng còn dùng để dựng ảnh gửi giỏ hàng.
  const stage = el("div", "sng-stage");
  const canvas = el("canvas", "sng-canvas");
  const mockup = el("canvas", "sng-mockup");
  // Lớp gợi ý: phần ảnh thò ra NGOÀI trái tim, hiện mờ. Chỉ bật lúc đang chỉnh ảnh.
  const ghost = el("canvas", "sng-ghost");
  // Nút kính lúp góc trên phải khung xem. Khung xem trên trang sản phẩm chỉ rộng chừng 300px, mà
  // chữ trên chăn in ra to bằng bàn tay - không soi to được thì khách gõ xong chẳng biết mình gõ
  // có tràn khung, có dính vào hoạ tiết hay không.
  const zoom = el("button", "sng-zoom");
  zoom.type = "button";
  zoom.setAttribute("aria-label", "View larger");
  zoom.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"></path></svg>';
  stage.append(canvas, ghost, mockup, zoom);

  // Khung xem to gắn thẳng vào BODY, không gắn trong bộ dựng: nằm trong thì nó bị cắt theo
  // `overflow` của mấy khối bọc ngoài của theme, và bị đè bởi thanh mua dính ở đáy trang.
  const lightbox = el("div", "sng-lightbox");
  lightbox.hidden = true;
  const lightImg = el("img", "sng-lightbox__img");
  lightImg.alt = "";
  const lightClose = el("button", "sng-lightbox__close", "\u00d7");
  lightClose.type = "button";
  lightClose.setAttribute("aria-label", "Close");
  lightbox.append(lightImg, lightClose);
  document.body.append(lightbox);

  const slots = photoSlots(config);
  // MỌI layout đều dùng lưới ô, kể cả layout chỉ có một ô ảnh.
  //
  // Ban đầu chỉ layout nhiều ô mới dùng lưới, layout một ô giữ dòng option cũ. Nhưng ba sản phẩm
  // Snuggle bán cạnh nhau mà bộ cá nhân hoá khác nhau thì khách mua cái thứ hai phải học lại từ
  // đầu - và mỗi lần sửa giao diện là phải nhớ sửa hai nhánh, mà nhánh một-ô thì chẳng ai chạy
  // lại để phát hiện hỏng.
  //
  // Một ô thì lưới rút về MỘT ô rộng bằng cột, hình chữ nhật nằm ngang - đúng dáng một chỗ thả
  // ảnh, không phải một ô vuông bé tí lạc lõng giữa hai cột trống.
  const rows = el("div", "sng-rows");
  let photos = null, tiles = null, count = null;
  {
    photos = el("div", `sng-photos${slots.length === 1 ? " sng-photos--mot" : ""}`);
    const head = el("div", "sng-photos__head");
    count = el("span", "sng-photos__count", `0/${slots.length} added`);
    head.append(el("span", "sng-photos__title", slots.length === 1 ? "Your photo" : "Your photos"), count);
    const grid = el("div", "sng-photos__grid");
    tiles = new Map();
    for (const one of slots) {
      // Ô chỉ là một cái NÚT: chạm vào là mở tấm trượt của đúng ô đó, và mọi thứ liên quan tới nó
      // nằm trong đấy - chọn ảnh, phóng, dịch, xoay, tông màu.
      //
      // Đã thử cho <input type=file> nằm ngay trong ô để chạm một cái là mở thư viện. Nhanh hơn
      // một nhịp thật, nhưng rồi mỗi ô lại phải mọc thêm một nút "Adjust" con để vào chỗ chỉnh -
      // hai vùng chạm trong một ô 74px là quá nhỏ, và ô ảnh trông không còn ra cái nút nữa.
      const node = el("button", "sng-tile");
      node.type = "button";
      node.dataset.slot = String(one.slot);
      const img = el("img", "sng-tile__img");
      img.hidden = true;
      img.alt = "";
      node.append(img, el("span", "sng-tile__num", String(one.slot)),
        el("span", "sng-tile__plus", "+"), el("span", "sng-tile__spot", cho(one)));
      grid.append(node);
      tiles.set(one.slot, { node, img });
    }
    photos.append(head, grid, el("p", "sng-photos__help",
      config.photos_help ?? "Tap a frame to add its photo, then zoom, move or rotate it."));
    rows.append(photos);
  }
  // Có lưới ô thì tông màu nằm TRONG tấm trượt của từng ô, không mọc thêm một dòng riêng ở đây.
  if (config.filter && !tiles) {
    rows.append(row("__filter", config.filter.label ?? "Photo tone", config.filter.default_label ?? "Original"));
  }
  // Dòng chọn nền đặt NGAY SAU ảnh: nó đổi cả tấm chăn nên khách phải thấy sớm, trước khi ngồi
  // gõ năm dòng chữ rồi mới phát hiện còn chọn được nền khác.
  if (config.background) {
    const mac = config.background.default ?? config.backgrounds?.[0]?.key;
    rows.append(row(BG_KEY, config.background.label ?? "Background",
      (config.backgrounds ?? []).find((one) => one.key === mac)?.en ?? "—"));
  }
  for (const item of optionRows(config)) rows.append(row(item.key, item.label, item.fields.map((f) => f.default ?? "—").join(" · ")));

  const side = el("div", "sng-side");
  // Chặn mua mà không nói gì thì khách bấm lại lần nữa rồi bỏ đi. Ô này hiện đúng lúc bị chặn.
  const warn = el("p", "sng-warn", config.photo_panel?.missing_photo ?? WARN_MISSING);
  warn.hidden = true;
  // Báo khi chữ được lấy lại từ lần trước, kèm nút quay về mặc định.
  const note = el("p", "sng-note");
  const noteReset = el("button", "sng-note__reset", "Start over");
  noteReset.type = "button";
  note.append(document.createTextNode("We kept the words you typed last time. "), noteReset);
  note.hidden = true;
  side.append(el("span", "sng-side__title", "Personalize"), warn, note, rows);

  const scrim = el("div", "sng-scrim");
  const drawer = el("div", "sng-drawer");
  const head = el("div", "sng-drawer__head");
  const title = el("span", "sng-drawer__title");
  const close = el("button", "sng-drawer__close", "Done");
  close.type = "button";
  const body = el("div", "sng-drawer__body");
  head.append(title, close);
  drawer.append(head, body);

  // Tấm trượt nằm TRONG khung của cột option chứ không trong khung của cả bộ. Nhờ vậy hai cột
  // hay một cột đều không phải tính lại toạ độ: nó phủ đúng cột option, canvas luôn nhìn thấy.
  const panels = el("div", "sng-panels");
  panels.append(side, scrim, drawer);
  root.append(stage, panels);
  return { stage, canvas, mockup, ghost, ctx: canvas.getContext("2d"), rows, warn, note, noteReset,
    scrim, drawer, title, close, body, photos, tiles, count, zoom, lightbox, lightImg, lightClose };
}

/** Chữ nhỏ dưới mỗi ô: chỗ nó nằm trên chăn ("top left"). Cấu hình cũ gộp cả hai vào `label`
 *  ("Photo 1 · top left") nên tách ra ở đây - khai riêng `spot` thì lấy thẳng. */
function cho(one) {
  if (one.spot) return one.spot;
  const at = String(one.label ?? "").split("·");
  return (at[1] ?? at[0] ?? "").trim();
}

function row(key, label, value) {
  const item = el("button", "sng-row");
  item.type = "button";
  item.dataset.key = key;
  item.append(el("span", "sng-row__label", label), el("span", "sng-row__value", value), el("i", "sng-row__go", "›"));
  return item;
}

function el(tag, className = "", text = "") {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text) node.textContent = text;
  return node;
}

function loadImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`không nạp được ${url}`));
    image.src = url;
  });
}

/** Tên ô nhập có dấu ngoặc vuông; querySelector cần được thoát trước. */
function cssEscape(value) {
  return typeof CSS?.escape === "function" ? CSS.escape(value) : value.replace(/([[\]])/g, "\\$1");
}

window.mountSnuggleEmbed = mountSnuggleEmbed;
})();
